/*
 * @Author: 赵泽文
 * @Date: 2023-01-22 16:10:40
 * @LastEditors: 王仁涛 wangrt@cnlemon.net
 * @LastEditTime: 2026-03-11 11:09:55
 * @Description: 英文语言包
 */

const currency_suffix = ''; // 金额后缀，例如 30 dollars

const transform = {
  收入科目: 'Income Subject',
  保存查询条件: 'Save filter conditions',
  裱花间: 'Cake decorator',
  裱花间设备: 'Cake decorator device',
};
export const en = {
  ...transform,
  development_env: 'Development environment',
  production_env: 'Production environment',
  commodity: 'Commodity',
  product_limit: 'Product limit',
  product_tag: 'Product tag',
  product_tag_placeholder:
    'Please enter the product tag, used for the activity classification display in the mini program',
  product: 'Goods',
  filter_invalid_product: 'Invalid goods filtered',
  add_product: 'Please add goods',
  operate_will_clean_product:
    'Changing this information will clear the selected product data. Confirm the change?',
  import_product_will_clean_current_product:
    'There are commodity details in the current documents, and importing will clear the existing commodities. Confirm the import?',

  money_symbol: currency_suffix,
  year: 'Year',
  month: 'Month',
  day: 'Day',
  days: 'Day',
  hour: 'Hour',
  minute: 'Minute',
  second: 'Second',
  number_type: 'Number',

  business_day: 'Business day',
  placed_order: 'Placed order',
  not_place_order: 'Not place order',
  save_success: 'Save successfully',
  audit_success: 'Successful audit',
  edit_success: 'Update successfully',
  confirm_audit_is: 'Confirm approval?',
  del_success: 'Deleted successfully',
  pass_success: 'Pass success',
  refuse_success: 'Reject success',
  setting_success: 'Successful setting',
  please_check_data: 'Please query the data first',
  please_select_delete_order: 'Please select the order you want to delete',
  please_select_print_order: 'Please select the order you want to print',
  please_select_re_audit_order: 'Please check the documents that need to be re-audited',
  create_transfer_in_out_order: 'Generating transfer out orders',
  transerOutOrder_audit_success:
    'Batch review submission successful. Please go to the task center to view the results',
  save_and_audit: 'Save and Review',
  save_success_and_audit_is:
    'Whether the documents are saved successfully and audited immediately？',
  order_del_confirm_is: 'Confirm to delete the selected document?',
  invalid_confirm_is_with_order_no:
    'If it cannot be recovered after being cancelled, confirm invalid document[{{orderNo}}]？',
  whether_to_return_the_document: 'Whether to return the document[{{orderNo}}]?',
  cancel_relate_product_will_clean:
    'After canceling the associated order, the selected goods will be cleared out. Are you sure to cancel the associated order?',
  request_order_not_in_list: 'This order does not have a list of documents, please re-select',
  audit_auto_create_transfer_in_order_confirm_is:
    'Confirm approval? Store transfer order will be generated automatically after approval.',
  relate_request_order_will_clean_product_confirm_is:
    '{{alertTxt}} associate order with selected items will be cleared, confirm {{alertTxt}} associate?',
  please_choose_apply_location_first: 'Please select the application store first',
  cancel_relate_transfer_in_order_product_will_clean:
    'Cancel the association after the transfer order, the selected goods will be cleared. Do you want to cancel the association?',
  transfer_in_order_not_in_list:
    'There is no list of bills for this transfer order. Please select again',
  relate_transfer_in_order_will_clean_product_confirm_is:
    '{{alertTxt}}关联调入单后已选择商品将会被清空，确认{{alertTxt}}关联吗？',
  inner_order_pass_confirm_is: 'Confirm the internal application form is approved？',
  inner_order_agree_confirm_is: 'Confirm agreement to the internal application form？',
  inner_order_agree_confirm_is_order_no:
    'Confirm agreement to the internal application form[{{orderNo}}]?',
  audit_auto_create_transfer_in_out_order:
    'Approval of inventory changes by automatically generating transfer orders and transfer orders.',
  agree_auto_create_transfer_in_out_order:
    'After approval, transfer out and transfer in orders will be automatically generated, and inventory will change.',
  inner_order_refuse_confirm_is: 'Confirm refusal of application?',
  inner_order_refuse_confirm_is_order_no: 'Confirm refusal of application[{{orderNo}}]？',
  suggest_link_apply_location:
    'It is suggested to make a decision after communicating with the applying store.',
  filter_product_batch_setting_confirm_is:
    'Are you sure to batch set the properties of filtered items?',
  batch_setting_product_not_fund: 'Item with batch setting not found',
  cancel_relate_purchase_order_product_will_clean:
    'After canceling the associated purchase order, the selected goods will be cleared. Are you sure to cancel the association?',
  purchase_order_not_in_list: 'No list of bills exists for this purchase order, please re-select',
  relate_purchase_order_will_clean_product_confirm_is:
    '{{alertTxt}} associate purchase order with selected items will be cleared. Confirm {{alertTxt}} associate?',
  cancel_relate_purchase_receive_order_product_will_clean:
    'The selected goods will be cleared after the receipt of the associated purchase is cancelled. Are you sure to cancel the associated purchase?',
  purchase_receive_order_not_in_list:
    'The purchase receipt does not have a list of documents, please re-select',
  relate_purchase_receive_order_will_clean_product_confirm_is:
    '{{alertTxt}} associate purchase selected items will be cleared after receiving the invoice. Confirm {{alertTxt}} associate?',
  del_choose_supplier_confirm_is: 'Are you sure to delete the selected vendor?',
  del_reason_confirm_is: 'Are you sure to delete the cause?',
  change_query_will_clean_product:
    'Modifying the filter conditions will clear the product details. Confirm the modification?',
  check_order_snapshot_confirm_is:
    'Using the inventory snapshot, the system will record the current inventory and compare the data after the inventory check with the inventory snapshot. Cannot continue to add goods after snapshot. Are you sure to use inventory snapshot?',
  current_page_un_save_leave_confirm_is:
    'The contents not saved on the current page will be lost. Are you sure to leave?',
  update_location_success: 'Successful store switching',
  have_common_product_can_not_change_gift:
    'If the same goods already exist, it is forbidden to change the gift mark again',
  store_account_balance_insufficient:
    'The store is account balance is insufficient, and the review cannot be successful. The store can go to the APP to recharge the account.',

  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  audit: 'Audit',
  re_audit: 'Counter audit',
  re_audit_success: 'Counter audit success',
  modify: 'Modify',
  edit: 'Edit',
  copy: 'Copy',
  print: 'print',
  batch_print: 'Batch print',
  partake: 'Share',
  create: 'Create',
  create_success: 'Create success',
  read: 'Read',
  del: 'Delete',
  delete_fail: 'Delete failed',
  pass: 'Pass',
  refuse: 'Refuse',
  refuse_person: 'Refuse person',
  refuse_time: 'Refuse time',
  export_excel: 'Export',
  invalid: 'Cancellation',
  return: 'Return',
  return_success: 'Return success',
  agree: 'Agree',
  agree_time: 'Agree time',
  agree_person: 'Agree person',
  add_product_btn: 'Add goods',
  batch_setting: 'Batch setting',
  import_file: 'Import',
  setting: 'Set',
  close: 'Close',
  audit_pass: 'Be approved',
  upload: 'Upload',
  new_add: 'Add',
  query: 'Query',
  return_btn: 'Return',
  business_date: 'Business date',
  variance_rate: 'Variance rate',

  stock_item_search: 'Stock item search',
  export_stock_item_search: 'Export stock item search',
  inventory_list: 'Stock Item List',
  inventory_dimension: '({{dimension}} dimension)',
  greater_than: 'Greater than',
  less_than: 'Less than',
  equal_than: 'Equal to',
  not_equal_than: 'Not equal to',
  please_select_comparison: 'Please select a comparison method',
  detail: 'Detail',
  single: 'Single product',
  cross_product: 'Cross product',
  cross_product_tip:
    'If you select a single product, only when you buy M pieces of a single specification of the product, you can enjoy the discount. Click cross-product, when the total number of participating products reaches M pieces, the discount is enjoyed',
  collect: 'Collect',
  select: 'Select',
  filter: 'Filter',
  display: 'Display',
  please_select: 'Please select',
  negative_stock: 'Negative stock',
  zero_stock: 'Zero stock',
  negative_amount: 'Negative amount',
  early_warning_state: 'Early warning state',
  above_maximum_inventory: 'Above maximum inventory',
  below_maximum_inventory: 'Below minimum inventory',
  latest_delivery_date: 'Latest delivery date',
  time_frame: 'Time frame',
  next_step: 'Next Step',
  previous_step: 'Previous Step',
  payment_status: 'Payment status',
  unpaid: 'Unpaid',
  paid: 'Paid',
  warehouse_allocation: 'Warehouse allocation',

  exp_collect: 'Validity summary',
  exp_board: 'Validity board',
  storage_condition: 'Storage condition',
  exp_product: 'Validity product',
  create_exp_product: 'Create validity product',
  edit_exp_product: 'Edit validity product',
  exp_product_import: 'Validity product import',
  exp_product_import_template: 'Validity product import template',

  distribution_settlement: 'Distribution settlement',
  create_distribution_settlement: 'Create distribution settlement document',
  edit_distribution_settlement: 'Edit distribution settlement document',
  read_distribution_settlement: 'Read distribution settlement document',
  settlement_date: 'Settlement date',
  settlement_money: 'Settlement Amount',
  settlemented_money: 'Settlemented Amount',
  unsettled_money: 'Unsettled amount',
  discount_amount: 'Discount amount',
  discounted_amount: 'Discounted amount',
  receivables_amount: 'Receivables Amount',
  collected_amount: 'Collected Amount',
  outstanding_amount: 'Outstanding Amount',
  payable_amount: 'Payable Amount',
  paid_amount: 'Paid Amount',
  unpaid_amount: 'Unpaid Amount',
  settlement_amount_for_this_instance: 'Settlement Amount for This Instance',
  payment_date: 'Payment Date',
  payment_type: 'Payment method',
  agreed_payment_date: 'Agreed Payment Date',
  re_audit_confirm_is: 'Do you want to reverse the audit of the selected documents?',
  delete_distribution_settlement_document: 'Delete distribution settlement document [{{orderNo}}]',
  create_distribution_settlement_document: 'Create distribution settlement document [{{orderNo}}]',
  re_audit_distribution_settlement_document:
    'Reverse audit distribution settlement document [{{orderNo}}]',
  location_dealings: 'Store Intercompany Transactions',
  supplier_dealings: 'Supplier Intercompany Transactions',
  prepayment_amount: 'Prepayment amount',
  cost_project: 'Cost item',
  save_cost_project: 'Add Cost item',
  edit_cost_project: 'Edit Cost item',
  receivable: 'Receivable',
  meet: 'Meet',
  income_and_expenditure_direction: 'Income and expenditure direction',
  cost_project_code: 'Cost item code',
  cost_project_name: 'Cost item name',
  application_scope: 'Application scope',
  store_expense_sheet: 'Store Expense Sheet',
  supplier_expense_sheet: 'Supplier Expense Sheet',
  location_prepayment: 'Location prepayment order',
  add_location_prepayment: 'Create location prepayment order',
  edit_location_prepayment: 'Edit location prepayment order',
  read_location_prepayment: 'Read location prepayment order',
  supplier_prepayment: 'Supplier prepayment order',
  add_supplier_prepayment: 'Create supplier prepayment order',
  edit_supplier_prepayment: 'Edit supplier prepayment order',
  read_supplier_prepayment: 'Read supplier prepayment order',
  supplier_settlement: 'Supplier settlement',
  create_supplier_settlement: 'Create supplier settlement document',
  edit_supplier_settlement: 'Edit supplier settlement document',
  read_supplier_settlement: 'Read supplier settlement document',

  request_order: 'Order form',
  request_order_same_tip: 'The required store must not be the same as the shipping store.',
  replenishment_guide: 'Replenishment guide',
  export_replenishment_guide: 'Export replenishment guide',
  generate_requisitions_by_store: 'Generate order form by store',
  generate_requisitions_by_class:
    'Generate the goods requisition form according to the top-level classification of items.',
  order_the_items: 'Order goods',
  choose_to_order_the_items: 'Choose to order the items',
  order_all_items_in_stock: 'Order all items currently in stock at the store',
  order_items_when_inventory_levels: 'Order items when inventory levels reach the reorder point',
  order_items_from_a_specified_category: 'Order items from a specified category',
  replenish_items_based_on_the_request_order_template:
    'Replenish items based on the request order template',
  order_items_based_on_the_item_query_template: 'Order items based on the item query template',
  order_items_based_day_1: 'Order items that have not been replenished for',
  order_items_based_day_2: 'days and have zero inventory',
  out_of_stock_item: 'Out-of-stock items',
  actively_selling_items: 'Actively selling items',
  actively_selling_items_tip:
    'Actively moving items: Refers to items for which the ordering stores have inventory transaction details within a specified time frame.',
  order_items_that_have_stock_at_the_distribution_store:
    'Order items that have stock at the distribution store',
  pending_order_qty: 'Pending Order Quantity',
  order_quantity: 'Order Quantity',
  select_order_quantity: 'Select Order Quantity',
  order_quantity_is_zero: 'Order Quantity is Zero',
  based_on_the_stock_upper_limit: 'Based on the Stock Upper Limit',
  outbound_quantity_within_a_time_range: 'Outbound Quantity within a Time Range',
  replenishment_guide_success_tip:
    'A total of {{order_qty}} purchase order has been generated, containing {{item_qty}} items!',
  replenishment_guide_success_check_tip:
    'Order details can be viewed in the Delivery Module - Request Order. Would you like to go and check?',
  replenishment_condition_change_tip:
    'Changing the restocking conditions will clear the selected item list, do you want to continue?',
  transfer_in_order: 'Transfer in order',
  transfer_out_order: 'Transfer out order',
  export_transfer_out_order_storehouse: 'Calling up summary (by warehouse)',
  confirm_order_audit_is: 'Are you sure you need to review the selected documents?',
  inner_apply_order: 'Internal request order',
  request_order_statistics: 'Order statistics',
  product_delivery_prop: 'Commodity distribution attribute',
  product_purchase_prop: 'Commodity purchase attribute',
  delivery_unit: 'Distribution unit',
  location_delivery_price: 'Branch transfer price',
  distribution_gross_profit: 'Transfer gross profit analyze report',
  location_gross_profit: 'Store Gross Profit Analysis Table',
  product_gross_profit: 'Product Gross Profit Analysis Table',
  location_gross_profit_diff: 'Comparison Table of Gross Profit of Store Products',
  pre_discount_sales_revenue: 'Pre discount sales revenue',
  discounted_sales_revenue: 'Discounted sales revenue',
  financial_info: 'Financial information',
  financial_entity: 'Financial entity',
  go_to_add: 'Go add',
  purchase_order: 'Purchase order',
  go_to_purchase_order_page: 'Go to purchase order page',
  generate_purchase_order: 'Generate purchase order',
  generate_central_purchase_order: 'Generate central purchase order',
  generate_central_purchase_orders_by_out_stock_volume:
    'Generate central purchase orders by out-of-stock volume',
  generate_direct_delivery_order: 'Generate direct delivery order',
  purchase_receive: 'Purchase and receive',
  purchase_receive_order: 'Purchase receipt',
  settlement_status: 'Settlement status',
  unsettled: 'Unsettled',
  partial_settlement: 'Partial settlement',
  already_settled: 'Already settled',
  return_order: 'Return note',
  supplier: 'Supplier',
  please_supplier_priority: 'Please select a supplier priority',
  by_main_supplier: 'By main supplier',
  by_nearest_receiving_supplier: 'By nearest receiving supplier',
  do_not_display_items: 'Do not display items',
  is_it_the_main_supplier: 'Is it the main supplier',
  by_purchasing_unit: 'By purchasing unit',
  new_supply_relationship_added: 'New supply relationship added',
  copy_supply_relationship_error: 'The target store and reference store cannot be the same',
  recent_procurement_records: 'Recent procurement records',
  set_as_the_main_upplier: 'Set as the main supplier',
  copy_supply_relationship: 'Copy supply relationship',
  batch_modify_suppliers: 'Batch modify suppliers',
  agreed_price: 'Agreed price',
  please_input_agreed_price: 'Please enter the agreed price',
  minimum_order_quantity: 'Minimum order quantity',
  please_input_minimum_order_quantity: 'Please enter the minimum order quantity',
  highest_price: 'The highest price',
  lowest_price: 'The lowest price',
  priority: 'Priority',
  latest_purchase_date: 'Latest purchase date',
  freight_amount: 'Freight amount',
  please_input_freight_amount: 'Please enter the shipping fee amount',
  input_tax_rate: 'Input tax rate',
  please_input_input_tax_rate: 'Please enter the input tax rate',
  procurement_cycle: 'Procurement cycle (days)',
  procurement_conversion_rate: 'Procurement conversion rate',
  do_not_display_discontinued_items: 'Do not display discontinued items',
  do_not_display_dormant_items: 'Do not display dormant items',
  please_select_do_not_display_items: 'Please choose not to display items',
  please_select_supplier_or_item_archives:
    'Multiple store query, please select supplier or item file',
  import_supply_relationship: 'Import item supply relationship',
  batch_import_supply_relationship: 'Batch import of item supply relationships',
  export_supply_relationship_of_goods: 'Export item supply relationship',
  supply_relationship_import_tmpl: 'Import template for item supply relationship',
  import_supply_relationship_tips:
    'The limit for each imported item should be less than 5000, and files smaller than 3M only support: XLS,. XLSX format files',
  please_select_supply_relationship: 'Please select the supply relationship to be deleted',
  supply_relationship_to_be_deleted: 'Delete item supply relationship [{{id}}]',
  delete_the_supply_relationship:
    'Are you sure you want to delete the supply relationship of the selected item?',
  are_you_sure_set_as_the_main_upplier:
    'Are you sure to change the primary supplier for the selected data?',
  supply_relationship_of_goods: 'Supply relationship of goods',
  target_store: 'Target store',
  please_choose_target_store: 'Please select the target store',
  scope_of_items: 'Scope of items',
  please_select_a_specified_category: 'Please select a specified category',
  adjustment_order: 'Inventory adjustment sheet',
  adjustment_reason: 'Reason for adjustment',
  check_order: 'Inventory sheet',
  finished_produce_rate_report: 'Manufacture rate report',
  produce_plan_order: 'Manufacture planned order',
  generate_plan_order: 'Generate planned order',
  generate_produce_plan_order: 'Generate manufacture planned order',
  generate_produce_plan_order_by_process: 'Generate a plan (summarized by processed products)',
  generate_produce_plan_order_by_request:
    'Generate a plan sheet (split according to the demand sheet)',
  produce_material_order: 'Manufacture metarial order',
  confirm_save_order: 'Are you sure you want to save this production material requisition?',
  confirm_audit_order:
    'Are you sure you want to save and approve this production material requisition form?',
  produce_material_order_audit_success:
    "The material requisition review has been successful and can be viewed in the 'Inventory Management - Inventory Adjustment' section",
  audit_success_warehousing:
    'Generate {{num}} production material requisition and warehouse receipt forms',
  audit_success_outbound: 'Generate {{num}} production material requisition and outbound orders',
  document_date: 'Document date',
  material_date: 'Material requisition date',
  current_inventory: 'current inventory',
  produce_room_inventory: 'Inventory in processing room',
  outbound_price: 'Average outbound price',
  outbound_price_tip: 'Average price per unit of outgoing warehouse consumption',
  base_outbound_price: 'Basic average price for outbound shipments',
  base_outbound_price_tip: 'Basic unit average price of outbound warehouse',
  outbound_money: 'Outbound amount',
  outbound_money_tip: 'Material requisition quantity * average outbound price',
  current_inventory_tip: 'Inventory surplus in the outbound warehouse',
  storehouse_num_cannot_be_the_same:
    'The processing warehouse and the outbound warehouse cannot be the same, please select again',
  product_date: 'date of manufacture',
  batch_add: 'Batch Add',
  receive_quantity: 'Quantity received',
  produce_storage_order: 'Manufacture  receipt order',
  produce_fast_order: 'Quick manufacture order',
  ship_net_setting: 'Distribution network setup',
  chain_stock_setting: 'Invoicing Settings',
  number_precision: 'Digital precision',
  modify_precision_tip:
    'The number of decimal places in the modified precision cannot be less than the current number of decimal places, and the adjustment should be made after careful consideration.',
  product_price_precision: 'Product price precision',
  two_decimal: 'Two decimals',
  three_decimal: 'Three decimals',
  four_decimal: 'Four decimals',
  order_goods_setting: 'Ordering settings',
  call_single_parameter: 'Call in single parameter',
  examine_direct_generation:
    'Generate store transfer in order directly from center transfer out order review',
  exceed: 'Axceed',
  automatically_call_hours: 'Automatically call in after hours',
  auto_transfer_in_tip: 'Tip: Empty indicates that the store does not automatically call in',
  price_precision_cannot_subtract: 'Price precision is not allowed to be smaller',
  edit_chain_stock_settings: 'Edit PSI settings',
  location_request_order_setting: 'Location Request Order Setting',
  intelligent_replenishment: 'Intelligent replenishment',
  location_request_no_display_central_inventory: 'Location Request Hide Central Inventory',
  location_request_no_exceed_distribution_center_inventory:
    'Location Request No Exceed Distribution Center Inventory',

  please_select_material: 'Please select material',
  raw_material_consumption_analysis_table_for_processed_products:
    'Raw material consumption analysis table for processed products',
  read_raw_material_consumption_analysis_table_for_processed_products:
    'View the raw material consumption analysis table for processed products',
  export_raw_material_consumption_analysis_table_for_processed_products:
    'Export the raw material consumption analysis table for processed products',
  expected_yield_report: 'Expected yield report',
  read_expected_yield_report: 'Read expected yield report',
  export_expected_yield_report: 'Export expected yield report',
  expected_yield: 'Expected yield',
  actual_yield: 'Actual yield',

  tag: 'Label',
  vendor: 'Brand',
  search_vendor: 'Search Brand',
  product_service: 'Product series',
  copy_request_order_with_order_no: 'Copy the order form[{{orderNo}}]',
  copy_request_order: 'Copy the order form',
  save_request_order_with_order_no: 'Create an order form[{{orderNo}}]',
  del_request_order_with_order_no: 'Delete the order form[{{orderNo}}]',
  invalid_request_order_with_order_no: 'Invalid the order form[{{orderNo}}]',
  audit_request_order_with_order_no: 'Audit the order form[{{orderNo}}]',
  save_request_order: 'Add order form',
  edit_request_order: 'Edit order form',
  print_request_order: 'Print order form',
  read_request_order: 'View order form',
  request_order_import: 'Order form import',
  request_order_import_tmpl: 'Order form import template',
  order_no: 'Document number',
  order_type: 'Document type',
  memo: 'Remarks',
  tip: 'Prompt',
  order_detail_export: 'Detail export',
  export_order_detail_by_storehouse: 'Export detail summary(by storehouse)',
  summary_export: 'Order summary',
  order_summary_export: 'Export order summary',
  order_summary_export_by_sku: 'Export by SKU',
  order_summary_export_by_type: 'Export by category',
  by_type: 'By category',
  export_request_order_detail_with_order_no: 'Export the order [{{orderNo}}] details',
  order_detail_import: 'Detail import',
  import_request_order_detail_with_order_no: 'Import the details of the order [{{orderNo}}]',
  export_task_create_success: 'The export is being processed. Check it in the task center',
  import_task_create_success: 'The import is being processed. Go to the task center to check it',
  uploading_wait: 'Uploading, please hold',
  upload_failed: 'Upload failed, please upload again',
  upload_success: 'Upload successfully',
  print_task_create_success: 'Printing is being processed, please go to the task center to check',
  print_failed: 'Print failure',
  current_location_no_type: 'No store type is set for the current store',
  head_quarters_have_no_transfer: 'No distribution stores have been set up',
  location_have_no_transfer:
    'No distribution stores have been set up. Please contact the headquarters for configuration',
  request_location: 'Order store',
  request_location_num: 'Order store number',
  choose_request_location: 'Please select stores you want',
  choose_request_location_first: 'Please select the store first',
  head_quarters_have_no_distribution_center: 'No distribution center has been set up',
  location_have_no_distribution_center:
    'No distribution center has been configured. Contact the headquarters for configuration',
  delivery_location: 'Delivery store',
  receive_location: 'Receiving store',
  please_choose_receive_location: 'Please select the receiving store',
  please_choose_receive_location_first: 'Please select the receiving store first',
  choose_delivery_location: 'Please select the shipping store',
  choose_delivery_location_first: 'Please select the shipping store first',
  delivery_location_can_not_be_null: 'The delivery store cannot be empty',
  please_choose_location: 'Please select store',
  choose_location: 'Select store',
  delivery_date: 'Delivery date',
  receive_date: 'Date of receipt',
  send_date: 'Delivery date',
  expected_delivery_time: 'Expected Delivery Time',
  salesman: 'Salesman',
  choose_salesman: 'Selective salesman',
  search_product_tag: 'Search tag',
  input_memo_and_max_length_100: 'Please enter the remarks, which cannot exceed 100 characters',
  un_choose_list: 'The list item is not selected',
  export_request_order: 'Export the purchase order',
  input_order_no: 'Please enter the document number',
  audit_sate: 'Audit status',
  date_type: 'Date type',
  filer_date: 'Screening date',
  all: 'All',
  state_init: 'To be reviewed',
  state_audit: 'Reviewed',
  state_cancel: 'Have become obsolete',
  state_pass: 'Have passed',
  state_refuse: 'Rejected',
  state_agree: 'Agreed',
  row_num: 'Serial number',
  order_created_at: 'Document making time',
  order_creator: 'Documenter',
  order_audited_at: 'Audit time',
  order_auditor: 'Auditor',
  order_delivery_at: 'Delivery time',
  settlement_time: 'Settlement Time',
  payment_method: 'Payment Method',
  order_money: 'Amount of documents',
  operate: 'Operation',
  operate_tip: 'Operation prompt',
  invalid_success: 'Successful annulment',
  agree_success: 'Agreed successfully',
  read_transfer_in_order: 'View the transfer in order',
  save_transfer_in_order: 'New transfer in order',
  edit_transfer_in_order: 'Edit transfer in order',
  copy_transfer_in_order: 'Copy transfer in order',
  copy_transfer_in_order_with_order_no: 'Copy transfer in order[{{orderNo}}]',
  create_transfer_in_order_with_order_no: 'New transfer in order[{{orderNo}}]',
  del_transfer_in_order_with_order_no: 'Delete transfer in order[{{orderNo}}]',
  audit_transfer_in_order: 'Audit transfer in order',
  audit_transfer_in_order_with_order_no: 'Audit transfer in order[{{orderNo}}]',
  print_transfer_in_order: 'Print transfer in order',
  export_transfer_in_order: 'Export transfer in order',
  export_transfer_in_order_detail_with_order_no: 'Export the import order [{{orderNo}}] details',
  invalid_transfer_in_order_with_order_no: 'Void incoming order [{{orderNo}}]',
  read_transfer_out_order: 'View the transfer out order',
  save_transfer_out_order: 'New transfer out order',
  edit_transfer_out_order: 'Edit transfer out order',
  copy_transfer_out_order: 'Copy transfer out order',
  audit_transfer_out_order: 'Audit transfer out order',
  export_transfer_out_order: 'Export transfer out order',
  print_transfer_out_order: 'Print transfer out order',
  transfer_out_guide: 'Transfer out guide',
  read_transfer_out_guide: 'Read transfer out guide',
  save_transfer_out_guide: 'Save transfer out guide',
  transfer_out_guide_by_storehouse_ruler: 'Transfer out guide(According to warehouse item rules)',
  export_transfer_out_guide: 'Export transfer out guide',
  audit_transfer_out_order_with_order_no: 'Audit transfer out order[{{orderNo}}]',
  audit_auto_create_transfer_in_order:
    'Store transfer order will be generated automatically after approval。',
  copy_transfer_out_order_with_order_no: 'Copy transfer out order[{{orderNo}}]',
  create_transfer_out_order_with_order_no: 'New transfer out order[{{orderNo}}]',
  export_transfer_out_order_detail_with_order_no:
    'Export the details of the call-out order [{{orderNo}}]',
  relate_request_order: 'Associated purchase order',
  please_choose_relate_request_order: 'Select the associated purchase order',
  del_transfer_out_order_with_order_no: 'Delete transfer out order[{{orderNo}}]',
  invalid_transfer_out_order_with_order_no: 'Cancel transfer out order[{{orderNo}}]',
  copy_inner_apply_order_with_order_no: 'Copy internal requisition order[{{orderNo}}]',
  create_inner_apply_order_with_order_no: 'New internal requisition order [{{orderNo}}]',
  pass_inner_apply_order_with_order_no: 'Pass internal requisition order [{{orderNo}}]',
  refuse_inner_apply_order_with_order_no: 'Reject internal requisition order [{{orderNo}}]',
  print_inner_apply_order: 'Print internal requisition order ',
  export_inner_apply_order_detail_with_order_no:
    'Export internal requisition order [{{orderNo}}]明细',
  save_inner_apply_order: 'New internal requisition order',
  reply_inner_apply_order: 'Reply to internal requisition order',
  edit_inner_apply_order: 'Edit internal requisition order',
  audit_inner_apply_order: 'Audit internal requisition order',
  copy_inner_apply_order: 'Copy internal requisition order',
  read_inner_apply_order: 'View internal requisition order',
  deadline: 'Deadline date',
  relate_transfer_in_order: 'Associate the call in order',
  choose_relate_transfer_in_order: 'Select the associated call-in ticket',
  please_choose_apply_location: 'Please select the application store',
  apply_location: 'Store application',
  read_request_order_statistics: 'Check order statistics',
  read_request_distribution_center: 'Check distribution center',
  print_request_distribution_center: 'Print distribution center',
  export_request_order_statistics: 'Export order statistics',
  product_title: 'Commodity name',
  variant: 'Specification',
  product_sku: 'Commodity code',
  product_type: 'Commodity category',
  qty: 'Quantity',
  number_of_items: 'Number of items',
  use_unit: 'Common unit',
  use_unit_qty: 'Number of common units',
  base_unit: 'Basic unit',
  base_qty: 'Basic quantity',
  money: 'Amount',
  current_location_stock: 'Current Location Stock',
  distribution_center_stock: 'Distribution Center Stock',
  validate_request_num_tip:
    'The quantity required cannot be greater than the actual center inventory {{num}}',
  validate_request_num_tip1:
    'The quantity required cannot be greater than the actual center inventory',
  choose_product_type: 'Selection of commodity category',
  product_info: 'Commodity information',
  choose_product_info: 'Select product information',
  choose_product: 'Select goods',
  please_choose_product: 'Please select goods',
  please_choose_out_order_product: 'Please select the item that needs to be produced',
  keyword: 'Key word',
  search_product_title_barcode_sku: 'Search the product name/bar code/code',
  product_summary: 'Commodity summary',
  total: 'Total',
  order_count: 'Sum of documents',
  goods_count: 'Number of goods',
  location_product_summary: 'Store - Merchandise summary',
  day_max_order_qty: 'Daily order limit',
  please_input_day_max_order_qty: 'Please enter the daily order limit',
  min_order_qty: 'Lower order limit',
  please_input_min_order_qty: 'Please enter the lower order limit',
  min_order_qty_must_lt_day_max_order_qty:
    'The order floor must be less than the daily order ceiling',
  order_multiple: 'Order base',
  please_input_order_multiple: 'Please enter the order base',
  inventory_policy: 'Keep ordering after stock is out',
  please_choose_inventory_policy: 'Please choose to continue ordering after stock shortage',
  stock_out_distribution: 'Understock distribution',
  all_product: 'All goods',
  point_product: 'Specified goods',
  specify_classification: 'Specify classification',
  only_search_for_items: 'Only search for items',
  query_scope: 'Query scope',
  filter_items_fully_shipped: 'Filter items that have been fully shipped',
  query_only_items_not_generated_out: 'Query only items that have not generated a call-up',
  query_only_items_not_generated_out_order: 'Query only orders that have not generated a call-up',
  export_purchase_order_summary: 'Export Purchase Order Summary',
  export_by_category: 'Export by category',
  export_according_to_warehouse_item_rules: 'Export according to warehouse item rules',
  by_warehouse_item_rules: 'By warehouse item rules',
  query_all_desired_products: 'Query all desired products',
  please_choose_copy_prop: 'Please select replication properties',
  choose_location_can_not_equal_reference_location:
    'The selected store cannot be the same as the reference store',
  copy_product_delivery_prop: 'Copy the goods shipping property',
  product_delivery_prop_copy: 'Commodity distribution property copy',
  copy_product_purchase_prop: 'Copy the goods purchase property',
  product_purchase_prop_copy: 'Commodity purchase property copy',
  product_delivery_prop_copy_desc:
    'The distribution attribute replication function is mainly used to directly copy the distribution attribute of the goods in the reference store to other stores.',
  product_purchase_prop_copy_desc:
    'The purchase attribute replication function is mainly used to directly copy the purchase attribute of the goods in the reference store to other stores.',
  please_choose_reference_location: 'Please select reference store',
  reference_location: 'Reference store',
  read_product_delivery_prop: 'View the goods shipping properties',
  import_product_delivery_prop: 'Import goods delivery properties',
  export_product_delivery_prop: 'Export commodity delivery properties',
  setting_product_delivery_prop: 'Set goods delivery properties',
  batch_delete_product_delivery_prop: 'Batch delete goods delivery properties',
  read_product_purchase_prop: 'View the goods purchase properties',
  import_product_purchase_prop: 'Import goods purchase properties',
  export_product_purchase_prop: 'Export commodity purchase properties',
  setting_product_purchase_prop: 'Set goods purchase properties',
  edit_product_delivery_prop_with_location_name: 'Edit item shipping properties {{locationName}}',
  edit_product_purchase_prop_with_location_name: 'Edit item purchase properties {{locationName}}',
  location_name: 'Store name',
  location_total: 'Store total',
  day_max_order_qty_must_gt_min_order_qty:
    'The daily order limit must be greater than or equal to the daily order limit',
  day_max_order_qty_must_ge_order_multiple:
    'The daily order limit must be greater than or equal to the order base. Please expand the daily order limit',
  day_max_order_qty_rule_desc:
    'Daily Order Upper limit: specifies the maximum number of orders ordered each day',
  min_order_qty_rule_desc: 'Order floor: minimum quantity per order',
  order_multiple_rule_desc:
    'Order base: Orders must be placed in integer multiples of the order base',
  inventory_policy_rule_desc:
    'Continue ordering after out of stock: check this option, the distribution center designated by the store is allowed to continue ordering when out of stock; Uncheck, the store designated distribution center out of stock, not allowed to continue to order',
  choose_type: 'Select category',
  type: 'Category',
  search_product_lt_value: 'Search for items less than this value',
  search_product_gt_value: 'Search for items greater than this value',
  product_delivery_prop_import: 'Commodity distribution attribute import',
  product_purchase_prop_import: 'Commodity purchase attribute import',
  product_delivery_prop_import_tmpl: 'Commodity delivery properties import template',
  product_purchase_prop_import_tmpl: 'Commodity purchase properties import template',
  if_excel_empty_not_change:
    'If the imported Excel table data is empty, the original data is not changed.',
  please_input_location_delivery_price: 'Please enter the store delivery price',
  please_add_price_rate: 'Please enter the rate of increase',
  please_add_price_value: 'Please enter the amount of the increase',
  setting_location_delivery_price: 'Set up store delivery prices',
  max_can_not_gt: 'Maximum cannot exceed',
  cost_price: 'Cost price',
  available_inventory: 'Available stock',
  inventory_price: 'Unit price of inventory',
  inventory_average_price: 'Average stock price',
  inventory_average_price_tip:
    'When the inventory quantity is 0, the file reference price is taken',
  reference_cost_price: 'Refer to the cost price',
  setting_delivery_price: 'Set delivery price',
  rule: 'Rule',
  adjust: 'Adjust',
  add_price_rate: 'The percentage of the markup',
  add_price_value: 'The amount of the markup',
  copy_location_delivery_price: 'Copy store delivery prices',
  delivery_price_copy: 'Delivery price replication',
  delivery_price_copy_desc:
    'The distribution price replication function is mainly used to directly copy the delivery price of the reference store to other stores.',
  read_distribution_gross_profit: 'Check delivery margin',
  export_distribution_gross_profit: 'Derived distribution margin',
  transfer_out_money: 'Transfer amount',
  transfer_out_cost: 'Transfer cost',
  transfer_in_money: 'Amount transferred',
  transfer_in_cost: 'Transfer cost',
  gross_profit: 'Gross profit',
  gift_cost: 'Gift cost',
  gift_qty: 'Gift quantity',
  delivery_money: 'Amount of delivery',
  delivery_money_total: 'Total delivery amount',
  distribution_cost: 'Distribution cost',
  delivered_qty: 'Amount of delivered',
  undelivered_order_qty: 'Undelivered Order Quantity',
  delivery_qty: 'Delivery quantity',
  product_barcode: 'Commodity bar code',
  transfer_out_qty: 'Transfer quantity',
  transfer_in_qty: 'Incoming quantity',
  gross_profit_rate: 'Gross profit margin',
  gross_profit_quantity: 'Gross profit Quantity',
  location_summary: 'Store summary',
  read_purchase_order: 'View purchase order',
  save_purchase_order: 'New purchase order',
  edit_purchase_order: 'Edit purchase order',
  audit_purchase_order: 'Review purchase order',
  export_purchase_order: 'Export purchase order',
  print_purchase_order: 'Print purchase order',
  copy_purchase_order: 'Duplicate purchase order',
  invalid_purchase_order_with_order_no: 'Cancel the purchase order[{{orderNo}}]',
  del_purchase_order_with_order_no: 'Delete purchase order[{{orderNo}}]',
  audit_purchase_order_with_order_no: 'Review purchase order[{{orderNo}}]',
  copy_purchase_order_with_order_no: 'Duplicate purchase order[{{orderNo}}]',
  create_purchase_order_with_order_no: 'Create a purchase order[{{orderNo}}]',
  abandon_purchase_order_with_order_no: 'Abandon a purchase order[{{orderNo}}]',
  read_purchase_receive_order: 'Check the purchase receipt',
  save_purchase_receive_order: 'New purchase receipt',
  edit_purchase_receive_order: 'Edit the purchase receipt',
  audit_purchase_receive_order: 'Review the purchase receipt',
  print_purchase_receive_order: 'Print the purchase receipt',
  export_purchase_receive_order: 'Export purchase receipt',
  copy_purchase_receive_order: 'Copy the purchase receipt',
  copy_purchase_receive_order_with_order_no: 'Copy the purchase receipt[{{orderNo}}]',
  create_purchase_receive_order_with_order_no: 'Create a purchase receipt[{{orderNo}}]',
  del_purchase_receive_order_with_order_no: 'Delete the purchase receipt[{{orderNo}}]',
  invalid_purchase_receive_order_with_order_no: 'Annulled purchase receipt[{{orderNo}}]',
  audit_purchase_receive_order_with_order_no: 'Review the purchase receipt[{{orderNo}}]',
  export_purchase_receive_order_detail_with_order_no:
    'Export the purchase receipt [{{orderNo}}] details',
  read_return_order: 'View the return note',
  save_return_order: 'New return note',
  edit_return_order: 'Edit return',
  audit_return_order: 'Review the return',
  export_return_order: 'Export return',
  copy_return_order: 'Duplicate return',
  print_return_order: 'Print the return form',
  copy_return_order_with_order_no: 'Duplicate return[{{orderNo}}]',
  create_return_order_with_order_no: 'Create a return note[{{orderNo}}]',
  del_return_order_with_order_no: 'Delete return[{{orderNo}}]',
  invalid_return_order_with_order_no: 'The return is invalid[{{orderNo}}]',
  audit_return_order_with_order_no: 'Review the return[{{orderNo}}]',
  export_return_order_detail_with_order_no: 'Export the return [{{orderNo}}] details',
  audit_confirm_is: 'Review and confirm',
  purchase_location: 'Purchasing store',
  save_supplier: 'New supplier',
  edit_supplier: 'Edit supplier',
  edit_supplier_with_name: 'Edit supplier[{{supplierName}}]',
  create_supplier_with_name: 'New supplier[{{supplierName}}]',
  edit_supplier_with_role_name: 'Edit supplier role[{{supplierRoleName}}]',
  create_supplier_with_role_name: 'New supplier role[{{supplierRoleName}}]',
  purchase_date: 'Date of purchase',
  please_choose_purchase_location: 'Please select the purchase store',
  export_purchase_order_detail_with_order_no: 'Export the purchase order [{{orderNo}}] details',
  please_choose_supplier: 'Please select supplier',
  choose_supplier: 'Selection of supplier',
  have_no_supplier: 'No supplier has been set',
  bulk_set_suppliers: 'Bulk Set Suppliers',
  relate_purchase_order: 'Associated purchase order',
  choose_relate_purchase_order: 'Select the associated purchase order',
  return_location: 'Return store',
  return_date: 'Return date',
  please_choose_return_location: 'Please select return store',
  relate_receive_order: 'Associated receipt of goods',
  choose_relate_receive_order: 'Select associated receipt',
  relate_purchase_receive_order: 'Associated purchase receipt',
  base_info: 'Basic information',
  wechat_order_accept: 'WeChat order acceptance',
  supplier_code: 'Supplier code',
  please_input_supplier_code: 'Please enter the supplier code',
  input_char_length_must_le_20: 'A maximum of 20 characters',
  please_input_number_or_str: 'Please enter numbers or letters',
  input_number_or_str_length_must_le_20: 'No more than 20 letters or numbers',
  supplier_name: 'Supplier name',
  please_input_supplier_name: 'Please enter a supplier name',
  input_length_must_le_20: 'No more than 20 words',
  contact: 'Contact person',
  contact_phone: 'Contact number',
  please_input_contact_name: 'Please enter a contact name',
  contact_address: 'Contact address',
  please_input_contact_address: 'Please enter the contact address',
  please_input_right_phone: 'Please enter the correct contact number',
  please_input_right_contact_phone: 'Please enter the contact number',
  email: 'E-mail address',
  please_input_email: 'Please enter your email address',
  email_format_error: 'The mailbox format is incorrect',
  finance_info: 'Financial information',
  open_account_name: 'Account name',
  please_input_open_account_name: 'Please enter the account name',
  open_account_bank: 'Bank of deposit',
  please_input_open_account_bank: 'Please enter your bank',
  bank_card_no: 'Bank card number',
  please_input_bank_card_no: 'Please enter your bank card number',
  please_input_right_bank_card_no: 'Please enter the correct bank card number',
  invoice_title: 'Invoice title',
  please_input_invoice_title: 'Please enter the invoice title',
  enclosure_info: 'Attachment information',
  upload_certificates: 'Upload certificate',
  upload_enclosure: 'Upload attachment',
  upload_maximum: 'A maximum of {{max}} photos can be uploaded',
  upload_image_maximum_size: 'Image cannot be larger than 2MB',
  business_license_image_upload_rule:
    'Upload qualification files such as business licenses. png, jpg, and jpeg files are supported. Each file cannot be larger than 2MB',
  read_supplier: 'View supplier',
  del_supplier_with_name: 'Delete supplier[{{supplierName}}]',
  del_supplier_with_user_name: 'Delete supplier user[{{supplierUserName}}]',
  del_supplier_with_user_role_name: 'Delete supplier user role[{{supplierUserRoleName}}]',
  search_supplier_name_contact_phone: 'Search for vendors/contacts/contact numbers',
  read_adjustment_order: 'Check the inventory adjustment sheet',
  save_adjustment_order: 'New inventory adjustment sheet',
  edit_adjustment_order: 'Edit inventory adjustment sheet',
  audit_adjustment_order: 'Review the inventory adjustment sheet',
  export_adjustment_order: 'Export the inventory adjustment sheet',
  print_adjustment_order: 'Print an inventory adjustment sheet',
  copy_adjustment_order: 'Copy the inventory adjustment sheet',
  invalid_adjustment_order_with_order_no: 'Scrap inventory adjustment sheet[{{orderNo}}]',
  del_adjustment_order_with_order_no: 'Delete inventory adjustment sheet[{{orderNo}}]',
  audit_adjustment_order_with_order_no: 'Review the inventory adjustment sheet[{{orderNo}}]',
  copy_adjustment_order_with_order_no: 'Copy the inventory adjustment sheet[{{orderNo}}]',
  create_adjustment_order_with_order_no: 'Create inventory adjustment slips[{{orderNo}}]',
  import_adjustment_order_with_order_no: 'Import inventory adjustment sheet[{{orderNo}}]',
  export_adjustment_order_detail_with_order_no:
    'Export the inventory adjustment order [{{orderNo}}] details',
  adjustment_location: 'Adjust stores',
  please_choose_adjustment_location: 'Please select adjust store',
  adjustment_type: 'Adjustment mode',
  please_choose_adjustment_type: 'Select an adjustment mode',
  choose_adjustment_type: 'Select adjustment mode',
  inventory_in: 'Be put in storage',
  inventory_in_money: 'Warehousing amount',
  inventory: 'Inventory',
  inventory_change: 'Inventory changes',
  virtual_inventory_change: 'Virtual inventory change',
  export_inventory_change: 'Export inventory changes',
  inventory_log_list: 'Inventory Log List',
  virtual_inventory_log_list: 'Virtual inventory log list',
  stock_transfer: 'Inventory transfer',
  stock_transfer_details: 'Inventory transfer order details',
  read_stock_transfer: 'Read inventory transfer',
  save_stock_transfer: 'New inventory transfer sheet',
  copy_stock_transfer: 'Copy inventory transfer sheet',
  edit_stock_transfer: 'Edit inventory transfer sheet',
  save_stock_transfer_with_order_no: 'Created inventory transfer [{{orderNo}}]',
  del_stock_transfer_with_order_no: 'Delete inventory transfer [{{orderNo}}]',
  edit_stock_transfer_with_order_no: 'Edit inventory transfer [{{orderNo}}]',
  audit_stock_transfer_with_order_no: 'Audit inventory transfer [{{orderNo}}]',
  copy_stock_transfer_with_order_no: 'Copy inventory transfer [{{orderNo}}]',
  export_stock_transfer: 'Export inventory transfer',
  export_stock_transfer_detail_with_order_no: 'Export the inventory transfer [{{orderNo}}] details',
  blush_copy_stock_transfer_with_order_no: 'Blush copy inventory transfer [{{orderNo}}]',
  confirm_blush_copy_stock_transfer: 'Are you sure you want to copy "[{{orderNo}}]"？',
  blush_duplicate: 'Blush duplicate',
  stock_transfer_date: 'Inventory transfer date',
  available_stock: 'Available inventory',
  occupy_stock: 'Allocate inventory',
  occupy_qty: 'Allocate quantity',
  occupy_stock_details: 'Allocate inventory details',
  inventory_situation: 'Inventory situation',
  please_select_inventory_situation: 'Please select inventory situation',
  in_stock: 'In stock',
  out_stock: 'Out of stock',
  inventory_out: 'Warehousing',
  adjustment_date: 'Date adjustment',
  choose_reason: 'Selection reason',
  please_choose_adjustment_reason: 'Select a reason for the adjustment',
  please_input_reason_keyword: 'Please enter the cause keyword',
  adjustment_order_import: 'Adjustment sheet import',
  adjustment_order_import_tmpl: 'Adjust the single import template',
  read_adjustment_reason: 'Viewing the Reason for Adjustment',
  save_adjustment_reason: 'Reason for new adjustment',
  edit_adjustment_reason: 'Reason for editing adjustment',
  create_adjustment_reason_with_order_no: 'Create adjustment cause[{{reasonName}}]',
  edit_adjustment_reason_with_order_no: 'Reason for editing adjustment[{{reasonName}}]',
  del_adjustment_reason_with_order_no: 'Deletion adjustment reason[{{reasonName}}]',
  name: 'Name',
  please_input_name: 'Please enter name',
  name_can_not_be_null: 'The name cannot be empty',
  please_input_adjustment_reason_name: 'Enter the cause name',
  read_check_order: 'Check the inventory sheet',
  save_check_order: 'New inventory check sheet',
  edit_check_order: 'Edit the inventory sheet',
  audit_check_order: 'Review the stock count sheet',
  export_check_order: 'Export the inventory check sheet',
  print_check_order: 'Print the inventory check sheet',
  copy_check_order: 'Copy the inventory check sheet',
  invalid_check_order_with_order_no: 'Nullify the stock count sheet[{{orderNo}}]',
  del_check_order_with_order_no: 'Delete the inventory check sheet[{{orderNo}}]',
  audit_check_order_with_order_no: 'Review the stock count sheet[{{orderNo}}]',
  copy_check_order_with_order_no: 'Copy the inventory check sheet[{{orderNo}}]',
  create_check_order_with_order_no: 'Create a inventory check sheet[{{orderNo}}]',
  import_check_order_with_order_no: 'Import the inventory check sheet[{{orderNo}}]',
  export_check_order_detail_with_order_no: 'Export the inventory check [{{orderNo}}] details',
  check_order_import: 'Inventory entry',
  check_order_import_tmpl: 'Inventory sheet import template',
  check_location: 'Take stock of stores',
  please_choose_check_location: 'Please select the inventory store',
  all_product_check: 'Full count',
  point_product_check: 'Item count',
  point_type_check: 'Category count',
  check_type: 'Inventory type',
  inventory_check_scope: 'Inventory check scope',
  please_choose_inventory_check_scope: 'Please select inventory check scope',
  check_date: 'Date of inventory',
  no_unit: 'No unit',
  product_have_no_unit: 'Goods have no units',
  check_qty_base_unit_qty_gt_zero_in_same_time:
    'The count quantity and the base quantity must not be zero at the same time',
  check_order_detail: 'Inventory sheet details',
  check_order_snapshot_desc:
    'For example, the actual inventory of the system is 100, and the inventory quantity is 101 during the inventory taking. At this time, the purchase quantity after the inventory snapshot is set to 40, and then the inventory taking audit is conducted. After the audit, the inventory is 101+40=141',
  product_dormancy_desc:
    '[Sleep] : ordering is not allowed, and the product is not displayed in the ordering process',
  product_stop_purchase_desc:
    '[Stop purchase] : The product is not allowed to be purchased and will not be displayed in the purchase process',
  product_draft_desc: '[File/Draft] : The product is not shown in the system documents',
  after_audit_inventory_will_change:
    'After the audit, the inventory will be adjusted according to the inventory count.',
  please_choose_check_type: 'Please select the inventory type',
  please_choose_type: 'Please select category',
  check_method: 'Inventory method',
  filter_product: 'Filtered goods',
  read_finished_produce_rate_report: 'View the output rate report',
  export_finished_produce_rate_report: 'Export the output rate report',
  plan_produce_qty: 'Planned production',
  finished_in_inventory_qty: 'Quantity of finished products in storage',
  plan_finish_rate: 'Planned completion rate',
  finished_produce_rate: 'Yield of finished products',
  total_material: 'Total raw materials',
  storage_time: 'Warehousing time',
  storage_date: 'Date of arrival',
  plan_order_no: 'Plan number',
  add_by_request_order: 'Add through request form',
  request_number: 'Number',
  in_production: 'In Production',
  in_production_tip: 'Unaudited production receipt, the total amount of a certain item',
  formula_available: 'Is there a formula available',
  quantity_required: 'Production quantity required',
  request_number_tip:
    'The store requests goods from the distribution center, the total amount of a certain item',
  at_most: 'At most {{num}} characters',
  please_select_produced_product: 'Please select the item to be produced',
  produce_plan_order_tip:
    "Generate a demand order based on the store's demand for goods, and display it in the dimension of processed products",
  choose_plan_order_no: 'Select the schedule number',
  produce_plan_order_no: 'Production Plan Number',
  process_no_type: 'Processing order type',
  from_to_process_order_no: 'Source Processing Order Number',
  from_to_process_order_no_tip:
    'If the formula of processed product A is nested with semi-finished product B, the system will generate a processing plan for the nested semi-finished product B after the A processing order is approved. The source processing plan number of the B processing plan is the processing plan for processed product A',
  added_by_hands: 'Manually add',
  request_order_added: 'Add a new request form',
  ship_center_generated: 'Distribution center generation',
  from_board_created: 'Collecting tasks',
  production_order_created: 'Production task creation',
  from_order: 'From order',
  read_produce_plan_order: 'View the production plan sheet',
  save_produce_plan_order: 'New production schedule',
  edit_produce_plan_order: 'Edit the production planner',
  audit_produce_plan_order: 'Review the production plan sheet',
  export_produce_plan_order: 'Export the production plan sheet',
  print_produce_plan_order: 'Print the production plan sheet',
  copy_produce_plan_order: 'Copy the production planner',
  invalid_produce_plan_order_with_order_no: 'Cancel the production plan sheet[{{orderNo}}]',
  del_produce_plan_order_with_order_no: 'Delete the production schedule[{{orderNo}}]',
  audit_produce_plan_order_with_order_no: 'Review the production plan sheet[{{orderNo}}]',
  copy_produce_plan_order_with_order_no: 'Copy the production planner[{{orderNo}}]',
  create_produce_plan_order_with_order_no: 'Create a production planner[{{orderNo}}]',
  import_produce_plan_order_with_order_no: 'Import the production planner[{{orderNo}}]',
  export_produce_plan_order_detail_with_order_no:
    'Export production scheduler [{{orderNo}}] details',
  produce_qty_can_not_be_zero: 'The amount of processing should not be 0',
  read_produce_material_order: 'Check the production material requisition sheet',
  save_produce_material_order: 'New material requisition for production',
  edit_produce_material_order: 'Edit production requisition sheet',
  audit_produce_material_order: 'Review production material requisition sheet',
  export_produce_material_order: 'Export production material requisition list',
  print_produce_material_order: 'Print production requisition sheet',
  copy_produce_material_order: 'Copy production requisition sheet',
  invalid_produce_material_order_with_order_no:
    'Scrap production material requisition[{{orderNo}}]',
  del_produce_material_order_with_order_no:
    'Delete the production material requisition[{{orderNo}}]',
  audit_produce_material_order_with_order_no:
    'Review production material requisition sheet[{{orderNo}}]',
  copy_produce_material_order_with_order_no: 'Copy production requisition sheet[{{orderNo}}]',
  create_produce_material_order_with_order_no: 'Create production requisition sheet[{{orderNo}}]',
  import_produce_material_order_with_order_no:
    'Import production material requisition[{{orderNo}}]',
  export_produce_material_order_detail_with_order_no:
    'Export details of production material requisition [{{orderNo}}]',
  finished_have_no_material: 'The finished formula has no raw materials',
  produce_date: 'Date of processing',
  relate_produce_plan_order: 'Associated production planning sheet',
  please_choose_relate_produce_plan_order: 'Please select the associated plan sheet',
  choose_relate_produce_plan_order: 'Select the associated plan sheet',
  produce_product: 'Processed goods',
  please_choose_produce_product: 'Please select the product to be processed',
  choose_produce_product: 'Selected goods for processing',
  produce_qty: 'Processing quantity',
  please_input_produce_qty: 'Please enter the processing quantity',
  please_input_product_title_barcode_sku_variant:
    'Please enter the product name/bar code/code/specification',
  produce_storage_order_no: 'Production Receipt Number',
  warehousing_success_tip:
    "Production and warehousing have been successful. You can check the inventory details in the 'Inventory Entry and Exit Details' section",
  outbound_record: 'Generate {{num}} production and inventory records',
  warehousing_record: 'Generate {{num}} production outbound records',
  process_product_warehousing: 'Processed products are stored in the warehouse',
  raw_material_warehousing: 'Raw material storage',
  confirm_price: 'Price confirmation',
  deducting_warehouse: 'Deducting warehouse',
  deducting_warehouse_tip:
    'Deducting the warehouse is taken from the processed product management, and the processed product is located in the processing room warehouse',
  inventory_status: 'Inventory Status',
  theoretical_dosage: 'Theoretical dosage',
  theoretical_dosage_tip:
    'Theoretical consumption of raw materials calculated based on the production and warehousing quantity of processed products combined with the production formula',
  actual_usage: 'Actual usage',
  actual_usage_tip: 'The amount manually entered by the user defaults to the theoretical amount',
  differential_dosage: 'Differential dosage',
  differential_dosage_tip: 'Differential dosage=theoretical dosage - actual dosage',
  quantity_on_hand: 'Quantity on hand',
  quantity_to_be_supplemented: 'Quantity to be supplemented',
  quantity_to_be_supplemented_tip:
    'Actual usage - On hand quantity. If positive, a red alert indicates a shortage. If negative, a zero alert indicates sufficient quantity',
  detail_money_tip:
    'The amount will not be calculated until it is completed and stored in the warehouse',
  detail_price_tip:
    'The cost unit price is not calculated before the completed goods are put into storage',
  detail_in_storehouse_tip:
    'The warehouse entry is based on the warehouse item rules, otherwise it is empty',
  batch_setting_in_warehouse: 'Batch set warehouse for inbound storage',
  raw_material_name: 'Raw Material Name',
  total_theoretical_dosage: 'Total theoretical dosage',
  total_actual_usage: 'Total actual usage',
  total_base_unit_qty: 'Basic unit total usage',
  total_assist_unit_qty: 'Assist unit total usage',
  base_unit_qty: 'Basic unit usage',
  total_differential_dosage: 'Total differential usage',
  actual_usage_detail_tip:
    '(You can directly input the total actual usage, and the system will automatically allocate according to the default rules. You can also customize the actual usage by details.)',
  default_allocation_rules: 'Default Allocation Rules',
  automatic_allocation_rules: 'Automatic Allocation Rules',
  automatic_allocation_rules_tip:
    'Allocate according to the theoretical usage ratio of processed products. Example: If the theoretical usage of processed product A is M, the theoretical usage of processed product B is N, and the total actual usage is X, then the actual usage of processed product A=X * M/(M+N); Actual usage of processed product B=X * N/(M+N)',
  completion_date: 'Completion date',
  unfinished: 'Unfinished',
  completed: 'Completed',
  cancel_operation: 'Do you want to cancel the current operation?',
  in_storehouse_cannot_be_empty: 'The warehouse cannot be empty',
  warehouseing_success: 'Storage successful',
  confirm_produce_tip:
    'After confirming production, the processed products are stored in the corresponding warehouse, and the raw materials are released from the corresponding warehouse',
  confirm_produce: 'Confirm production',
  read_produce_storage_order: 'Check the production receipt',
  save_produce_storage_order: 'New production receipt',
  edit_produce_storage_order: 'Edit the production receipt',
  audit_produce_storage_order: 'Review production inventory receipt',
  export_produce_storage_order: 'Export the production receipt',
  print_produce_storage_order: 'Print the production receipt',
  copy_produce_storage_order: 'Copy the production receipt',
  invalid_produce_storage_order_with_order_no: 'Scrap the production receipt[{{orderNo}}]',
  del_produce_storage_order_with_order_no: 'Delete the production inventory entry[{{orderNo}}]',
  audit_produce_storage_order_with_order_no: 'Review production inventory receipt[{{orderNo}}]',
  copy_produce_storage_order_with_order_no: 'Copy the production receipt[{{orderNo}}]',
  create_produce_storage_order_with_order_no: 'Create a production inventory entry[{{orderNo}}]',
  import_produce_storage_order_with_order_no: 'Import the production receipt[{{orderNo}}]',
  export_produce_storage_order_detail_with_order_no:
    'Export the details of the production incoming warehouse order [{{orderNo}}]',
  location_can_not_be_null: 'The store cannot be empty',
  relate_produce_material_order: 'Associated material requisition sheet',
  please_choose_relate_produce_material_order:
    'Please select associated material requisition sheet',
  choose_relate_produce_material_order: 'Select associated material requisition list',
  read_produce_fast_order: 'View quick production order',
  save_produce_fast_order: 'New quick production order',
  edit_produce_fast_order: 'Edit quick production order',
  audit_produce_fast_order: 'Review rapid production order',
  export_produce_fast_order: 'Export quick production order',
  print_produce_fast_order: 'Print quick production orders',
  copy_produce_fast_order: 'Copy quick production order',
  invalid_produce_fast_order_with_order_no: 'Cancel the quick production order[{{orderNo}}]',
  del_produce_fast_order_with_order_no: 'Delete the quick production order[{{orderNo}}]',
  audit_produce_fast_order_with_order_no: 'Review rapid production order[{{orderNo}}]',
  copy_produce_fast_order_with_order_no: 'Copy quick production order[{{orderNo}}]',
  create_produce_fast_order_with_order_no: 'Create a quick production order[{{orderNo}}]',
  import_produce_fast_order_with_order_no: 'Import quick production order[{{orderNo}}]',
  export_produce_fast_order_detail_with_order_no:
    'Export the quick production order [{{orderNo}}] details',
  of_material: 'Raw material',
  finished_product_title: 'Name of finished product',
  material_product_title: 'Name of raw material',
  un_get_location_permission: 'The store information and permissions have not been obtained',
  update_chain_stock_failed: 'Failed to replace the invoicing token. Procedure',
  lack_important_data: 'The jump failed because key data is missing',
  load_finished: 'Complete loading',
  ship_net: 'Transfer network',
  read_ship_net: 'Viewing the delivery network',
  setting_ship_location: 'Set up distribution stores',
  read_ship_location: 'Check the delivery store',
  ship_location_setting: 'Distribution store setup',
  choose_location_setting: 'Select delivery store',
  no_location: 'There is no shop at the moment',
  ship_center_name: 'Distribution center name',
  ship_center: 'Distribution center',
  return_ship_center: 'Return distribution center',
  please_select_ship_center: 'Please select distribution center',
  location_code: 'Store code',
  location_sys_num: 'Store num',
  search_location_name_code: 'Search for store name/code',
  read_chain_stock_setting: 'View invoicing Settings',
  purchase_setting: 'Procurement setup',
  receive_auto_update_cost: 'Automatic maintenance cost of receiving goods',
  goods: 'Goods',
  goods_inventory: 'Goods inventory',
  goods_name: 'Goods name',
  please_input_goods_name: 'Please enter the goods name',
  read_goods_inventory: 'Read goods inventory',
  product_detail: 'Commodity details',
  un_know: 'Unknown',
  sync: 'Synchronization',
  success_import_count: 'Import {{dataCount}} successfully',
  failed_reason: 'Cause of failure',
  task_type: 'Task type',
  apply_time: 'Application time',
  finished_time: 'Completion time',
  task_process: 'Task progress',
  task_state: 'Task status',
  my_account: 'My account number',
  user_center: 'Individual center',
  user_setting: 'Personal setting',
  switch_merchant: 'Switch shop',
  headquarters: '【 Headquarters 】',
  ship: '【 Distribution 】',
  location: '【 Store 】',
  logout: 'Log out',
  task_center: 'Mission center',
  task_center_only_show_15_day_data:
    'The task center displays the data of the last 15 days only. Process the data in a timely manner',
  qty_must_ge_min_order_qty: 'Quantity cannot be less than the minimum order',
  qty_must_double_order_base: 'Quantity must be a multiple of the order base: {{useUnitMul}}',
  please_input_keyword_to_add: 'Please enter keyword add',
  price: 'Unit price',
  base_price: 'Basic unit price',
  base_price_average: 'Basic unit average price',
  base_unit_inventory: 'Basic unit inventory',
  in_out_qty: 'Profit and loss quantity',
  tag_gift: 'Token gift',
  yes: 'Yes',
  no: 'No',
  all_product_type: 'Total commodity category',
  un_choose_location: 'Unselected store',
  choose_location_count: 'Selected stores ({{locationCount}})',
  please_choose_product_variant: 'Please select the product specification',
  search_product: 'Search for goods',
  search_product_series: 'Search product series',
  search_product_title_variant_barcode: 'Search the product name/specification/bar code',
  choose_product_count: 'Selected item ({{productCount}})',
  all_orders_selected: 'All orders for {{locationName}} stores have been selected',
  choose_date: 'Select date',
  clean_choose: 'Clear options',
  filter_produced_produce_plan_order: 'Filter processed production plan sheet',
  have_repeat_product_please_choose_again: 'Duplicate goods already exist, please re-select!',
  no_data: 'No data yet',
  no_data_please_check: 'No data available, please check your query criteria or data source!',
  request_date: 'Date of delivery',
  import_tmpl: 'Import template',
  please_upload_excel: 'Please upload excel',
  only_upload_xls_and_xlsx: 'Only xlsx or xls files can be uploaded',
  only_upload_image: 'Only png, jpg, gif, and bmp files can be uploaded',
  change_file: 'Replacement file',
  add_file: 'Add file',
  or_drag_change: 'Or drag and drop replacement',
  upload_file_change: 'Drag the file here, or',
  download_import_tmpl: 'Download the import template',
  download_import_tmpl_tip: 'Please use the template provided by the system to edit the data',
  reason: 'Cause',
  ship_center_inventory: 'Distribution center inventory',
  today_order_qty: 'Quantity ordered today',
  undelivered_qty: 'Undelivered quantity',
  order_qty: 'Order quantity',
  product_can_not_ship_please_adjust:
    'The following commodities do not meet the distribution attributes of commodities and need to be adjusted as required',
  product_order_audit_error_tip_one:
    'The current time period is not available for ordering. Please place your order within the specified time frame',
  product_order_audit_error_tip_two:
    'The following items are mandatory. Will they be automatically added to the document?',
  product_order_audit_error_tip_three:
    'The following products are mandatory. Do you want to automatically adjust the minimum quantity of goods to be purchased?',
  product_order_audit_error_tip_content:
    'The quantity of goods requested by {{name}} cannot be less than  {{number}} of goods requested',
  current_order_amount_tip: 'Current document amount {{money}} yuan',
  min_order_amount_tip: 'The minimum order amount is {{money}} yuan',
  please_input_keyword: 'Please enter the keyword',
  choose_all: 'select all',
  cancel_all: 'Cancel all',
  location_without_symbol: 'Store',
  location_num: 'Store number',
  keyword_query: 'Keyword query',
  role: 'Role',
  please_choose_role: 'Please select a role',
  super_admin: 'Super administrator',
  all_role: 'All roles',
  move_right_complete_verification: 'Swipe right to complete the verification',
  verification_success: 'Successful verification',
  verification_failed: 'Validation failure',
  safe_storage: 'Security retention',
  please_complete_safe_verification: 'Complete security verification',
  only_upload_jpg_and_png: 'You can upload only JPG or PNG files',
  image_size_lt_2m: 'The picture must be less than 2MB',
  custom_tag: 'Custom tag',
  diff_money: 'Difference money',
  shipping_attribute_copy: 'Shipping attribute copy',
  purchase_attribute_copy: 'Purchase attribute copy',
  today: 'Today',
  yesterday: 'Yesterday',
  week: 'Week',
  last_week: 'Last week',
  current_month: 'Current month',
  last_month: 'Last month',
  current_quarter: 'Current quarter',
  current_year: 'Current year',
  sure_to_delete: 'Sure to delete {{name}} ？',
  price_openly_agreed_upon: 'Price openly agreed upon',
  blind_disc: 'Blind disc',
  hibernate: 'Hibernate',
  eliminate: 'Eliminate',
  stop_purchasing: 'Stop purchasing',
  archive_draft: 'Archive draft',
  inventory_snapshot: 'Inventory snapshot',
  purchase_order_import: 'Import purchase order',
  purchase_order_import_tmpl: 'Import purchase order template',
  import_purchase_order_with_order_no: 'Import purchase order [{{orderNo}}]',
  receive_order_import: 'Import receive order',
  receive_order_import_tmpl: 'Import receive order template',
  import_receive_order_with_order_no: 'Import receive order [{{orderNo}}]',
  return_order_import: 'Import return order',
  return_order_import_tmpl: 'Import return order template',
  import_return_order_with_order_no: 'Import return order [{{orderNo}}]',
  article_0_of_0: 'Article 0 of 0 item',
  default_pangination: '{{first}}-{{second}} of {{third}} items',
  store_delivery_price_import_template: 'Store Delivery Price Import Template',
  store_delivery_price_import: 'Store Delivery Price Import ',
  add_finished_product: 'Add finished product',
  archive_delivery_price: 'Archive delivery price',
  archive_reference_cost_price: 'Archive reference cost price',
  tag_enable: 'Tag enable',
  approval: 'Approval',
  approved: 'Approved',
  approval_success: 'Approval success',
  whether_to_approval_the_document: 'Whether to approval the document[{{orderNo}}]?',
  quantity_must_be_greater_than_0: 'Quantity must be greater than 0',
  product_quantity_cannot_be_0: 'Product quantity cannot be 0',
  the_maximum_quantity_cannot_exceed: 'The maximum quantity cannot exceed',
  the_basic_maximum_quantity_cannot_exceed: 'The basic maximum quantity cannot exceed',
  the_quantity_of_raw_materials_cannot_all_be_0: 'The quantity of raw materials cannot all be 0',
  duplicate_product_already_exists: 'Duplicate product already exists',
  max_price_cannot_exeed: 'The maximum unit price cannot exceed',
  max_amounnt_cannot_exeed: 'The maximum amount cannot exceed',
  amount_calculation_error: 'Amount calculation error',
  read_material: 'Read material',
  loading_products: 'Loading products...',
  continue_to_sale: 'Continuing sales',
  stop_to_sale: 'Stop sales',
  obsolescence_time: 'Obsolescence time',
  last_modification_time: 'Last modification time',
  p_delivery_date: 'Delivery date',
  approval_time: 'Approval time',
  processing_time: 'Processing time',
  prepare_document: 'Prepare document',
  handle: 'Handle',
  document_status: 'Document status',
  status: 'Status',
  applied_store: 'Applied store',
  application_type: 'Application type',
  modifier: 'Modifier',
  modifier_time: 'Modification time',
  operate_type: 'operating mode',
  approver: 'Approver',
  approver_time: 'Approval time',
  processor: 'Processor',
  processor_time: 'Processing time',
  print_times: 'Print times',
  three_times_more: 'More than three times',
  num_times: '{{num}} times',
  application_remarks: 'Application remarks',
  reply_note: 'Reply note',
  attachments: 'Attachments',
  number_of_attachments: 'Number of attachments',
  return_reason: 'Reason for return',
  business_store: 'Business store',
  reply_money: 'Amount of approval',
  unit: 'Unit',
  storehouse_num: 'Pull up the ticket number',
  please_enter_storehouse_num: 'Please select Import Warehouse',
  please_select_storehouse: 'Please select Warehouse',
  no_storehouse_available: 'No warehouse available',
  location_replenishment: 'Location replenishment',
  store_not_bound: 'Store not bound',
  shipping_warehouse: 'Shipping warehouse',
  transfer_out_of_warehouse: 'Roll-out warehouse',
  please_select_transfer_out_of_warehouse: 'Please select roll-out warehouse',
  roll_out_memo: 'Roll-out memo',
  transfer_to_memo: 'Transfer to memo',
  transfer_in_of_warehouse: 'Transfer to warehouse',
  please_select_transfer_in_of_warehouse: 'Please select transfer to warehouse',
  call_in_store: 'Transfer to store',
  call_out_store: 'Transfer out of store',
  summary_by_product: 'Summary by Product',
  summary_by_store: 'Summary by Store',
  summary_by_store_product: 'Summary by store product',
  summarize_by_order_number: 'Summarize by Order Number',
  summarize_by_order_product_detail: 'Summarize by order product detail',
  summarize_by_business_day: 'Summary by store item business day',
  commodity_code: 'Ommodity code',
  transit_quantity: 'In transit quantity',
  generate_transfer_store_out_order: 'Generate transfer out store transfer in order',
  generate_transfer_store_in_form: 'Generate transfer in store transfer in form',
  relate_transfer_out_order: 'Related Transfer Out Order',
  outbound_tracking_number: 'Please select the outbound tracking number',
  goods_in_transit: 'Goods in transit',
  batch_review: 'Batch review',
  operation_successful: 'Operation successful',
  check_that_out_unapproved_in_order:
    'Please check that a total of unapproved inbound orders generated from the same outbound order have been successfully generated {{num}} receipt',
  read_goods_in_transit: 'Read goods in transit',
  operation_after_sold_out: 'Operation after selling out',
  code_input: 'Code、name',
  store_code: 'Store code',
  store_name: 'Store name',
  please_enter_store_code: 'Please enter the warehouse code',
  please_enter_contact: 'Please enter the contact person',
  please_enter_store_name: 'Please enter the warehouse name',
  please_enter_contract_phone: 'Please enter the contact phone number',
  please_enter_address: 'Please enter the address',
  please_enter_remark: 'Please enter the remark',
  please_input_english_name: 'Please enter the English_name',
  please_input_item_barcode: 'Please enter the item barcode',
  please_input_abbreviation_code: 'Please enter the shorthand code',
  please_input_variant: 'Please enter the specifications',
  please_select_brand_name: 'Please select the brand name of the item',
  please_input_place_of_origin: 'Please enter the place of origin',
  please_select_cost_accounting_method: 'Please choose a cost accounting method',
  please_select_use_unit: 'Please select common units',
  please_input_purchase_price: 'Please enter the purchase price',
  only_number_letter_and_chinese_character: 'Can only input Chinese/number/letter combinations',
  only_query_not_generated_transfer_out:
    'Query only items that have not generated transfer out order',
  please_input_code_or_name: 'Please enter a code or name',
  auto_generate_category_code: 'Automatically generate category codes',
  enable: 'Enable',
  default_store: 'Default store',
  distribution_store: 'Distribution Store',
  produce_room: 'Produce Room',
  default_belonging_store: 'Default warehouse ownership',
  distribution_processing_room: 'Distribution produce Room',
  by_request_order: '(Separate orders according to the demand list)',
  contract_phone: 'Contract phone',
  address: 'Address',
  last_modified_by: 'Last modified by',
  remark: 'Remark',
  store_info: 'Store Info',
  contact_info: 'Contact Info',
  save_request_store: 'Add Store Information',
  belonging_store: 'Belonging Store',
  store_attributes: 'Organizational Attributes',
  belonging_store_not_empty: 'Belonging Store cannot be empty!',
  edit_request_store: 'Edit Store',
  code_input_brand: 'Code Name Abbreviation Code',
  barnd_code: 'Barnd Code',
  brand_name: 'Brand Name',
  bar_code: 'Bar code',
  please_input_bar_code: 'Please enter barcode',
  brand_abbreviation_code: 'Brand Abbreviation Code',
  edit_request_brand: 'Edit Request Brand',
  save_request_brand: 'Add Request Brand',
  brand_name_title: 'Brand Name',
  product_category: 'Product Category',
  all_product_category: 'ALL Product Category',
  category_management: 'Category  Name',
  barnd_manage: 'Brand Manage',
  parent_class: 'Parent Class',
  category_code: 'Category  Code',
  please_input_category_code: 'Please Input Category Code',
  category_name: 'Category Name',
  please_input_category_name: 'Please Input Category Name',
  please_input_brand_code: 'Please Input Brand Code',
  please_input_brand_name: 'Please Input Brand Name',
  document_setting: 'Brand Setting',
  product_document: 'Product Document',
  supplier_document: 'Supplier Document',
  supplier_code_customized: 'Supplier Code Customized',
  supplier_code_customized_tip:
    'Uncheck the application system default rules: prefix KS, plus a 3-digit auto-increasing integer, such as KS001, KS002',
  store_document: 'Store Document',
  stock_code_customized: 'Stock Code Customized',
  stock_code_customized_tip:
    'Uncheck the application system default rules: prefix CK, plus a 3-digit self-increasing integer, such as CK001, CK002',
  store: 'Store',
  no_warehouse_available: 'No warehouse available',
  delivery_warehouse: 'Delivery warehouse',
  please_delivery_warehouse: 'Please Select Delivery Warehouse',
  batch_selection_of_delivery_warehouse: 'Batch selection of delivery warehouse',
  receive_warehouse: 'Receiving warehouse',
  please_receive_warehouse: 'Please Select Receiving warehouse',
  return_warehouse: 'Return Warehouse',
  please_return_warehouse: 'Please Select Return Warehouse',
  inventory_warehouse: 'Inventory warehouse',
  please_inventory_warehouse: 'Please select Inventory warehouse',
  transfer_out_warehouse: 'Transfer out of warehouse',
  please_transfer_out_warehouse: 'Please select Call out warehouse',
  adjust_warehouse: 'Adjust warehouse',
  please_adjust_warehouse: 'Please Select Adjust warehouse',
  inventory_quantity: 'Inventory quantity',
  current_inventory_quantity: 'Current inventory quantity',
  remove_current_inventory_quantity_zero: 'Removes items with the current inventory number of 0',
  set_current_inventory_quantity: 'Quantity is set to the current inventory',
  not_zero_current_inventory: 'None The current inventory number is 0!',
  zero_inventory_remove_tip:
    'There are {{number}} items with the current inventory number of 0. Confirm whether to remove them from the current list',
  check_product_set_current_inventory_quantity:
    'Counting the items on hand sets the current inventory count.',
  set_current_inventory_quantity_tip:
    'Counting the items resulted in {{number}} items. Did you set the actual count of the items not included in the inventory count to the current inventory number?',
  origin_cost_price: 'Origin Cost Price',
  current_cost_price: 'Current Cost Price',
  origin_base_price: 'Origin Base Price',
  current_base_price: 'Current Base Price',
  stock_cost_diff_money: 'Diff Money',
  please_enter_inventory_quantity: 'Please enter inventory quantity',
  inventory_amount: 'Inventory amount',
  auto_generate_item_code: 'Auto generate item code',
  barcode_digits: 'Barcode Digits',
  prefix_usage: 'Prefix Usage',
  auto_generate_sku: 'Auto Generate SKU',
  sku_digits: 'SKU Digits',
  fixed_prefix: 'Fixed Prefix',
  current_category_code: 'Current Category Code',
  top_level_category_code: 'Top Level Category Code',
  none: 'None',
  front: 'Front',
  back: 'Back',
  position: 'Position',
  position2: 'Position',
  auto_generate_warehouse_code: 'Auto Generate Warehouse Code',
  current_store_inventory: 'Current store inventory',
  fixed_prefix_usage: 'Fixed Prefix Usage',
  code_length: 'Code Length',
  product_category_import: 'Product Category Import',
  brand_import: 'Brand Import',
  dimension: 'Dimension',
  inventory_product_input: 'Name、sku、shorthand code、item code',
  product_input: 'Item code, sku, barcode, shorthand code, name, ID',
  sales_management: 'Sales Management',
  normal: 'Normal',
  item_name: 'Item Name',
  item_variant_name: 'Item specification name',
  item_category: 'Item Category',
  top_item_category: 'Item Top Category',
  select_item: 'Select Category',
  please_item_category: 'Please select item category',
  item_sku: 'Item Barcode',
  abbreviation_code: 'Abbreviation Code',
  sku: 'SKU',
  purchase_price: 'Purchase Price',
  delivery_price: 'Delivery Price',
  validity_Period: 'Validity Period',
  primary_Supplier: 'Primary Supplier',
  date_item: 'Creation Date',
  item_id: 'Item ID',
  item_export: 'Item Export',
  english_name: 'English Name',
  sku_code: 'SKU (Item Code)',
  place_of_origin: 'Place of Origin',
  cost_accounting_method: 'Cost Accounting Method',
  quality_guarantee_period_tip:
    'Used for printing labels on processed products, the shelf life is calculated based on 24 hours per day',
  weighted_average: 'Weighted Average',
  unit_of_Measurement: 'Unit of Measurement',
  price_attribute: 'Price Attribute',
  reference_cost: 'Reference Cost',
  other_attributes: 'Other Attributes',
  multiple_codes: 'Multiple Codes for One Product',
  press_enter_key: 'Press Enter key or comma to add options',
  item_image: 'Item Image',
  please_select_item_category: 'Please select item category',
  upload_item_image: 'Upload Item Image',
  business_item_image_upload_rule:
    'Only supports four formats: gif, jpeg, png, and bmp. Recommended pixel size is 800 * 800, with a maximum size of 10MB. Only single image upload for each item is required.',
  call_in_status: 'Call in status',
  not_transferred_in: 'Not transferred in',
  partial_transfer_in: 'Partial transfer in',
  all_transfer_in: 'All transfer in',
  warehouse: 'warehouse',
  item_classification: 'Item classification',
  purchase_receipt_details: 'Purchase receipt details',
  purchase_return_details: 'Purchase return details',
  summary_purchasing_stores: 'Summary of Purchasing Stores',
  return_store_name: 'Return store name',
  return_unit_price: 'Return unit price',
  return_gift_number: 'Quantity of returned gifts',
  return_gift_amount: 'Return gift amount',
  cost_unit_price: 'Cost unit price',
  goods_barcode: 'Item barcode',
  goods_title: 'Item Name',
  top_tier_categories: 'Top tier categories',
  received_quantity: 'Received quantity',
  receipt_unit_price: 'Receipt unit price',
  receipt_amount: 'Receipt amount',
  gift_unit: 'Gift unit',
  gift_quantity: 'Gift quantity',
  gift_amount: 'Gift amount',
  conversio_rate: 'Conversion rate',
  return_quantity: 'Return quantity',
  return_amount: 'Return amount',
  goods_input_placeholder: 'Goods name, mnemonic code, item barcode, sku',
  base_unit_num: 'Number of basic units',
  sub_total_num: 'Subtotal num',
  sub_total_amount: 'Subtotal amount',
  del_request_store_with_store_no: 'Delete Request Order [{{storehouse_num}}]',
  read_store: 'Read Store',
  store_del_confirm_is: 'Confirm deletion of selected warehouses?',
  create_brand_reason_with_no: 'Create Brand Reason With No[{{name}}]',
  edit_brand_reason_with_no: 'Edit Brand Reason With No[{{reasonName}}]',
  read_request_brand: 'Read Request Brand',
  edit_settings: 'Edit Settings',
  read_request_category: 'Read Request Category',
  create_category_with_no: 'Create Category With No[{{name}}]',
  edit_category_with_order_no: 'Edit Category With No[{{name}}]',
  category_del_confirm_is: 'Category Del Confirm Is?',
  brand_del_confirm_is: 'Brand Del Confirm Is?',
  del_request_brand_with_id: 'Del Request Brand With Id[{{id}}]',
  psi_unit: 'Ordering unit',
  transfer_unit: 'Transfer Unit',
  assist_unit: 'Auxiliary unit',
  assist_unit_qty: 'Auxiliary unit quantity',
  please_select_assist_unit: 'Please select an auxiliary unit',
  rate: 'Conversion ratio',
  chain_unit: 'Orderable units',
  set_multiple_unit: 'Set up multiple units',
  set_assist_unit: 'Set auxiliary units',
  assist_unit_scene: `Auxiliary unit usage scenario: Common in the fresh food industry, ordering by quantity unit and settlement by weighing unit. For example: fish, 10 [{{currency_suffix}}]/kg, order per piece, settlement price=weight x unit price`,
  please_select_sub_unit_1: 'Please select sub unit 1',
  please_input_sub_unit_1_rate: 'Please enter the conversion rate for sub unit 1',
  sub_unit_1_more_than_zero: 'The conversion rate of sub unit 1 should be greater than 0',
  please_select_sub_unit_2: 'Please select sub unit 2',
  please_input_sub_unit_2_rate: 'Please enter the conversion rate for sub unit 2',
  sub_unit_2_more_than_zero: 'The conversion rate of sub unit 2 should be greater than 0',
  sub_unit_2_rate_more_than_zero_sub_unit_1:
    'The conversion ratio of sub unit 2 needs to be greater than that of sub unit 1',
  please_select_base_unit: 'Please select the base unit',
  please_input_assist_unit_rate: 'Please enter auxiliary unit conversion rate',
  assist_unit_rate_more_than_zero: 'Auxiliary unit conversion rate should be greater than 0',
  the_unit_is_already_selected_by_others:
    'This unit has already been selected by others, please reselect it！',
  sub_unit_1: 'Deputy unit 1',
  please_select_sub_unit: 'Please select a sub unit',
  rate_over_zero: 'Conversion ratio greater than 0',
  sub_unit_2: 'Deputy Unit 2',
  settings_desc:
    'The standard product barcode consists of 13 digits starting with 69, and it is recommended to use a barcode length of 13 digits.',
  add_category: 'Add Primary Category',
  add_Subcategory: 'Add Subcategory',
  edit_request_category: 'Edit Category',
  save_request_category: 'Save Category',
  del_request_product_with_no: 'Del Request Product With No[{{id}}]',
  product_confirm_is:
    'Deleted items cannot be recovered. Do you want to confirm the deletion? Note: After the item is deleted, the item in the store will also be deleted.',
  product_delete_confirm_tip: 'Whether to delete the item?',
  whether_to_delete_the_selected_item: 'Whether to delete the selected item',
  code_store: 'Code Store',
  save_store: 'Save Store[{{name}}]',
  export_transfer_out_store: 'Export Transfer Out Store',
  not_allowed_purchase:
    'Not allowed for purchase, this item will not be displayed in the purchasing process.',
  not_allowed_requisition:
    'Not allowed for requisition, this item will not be displayed in the requisition process.',
  not_allowed_create_business_documents:
    'Not allowed for create business documents, the supply chain document cannot add this item.',
  involved_sales:
    'When checked, the item, which is also a commodity, can be directly involved in retail sales.',
  to_add: '去新增',
  unit_settings: 'Unit Settings',
  create_product_with_name: 'Create Product With Name{{name}}',
  copy_create_product_with_name: 'Copy Create Product With Name{{name}}',
  edit_product_with_name: 'Edit Product With Name{{name}}',
  please_input_purse: 'Please enter the Purse',
  please_input_reference_cost: 'Please Input Reference Cost',
  save_settings: 'Save Settings',
  please_item_cost: 'Please Item cost',
  sub_unit2_greater_than_sub_unit1: 'Conversion ratio of Sub-unit 1 should be less than Sub-unit 2',
  summaries: 'Summaries',
  please_select_summaries: 'Please Select Summaries',
  entry_exit_details: 'Entry Exit Details',
  in_out_type: 'In out type',
  in_stock_type: 'In stock type',
  out_stock_type: 'Out stock type',
  read_entry_exit_details: 'Read Entry Exit Details',
  operate_time: 'Operating Time',
  quantity_before_adjustments: 'Quantity before adjustments',
  quantity_adjustments: 'Quantity adjustments',
  quantity_after_adjustments: 'Quantity after adjustments',
  operator: 'Operator',
  price_after_adjustments: 'Price after adjustments',
  summaries_details: 'Summaries details',
  inventory_in_storehouse: 'Inventory in storehouse',
  inventory_out_storehouse: 'Inventory out storehouse',
  please_choose_inventory_in_warehouse: 'Please choose inventory in warehouse',
  please_choose_inventory_out_warehouse: 'Please choose inventory out warehouse',
  sub_unit2_not_equals_sub_unit1: 'Sub-unit Cannot Be The Same As The Base Unit',
  please_input_multiple_codes: 'Please Input Multiple Codes',
  edit_store: 'Edit Store[{{name}}]',
  please_input_unit: 'Please Input Unit',
  summary_details: 'Summary details of procurement',
  item_can_not_be_empty: 'Item name cannot be empty',
  summary_detail_goods_input_placeholder: 'Goods name, item barcode, sku',
  product_export: 'Product Export',
  batch_edit: 'Batch Edit',
  please_select_one_row: 'Please Select One Row',
  product_import_tmpl: 'Item File Import Template',
  please_select_item_brand: 'Please Select Item Brand',
  import_product_document_prop: 'Import Item Profile Attributes',
  batch_edit_document: 'Batch Edit Document',
  export_transfer_out_document: 'Export Transfer Out Document',
  please_input_barcode_length: 'Please Input Barcode Length',
  please_input_sku_length: 'Please Input sku Length',
  production_department: 'Production Department',
  search_production_department: 'Search Production Department',
  business_default_unit: 'Business Default Unit',
  allow_selection_of_unit: 'Allow selection of non-default units when manually creating documents',
  as_the_unit_displayed:
    'As the unit displayed by default on the page when users manually create business documents, other units can be selected in the business.',
  simple_category: 'Simple Category',
  sale_tracked_inventory: 'Sales deduction inventory',
  headquarters_price: 'Headquarters price',
  estimated_cost: 'Estimated cost',
  query_by_finished_product_title_shorthand_character:
    'Search based on the product name and initial letter of Pinyin',
  sort: 'Sort',
  create_at_desc: 'Creation time（New-Old）',
  create_at_asc: 'Creation time（Old-New）',
  trade_name_asc: 'Trade name（A-Z）',
  trade_name_desc: 'Trade name（Z-A）',
  please_select_product_category: 'Please Select Product Category',
  read_formula_manage: 'View Recipe Management',
  not_query_formula_manage: 'No recipe management found',
  formula_manage_export: 'Recipe Management Export',
  formula_manage: 'Formula manage',
  operate_tips_del_finished_product: 'Confirm to delete finished product {{title}} ?',
  delete_finished_product: 'Delete finished product{{title}}',
  formula_import: 'Recipe import',
  formula_import_template: 'Recipe Import Template',
  document_length: 'Document Length',
  add_first_level_classification: 'Add First Level Classification',
  category_del_confirm_move:
    'It was found that there are items in use under this category. After deleting the category, these items will be moved to?',
  choose_category: 'Choose Category',
  category_del_confirm_input:
    'Confirm to delete this category, please enter the category name "#category name"',
  confirm_delete: 'Confirm Delete',
  category_parent: 'Category Parent',
  please_select_category_parent: 'Please Select Category Parent',
  collapse_all_categories: 'Collapse All Categories',
  expand_all_categories: 'Expand All Categories',
  please_input_item_category_name:
    'The entered name is inconsistent with the name of the category selected for deletion, please re-enter it.',
  sort_category: 'Sort Categories',
  del_request_category_with_name: 'Del Category [{{title}}]',
  move_success: 'Move Success',
  create_new_recipe: 'Create New Recipe',
  edit_new_recipe: 'Edit New Recipe',
  recipe_title: '配方名称',
  please_enter_recipe_name: 'Please enter recipe name',
  reference_cost_tooltip:
    'That is, the theoretical stock price of each base unit of an item, which can be used for theoretical cost statistics of items.',
  other_cost: 'Other Cost',
  total_cost: 'Total cost',
  total_cost_tip: 'Total cost = reference cost + other costs',
  input_memo_and_max_length_50: 'Please enter a note, no more than 50 words',
  price_tip: 'Value rule: Average inventory price>Archive cost price',
  money_tip: 'Actual raw material usage, outbound cost amount',
  location_process_order: 'Store processing order',
  process_order_no: 'Processing Order Number',
  processing_location: 'Processing store',
  processing_storehouse: 'Processing warehouse',
  processing_date: 'Processing date',
  invalid_location_process_order_with_order_no: 'Invalid store processing order [{{orderNo}}]',
  read_location_process_order: 'Read store processing orders',
  save_location_process_order: 'Add store processing orders',
  delete_location_process_order: 'Delete store processing orders',
  edit_location_process_order: 'Edit store processing orders',
  audit_location_process_order: 'Review store processing orders',
  production_board: 'Production bulletin board',
  processing_room_task_dashboard: 'Processing Room Task Dashboard',
  full_screen: 'Full screen display',
  exit_full_screen: 'Exit Full Screen',
  processing_room_task_dashboard_data: 'Daily Task Statistics Dashboard for Processing Room',
  production_board_tip:
    'Production Kanban is a centralized process for production planning documents, which includes material requisition and production of processed products',
  generate_material_order: 'Generate Material Requisition Form',
  stop_production: 'Termination of production',
  stop_production_tip: 'Cannot terminate terminated processed products, please select again',
  cancel_termination: 'Cancel termination',
  cancel_termination_tip:
    'Only terminated processed products can be cancelled. Please select again',
  terminated: 'Terminated',
  single_generate: 'Single item material requisition',
  summary_generate: 'Summarize material requisition',
  process_status: 'Processing status',
  generate_status: 'Material requisition status',
  generated_inventory: 'Generated inventory',
  ungenerated_inventory: 'Not generated for storage',
  generate_picking: 'Material requisition has been generated',
  ungenerate_picking: 'No material requisition generated',
  generate_processing_order: 'Generate processing order',
  inventory_quantity_already_received: 'Inventory quantity already received',
  actual_production_volume: 'Actual production volume',
  processed_products_management: 'Processed product management',
  storage_conditions: 'Storage conditions',
  product_description: 'Product description',
  usage: 'Usage',
  precautions: 'Precautions',
  contact_information: 'Contact information',
  product_standard_code: 'Product standard code',
  production_license_code: 'Production license code',
  select_processed_products: 'Select processed products',
  belong_formula: 'Belonging formula',
  please_choose_produce_room: 'Please select a processing room',
  add_processed_product: 'Newly added products',
  occupied_by_formula: 'Processed products are occupied by formula [{{name}}]',
  please_choose_processed_products: 'Please select the processed product to be deleted',
  add_processed_product_confirm:
    '{{num}} processed products already belong to other processing rooms and are not available. Should it be removed?',
  edit_processed_product: 'Edit processed products',
  export_processed_product: 'Export processed products',
  no_produce_room_to_use: 'There are currently no available processing rooms available',
  delete_processed_product: 'Delete processed products',
  delete_processed_product_tip: 'The following processed products cannot be deleted!',
  delete_processed_product_confirm:
    'After deletion, processing orders that have already used the item will not be able to be approved. Are you sure to delete?',
  set_process_product: 'Untreated processed products: {{num}} pieces',
  set_formula: 'Recipe not enabled: {{num}}',
  set_a_recipe: 'Do you want to set a recipe',
  produce_production_order_no: 'Production Material Requisition Number',
  processed_products: 'Processed_products',
  please_choose_processed_product_greater_than_zero:
    'Only select processed products that require a production volume greater than 0',
  raw_materials: 'Raw Materials',
  processed_product_barcode: 'Processed product barcode',
  processed_product_title: 'Processed product title',
  planned_processing_volume: 'Planned processing volume',
  actual_processing_volume: 'Actual processing volume',
  ratio: 'Ratio',
  production_quantity: 'Production quantity',
  consumption_unit: 'Consumption unit',
  net_material_quantity: 'Net material quantity',
  net_material_rate: 'Net material rate',
  reference_unit_price: 'Reference unit price',
  recipe_code: 'Recipe code',
  creator: 'Creator',
  creator_time: 'Creator time',
  last_edited_time: 'last edited time',
  recipe_information: 'Recipe information',
  search_finished_product: 'Search Finished product',
  enable_confirm: 'Enable',
  disable: 'Disable',
  cost_unit_tip: 'The unit of resources consumed when making dishes',
  net_material_quantity_tip:
    'Refers to the quantity of usable parts of raw materials after initial processing',
  net_material_rate_tip:
    'It refers to the ratio of the available weight of raw materials after preliminary processing to the total weight before processing.',
  gross_profit_tip:
    'Refers to the gross weight of unprocessed raw materials, gross material amount = net material amount ÷ net material rate',
  reference_unit_price_tip:
    'The unit price of raw materials is the average inventory price of the warehouse to which the processed products belong, and will change dynamically.',
  consumption_unit_tip: 'The unit of raw materials consumed when making dishes',
  consumption_unit_price_tip:
    'Refers to the price per unit of consumption of an item, where the unit price of consumption is equal to the unit price of consumption of the item in the item file. Here is the theoretical cost, which is actually deducted based on the average inventory price',
  category_move_confirm_is: 'Confirm mobile classification?',
  category_move_confirm_levle: 'You can only move between nodes at the same level!',
  create_time: 'Create Ttime',
  allow_non_fefault_unit: 'Allow selection of non-default units when manually creating documents',
  purchasing_unit: 'Purchasing unit',
  distribution_unit: 'Distribution unit',
  stock_keeping_unit: 'Stock keeping unit',
  business_default_unit_tip:
    'As the unit displayed by default on the page when users manually create business documents, other units can be selected in the business.',
  unit_conversion_rate: 'Unit conversion rate',
  coust_unit: 'Consumption unit price (yuan)',
  coust_unit_tip:
    'That is, the price per consumed unit of the item, consumption unit price = reference cost/consumption unit conversion value',
  unit_tip: 'No conversion required for basic units',
  automatically_calculated: 'Automatically calculated',
  can_setting_cost_card: 'Stores can set up item cost cards',
  can_setting_cost_card_tip:
    'When not enabled, the store perspective can only see the cost cards set and issued by the headquarters, and cannot be edited; When enabled, the store perspective can not only see the cost cards set and issued by the headquarters, but also edit them based on the headquarters cost card. If the headquarters has not set a cost card, the store can directly set it. In addition, the store can also import cost cards;',
  standard_cost_card: 'Standard Product Cost Card',
  mall_cost_card: 'Mall Product Cost Card',
  cost_card_manage: 'Cost card management',
  import_cost_card: 'Import cost card',
  export_cost_card: 'Export cost card',
  cost_card: 'Cost card',
  cost_card_info: 'Cost card info',
  commodity_info: 'Commodity info',
  configuration_cost_card: 'Configuration cost card',
  commodity_info_placeholder: 'Product number/shorthand code/name',
  product_info_placeholder: 'Item name/code/shorthand code',
  product_id: 'Product ID',
  reset: 'Reset',
  cost_card_issuance: 'Cost card issuance',
  issuance_location_manage: 'Manage and distribute stores',
  issuance_location_tip: 'Are you sure you want to withdraw the selected store?',
  withdraw: 'Withdrawal',
  withdraw_success: 'Withdrawal successful',
  replace_cost_card_search_tip: 'Please enter the item above for cost card inquiry first',
  choose_cost_card: 'Select cost card',
  cost_card_issuance_tips:
    'The data issued by the headquarters to the stores will not be affected if the stores are self built. Cost card production warehouse is the default warehouse',
  batch_replacement_of_items: 'Batch replacement of items',
  batch_import: 'Batch import',
  batch_export: 'Batch export',
  batch_deletion: 'Batch deletion',
  distribution_management: 'Distribution Management',
  cost_card_import_tips_first:
    'The limit for each import of items should be less than 5000, the limit for products should be less than 1000, and only. xlsx format files can be uploaded if the file size is less than 3M',
  cost_card_import_tips_second:
    'Please modify according to the error prompt until the import is successful',
  batch_import_of_cost_cards: 'Batch import of cost cards',
  cost_card_import_tmpl: 'Cost Card Import Template',
  product_code: 'Article number',
  product_name: 'Product Name',
  product_variant_name: 'Form name',
  product_classify: 'Product classification',
  sales_unit: 'Sales unit',
  sales_price: 'Sales price (yuan)',
  membership_price: 'Membership price (yuan)',
  cost_price_yuan: 'Cost price (yuan)',
  add_cost_card: 'Add cost card',
  cost_card_confirm:
    'Are you sure you want to delete this cost card? After deletion, it cannot be restored. Please operate with caution!',
  cost_price_yuan_tip: 'Cost price=item cost+other costs',
  classify_all: 'Classify All',
  view_cost_card: 'View cost card',
  confirm_issuance: 'Confirm issuance',
  cost_card_id: 'Cost card number',
  cost_card_name: 'Cost Card Name',
  number_of_associated_dishes: 'Number of associated dishes',
  associated_dishes: 'Associated dishes',
  abnormal_association: 'Abnormal association',
  items_before_replacement: 'Items before replacement',
  batch_replacement_of_items_tips:
    'This function can be used to replace a certain item in the cost card with a new item in bulk. Please select the item to be replaced first',
  consumption: 'Consumption',
  consumption_unit_price: 'Consumption unit price (yuan)',
  consumption_amount: 'Consumption amount (yuan)',
  consumption_amount_tip: 'Consumption amount=Consumption unit price x Raw material quantity',
  basic_unit_gross_profit_quantity: 'Basic unit of raw material quantity',
  find_cost_card: 'Find the corresponding cost card',
  items_after_replacement: 'Replacement item',
  choose_items_after_replacement: 'Select replacement item',
  affects_the_number_of_dishes: 'Affects the number of dishes',
  individual: 'Individual',
  selected_cost_card: 'Selected cost card',
  replacing_institutions: 'Replacing institutions',
  return_to_modification: 'Return to modification',
  location_count: 'Number of stores distributed',
  issuing_operation_time: 'Issuing operation time',
  effective_date_of_issuance: 'Effective date of issuance',
  please_enter_operator: 'Please enter the operator',
  all_successful: 'All successful',
  all_failed: 'All failed',
  partial_failure: 'Partial failure',
  in_progress: 'In progress',
  select_institution: 'Select Institution',
  additional_cost_card: 'Add cost card',
  edit_cost_card: 'Edit cost card',
  copy_cost_card: 'Copy cost card',
  cost_card_code: 'Cost card code',
  s_price: 'Price',
  yuan: 'Yuan',
  product_cost: 'Cost of goods',
  cost_card_type: 'Cost card type',
  the_first_associated_product_by_default:
    'Fill in the name of the first associated product by default',
  add_product_tootip: 'Item cost=sum of all item consumption amounts',
  total_cost_tootip: 'The total cost of a single item, value=total item cost+other costs',
  add_associated_products: 'Add associated products',
  associated_products: 'Associated products',
  product_codes: 'Product code',
  selected: 'Selected',
  gross_profit_rate_tootip: 'Gross profit margin=(selling price - cost price)/selling price',
  associated_with_a_cost_card: 'Is it associated with a cost card',
  standard_products: 'Standard products',
  mall_products: 'Mall products',
  all_associated_products: 'Associated products',
  distribution_status: 'Distribution status',
  distribution_location: 'Distribution location',
  distribution_location2: 'Distribution location',
  replace_result: 'Replace result',
  got_it: 'Got it',
  please_select_cost_card: 'Please select the cost card that needs to be issued',
  del_cost_card_with_no: 'Delete cost card [{{id}}]',
  gross_profit_error: 'The selling price cannot be less than the cost price',
  commodity_type: 'Product type',
  choose_commodity_count: 'Selected item ({{productCount}})',
  please_input_product_code: 'Please input product code',
  management_type: 'Statistics',
  please_select_management_type: 'Please select management type',
  finished_product: 'Finished product',
  semi_finished_product: 'Semi-finished products',
  raw_material: 'Raw material',
  Consumables: 'Consumables',
  yield: 'Yield',
  theoretical_consumption: 'Theoretical consumption',
  theoretical_consumption_amount: 'Theoretical consumption amount',
  actual_consumption: 'Actual consumption',
  actual_amount_consumed: 'Actual amount consumed',
  number_of_differences: 'Number of differences',
  fixed_assets: 'Fixed assets',
  please_input_number: 'Please input number',
  custom_item_code: 'Custom item code',
  code_number: 'Number of coding digits',
  custom_item_code_tip:
    'Uncheck the application system default rules: adjacent WP, add a 4-digit auto-increasing integer, such as WP0001, WP0002',
  please_input_code_length: 'Please input code length',
  Purchase_prices: 'Purchase prices',
  Purchase_barcode: 'Purchase barcode',
  Purchase_barcode_tip:
    "'Purchase unit price: The default price when adding a purchase order and receiving a goods order. <br/>Value order: the agreed price corresponding to the supply of the supplier relationship>the supplier's latest purchase price>the item file purchase unit price>the file cost price'",
  please_input_purchase_prices: 'Please enter the purchase unit price (yuan)',
  please_input_purchase_code: 'Please enter the purchase barcode',
  cost_card_name_empty: 'Cost card name cannot be empty',
  please_add_associated_products: 'Please add associated products',
  successfully_issued: 'Successfully issued',
  cannot_become_the_child_of_the_party: 'Cannot become the child node of the other party',
  current_institution: 'Current institution',
  please_select_the_item_after_replacement: 'Please select the item after replacement',
  please_select_the_consumption_unit: 'Please select the consumption unit',
  please_use_template: 'Please use the template provided by the system to edit data',
  click_upload: 'Click to upload',
  please_use_template_tip:
    'The number of imported items each time should be less than 5,000, and the file size should be less than 3M.',
  please_use_template_desc: 'Only supports: .XLS, .XLSX format files',
  drag_file: 'Drag files here, or',
  start_importing: 'Start importing',
  template_content_verification: 'Template content verification:',
  repeat_comparison: 'Repeat comparison:',
  override_import: 'Override import',
  enable_data_import:
    'Once turned on, existing data will be overwritten, and the content imported this time shall prevail.',
  base_unit_update:
    'The base unit, default business unit and conversion rate do not support modification and cannot be overwritten.',
  confirm_import: 'Confirm import',
  re_upload: 'Re upload',
  download_verification_results: 'Download verification results',
  you_can_click: 'You can click',
  view_data: 'View and modify problematic data',
  skip_data: 'Or skip the questions and import directly',
  please_input_item_code: 'Please input item code',
  add_up_to_10_units: 'Add up to 10 units',
  only_number_greater_than_0: 'Only numbers greater than 0 are supported',
  sales_manage_confirm_is:
    'Whether to enable sales management, after enabling it, the product can be sold',
  sales_item_move: 'Third-party products cannot be moved',
  sales_item_export: 'Third-party products cannot be imported',
  source: 'Source',
  third_classification: 'Third-party item classification',
  material_classification: 'MATERIAL item classification',
  packageackage_products: 'Package products',
  add_raw_materials: 'Add raw materials',
  add_processed_products: 'Add processed products',
  add_processed_products_tip:
    '(Only display processed products that have not yet created formulas in the current processing room)',
  summary_of_items_procured: 'Summary of items procured',
  enquiry_unit: 'Enquiry Unit',
  recent_purchase_price: 'Recent purchase price',
  number_of_gifts_received: 'Number of gifts received',
  price_of_gifts_received: 'Price of gifts received',
  classification_not_allowed_created:
    'The system has built-in classification names and duplicate creation is not allowed.',
  please_input_net_material_quantity: 'Please Input Net Material Quantity',
  please_input_net_material_rate: 'Please Input Net Material Rate',
  please_input_consumption_unit: 'Please Input Net Consumption Unit',
  choose_raw_materials: 'When choosing raw materials, you need to first choose processed products',
  read_stock_change_statistics: 'Read stock statistics of change',
  stock_change_statistics: 'Stock statistics of change',
  category_summary: 'Category summary',
  purchase_unit: 'Purchase unit',
  inventory_unit: 'Inventory unit',
  none_inventory: 'None inventory',
  have_inventory_transfer_record: 'Have inventory transfer records',
  deleted: 'Deleted',
  base_info2: 'Base info',
  other_info: 'Other info',
  top_level_category: 'Top level category',
  last_time_inventory: 'Last time inventory',
  purchase_return: 'Purchase return',
  reception_sales: 'Reception sales',
  inventory_cost_adjustment: 'Inventory cost adjustment',
  inventory_in_adjustment_reason: 'Inventory in adjustment reason',
  inventory_out_adjustment_reason: 'Inventory out adjustment reason',
  inventory_report_overflow: 'Inventory report overflow',
  inventory_loss_reporting: 'Inventory loss reporting',
  transfer_warehouse_entry: 'Transfer warehouse entry',
  transfer_warehouse_out: 'Transfer warehouse out',
  transfer_warehouse_date: 'Transfer warehouse date',
  material_requisition_out: 'Material requisition out',
  finished_product_warehousing: 'Finished product warehousing',
  current_time_inventory_in: 'Current time inventory in',
  current_time_inventory_out: 'Current time inventory out',
  current_time_inventory_balance: 'Current time inventory balance',
  export_stock_change_statistics: 'Export stock statistics of change',
  create_unit: 'Create unit',
  unit_name: 'Unit name',
  please_input_unit_name: 'Please input unit name',
  last_seven_days: 'Last seven days',
  last_thirty_days: 'Last thirty days',
  delivery_price_tooltip:
    'Product price value sequence: shopping mall order template > product price > product price',
  store_statistics: 'Store statistics',
  inventory_minimum: 'Inventory minimum',
  inventory_limit: 'Inventory limit',
  inventory_upper_and_lower:
    'The unit types of the upper and lower limits of inventory are basic units',
  please_input: 'Please input',
  please_input_over_0_integer_1: 'Please input over 0 integer',
  item_volume: 'Item volume',
  item_weight: 'Item weight',
  inventory_minimum_tooltip:
    'You can view the upper and lower limits of inventory and inventory warnings through the item inventory query table - store dimension. The unit type of inventory upper and lower limits is the basic unit.',
  inventory_limit_tooltip:
    'You can view the upper and lower limits of inventory and inventory warnings through the item inventory query table - store dimension. The unit type of inventory upper and lower limits is the basic unit.',
  item_volume_tooltip:
    'Item attributes are used to record the volume information of the item, expressed as the volume data of the item corresponding to the base unit. No business use yet, waiting for subsequent updates',
  item_weight_tooltip:
    'The item attribute is used to record the weight information of the item, expressed as the weight data of the corresponding item in the base unit. No business use yet, waiting for subsequent updates',
  read_request_order_template: 'Read request template',
  request_order_template: 'Request template',
  template_name: 'Template name',
  template_id: 'Template id',
  used_location: 'Used location',
  used_location_count: '{{locationCount}} location count',
  requst_product_num: 'Requst product number',
  create_request_order_template: 'Create request order template',
  template_del_confirm_is: 'Confirm delete template of [{{name}}] ?',
  distributed_location_del_confirm_is: 'Confirm delete distributed location of [{{name}}] ?',
  template_del_tip2:
    'Note：After the headquarters template is deleted, the template under the store is also deleted accordingly',
  template_batch_delete_confirm_is: 'Confirm batch delete {{count}} templates?',
  distributed_location_batch_delete_confirm_is:
    'Confirm batch delete {{count}} distributed location?',
  please_input_template_name: 'Please input request order template name',
  add_location: 'add location',
  suit_product_detail: 'Suit product detail',
  suit_product_import_tmpl: 'Product import template',
  please_select_delete_template: 'Please choose template to delete',
  please_select_delete_location: 'Please choose location to delete',
  require_goods_template: 'Require goods template',
  please_select_require_goods_template: 'Please choose require goods template',
  remove: 'Remove',
  batch_remove: 'Batch remove',
  please_select_delete_product: 'Please choose product to delete',
  cost_money: 'Cost money',
  past_quarter: 'Past quarter',
  past_year: 'Past year',
  unit_settings_tooltip:
    '1. The base unit cannot be changed after the project is applied by the business. (Business documents include: purchase order, purchase receipt order, purchase receipt order, goods request order, transfer in order, transfer out order, internal application order, inventory order) 2. It cannot be modified when the menu cost card or production formula is associated. Units and conversion rates',
  del_request_template_with_no: 'Delete request template with numbers [{{id}}]',
  export_request_template_detail: 'Export request template products',
  import_request_template_detail: 'Import request template products',
  progressing: 'In progress',
  not_started_yet: 'Not started yet',
  ended: 'Ended',
  remark_msg: 'Remarks',
  date: 'Date',
  time: 'Time',
  ordering_control_tip:
    'For the same event time and store, only the latest updates are effective at the same time',
  ordering_control_detail_tip:
    'Note: If there is a demand template for the application store, the required items must be added to the corresponding demand template and must be items issued by the headquarters to the store. Otherwise, they will be invalid',
  new_plan_added: 'New plan added',
  plan_name: 'Plan Name',
  activity_time: 'Activity time',
  activity_cycle: 'Activity cycle',
  repeat_every_day: 'Repeat every day',
  repeat_every_week: 'Repeat every week',
  repeat_every_month: 'Repeat every month',
  activity_time_period: 'Activity time period',
  orderable_date: 'Orderable date',
  orderable_time: 'Orderable time',
  min_order_amount: 'Minimum order amount',
  number_of_mandatory_items: 'Number of mandatory items',
  last_editor: 'Last editor',
  certain_items: 'Certain items',
  confirm_delete_order_control:
    'Are you sure you want to delete the mandatory order scheme {{name}}?',
  order_control: 'Store ordering control',
  order_control_import_template: 'Store Order Control Import Template',
  export_order_control_detail: 'Export store order control details',
  import_order_control_detail: 'Import store order control details',
  designated_time_period: 'Designated time period',
  please_select_activity_time: 'Please select the activity time',
  unrestricted: 'Unrestricted',
  fixed_date: 'Fixed date',
  fixed_week: 'Fixed Week',
  edit_order_control: 'Edit store order control',
  additional_order_control: 'Add store ordering control',
  copy_order_control: 'Copy Store Order Control',
  please_enter_order_control_name: 'Please enter the name of the store ordering control plan',
  permanent_validity: 'Permanent validity',
  fixed_time: 'Fixed time',
  participation_rules: 'Participation rules',
  please_select_used_location: 'Please select an app store',
  specific_time_period: 'Specific time period',
  after_folding: 'After folding',
  before_folding: 'Before folding',
  ordering_unit: 'Ordering unit',
  click_date: 'Click to select the date, then click cancel again',
  click_week: 'Click to select the week, then click cancel again',
  start_time: 'Start time',
  end_time: 'End time',
  default_delivery_date: 'Default delivery date',
  default_delivery_date_tip:
    'After N days, it means the order date+n is the delivery date. Example: If it is 0, it indicates the current day; If it is 1, it means the next day',
  order_control_save_tip:
    'The following products already have a store order control plan during the same activity time',
  order_control_plan: 'Store ordering control plan',
  add_up_to_six_rows: 'Add up to six rows',
  please_select_fixed_date: 'Please select a fixed date',
  please_select_fixed_week: 'Please select a fixed week',
  please_select_specific_time_period: 'Please select a specific time period',
  start_time_cannot_be_empty: 'The start time of the available ordering time cannot be empty',
  end_time_cannot_be_empty: 'The end time of the available ordering time cannot be empty',
  start_time_must_be_less_than_end_time:
    'The end time of the available ordering time must be greater than the start time',
  specific_time_periods_cannot_overlap: 'Specific time periods cannot overlap',
  total_count: 'Total {{totalCount}} items',
  kilogram: 'Kilogram',
  reimport: 'Re import',
  request_order_product_detail_template: 'Request_order_template_detail',
  new_query_template: 'New query template',
  query_template_range: 'Query template range',
  please_select_tmplate: 'Please select the template you want to work with',
  template_batch_del_tip: 'Are you sure you want to bulk delete {{id}} templates?',
  template_del_tip: 'Sure you want to remove the template 【{{name}}】?',
  edit_query_template: 'Edit query template',
  item_delivery: 'Item delivery',
  send_to_stores: 'Send to stores',
  distributed_by_head_office: 'Distributed by head office',
  self_built_store: 'Self-built store',
  product_confirm_associates_is:
    'This item has been used by business associates and cannot be deleted!',
  view_xiafa_stores: 'View Xiafa stores',
  the_stores_that_have_been_distributed: 'The stores that have been distributed are as follows:',
  store_type: 'store type',
  query_template: 'Query template',
  choose_template: 'Choose template',
  batch_item_distribution: 'Batch item distribution',
  business_information: 'business information',
  daily_inventory: 'Daily inventory',
  weekly_inventory: 'Weekly inventory',
  monthly_inventory: 'Monthly inventory',
  other_inventory: 'Other inventory',
  please_select_items_to_distributed: 'Please select the items to be distributed',
  item_enquiry_template: 'Item Enquiry Template',
  item_enquiry_template_detail: 'Item Enquiry Template Detail',
  check_type_tooltip:
    'The inventory can be quickly filtered and brought into the inventory list through the inventory type here.',
  clear_selected_items: 'Clear selected items',
  inventory_cost_in_money: 'Inventory cost in money',
  inventory_cost_out_money: 'Inventory cost out money',
  basic_parameter: 'Basic parameter',
  delivery_management: 'Delivery management',
  procurement_management: 'Procurement management',
  basic_file: 'basic file',
  return_order_parameters: 'Return order parameters',
  history_record: 'History record',
  modify_records: 'Modify records',
  basic_file_setting: 'Basic File Setting',
  procurement_management_setting: 'Procurement Management Setting',
  delivery_management_setting: 'Delivery Management Setting',
  only_keep_records_for_the_last_6_months: 'Only keep records for the last 6 months',
  inventory_management: 'Inventory management',
  inventory_parameters: 'Inventory parameters',
  how_to_convert_virtual_items:
    'How to convert virtual items when the store puts them into storage',
  transfer_actual_items: 'Transfer actual items',
  not_transferring_actual_items: 'Not transferring actual items',
  actual_items_spec1:
    'Application scenario 1: The store only needs to order chicken wings, regardless of brand, but the distribution center has multiple brands, which will change after a period of time.',
  actual_items_desc1:
    'Convert orders to actual items, order virtual items, submit as actual items, issue actual items, put actual items into storage, deduct actual items, and count actual items.',
  actual_items_spec2:
    'Application Scenario 2: A store orders a certain brand of chicken wings. After arriving, they are unpacked and mixed with other brands, making it impossible to tell them apart.',
  actual_items_desc2:
    'Do not transfer actual items, order actual items, submit as actual items, issue actual items, put virtual items into storage, deduct virtual items, and count virtual items.',
  inventory_management_setting: 'Inventory Management Setting',
  search_virtualItem_title: 'Item code, sku, barcode, shorthand code, name',
  virtual_item_list: 'virtual item list',
  associated_with_actual_item_list: 'Associated with actual item list',
  virtual_item_desc:
    'Virtual items can only be associated with actual items with the same basic unit',
  virtual_item: 'virtual item',
  actual_item: 'actual item',
  related_to_actual_items: 'Related to actual items',
  conversio_rate_base: 'Conversion rate base',
  please_select_virtual_item_first: 'Please select a virtual item first',
  cost_card_can_be_set_up: 'Cost card can be set up',
  cost_card_can_be_set_up_tip:
    'You can set up a cost card, and you can choose a virtual item in the cost card configuration',
  hibernate_tip:
    'Hibernate: The virtual item will not be allowed to order and will not appear in the ordering process',
  historical_receipt_price: 'Historical Receipt Price',
  receipt_number: 'Receipt number',
  audit_date: 'Date of audit',
  headquarters_products_distributed_to_the_store:
    'After the headquarters creates an item, it is automatically distributed to the store',
  managing_products_distributed_to_the_store:
    'After managing the inventory of products on the sales end, they will be automatically distributed to the store',
  third_party_products_distributed_to_the_store:
    'After the third-party products are synchronized to the headquarters, they are automatically distributed to the store',
  automatically_distributed_to_the_store:
    'After synchronizing third-party products with the headquarters for several customers using retail inventory, they will be automatically distributed to the store',
  priority_order: 'Priority order',
  product_move_confirm_is: 'Confirm whether to move items?',
  add_virtual_management: 'Please add a virtual item and a real item first',
  actual_item_base_unit_rate_cannot_be_0: 'The conversion rate cannot be 0',
  delivery_price__desc_tooltip: 'Delivery price: unit price per basic unit of the item',
  create_virtual_with_name: 'Create Virtual Item With Name{{name}}',
  edit_virtual_with_name: 'Edit Virtual Item With Name{{name}}',
  virtual_confirm_is:
    'Deletion cannot be restored. Are you sure you want to delete this virtual item? Note: After the item is deleted, the item in the store will also be deleted.',
  del_request_virtual_with_no: 'Del Request Virtual Item  With No[{{id}}]',
  virtual_item_delivery: 'virtual item delivery',
  categories_without_items:
    'Guanjia APP replenishment does not display item categories without items',
  no_category_item_move: 'Classification without category cannot be moved',
  no_category_item: 'No category',
  change: 'Change',
  change_replace_product: 'Change replace product',
  please_input_product: 'Input name or barcode or sku search product',
  please_select_an_actual_item_first: 'Please select an actual item first',
  edit_request_document: 'Edit Item Archive Information',
  save_request_document: 'Add Item Archive Information',
  product_location_confirm_is:
    ' After deleting an item, the corresponding item under the store should also be deleted.',
  users_not_allowed_modify:
    'Users are not allowed to modify it. If you need to modify it, please contact Le Lemon customer service staff.',
  upload_image: 'Upload image',
  add: 'Add',
  only_keep_records_for_the_last_12_months: 'Only keep records for the last 12 months',
  transfer_out_price: 'Transfer out price',
  transfer_in_price: 'Transfer in price',
  in_transit_money: 'In transit money',
  in_transit_base_qty: 'In transit base qty',
  product_memo: 'Product memo',
  suppiler_email: 'Suppiler email',
  product_related_request_order_desc: 'This product related request order ensure change',
  please_input_processed_product_title: 'Please enter the name of the processed product',
  please_input_raw_materials: 'Please enter the name of the raw material',
  recipe_level: 'Recipe level',
  legend: 'legend',
  new_recipe: 'New recipe',
  positive_relationship_diagram: 'Positive relationship diagram',
  export_Picture: 'Export Picture',
  virtual_confirm_location_is:
    'The item cannot be restored after deletion. Are you sure about the deletion?',
  formula_layers: 'Formula layers',
  other_parameters: 'Other parameters',
  purchase_approve:
    'When saving the purchase document for the first time, prompt whether to approve it',
  transfer_approve:
    'When saving chain documents for the first time, prompt whether to approve or not',
  inventory_approve:
    'When saving inventory documents for the first time, prompt whether to approve or not',
  please_select_store_name: 'Please select a store',
  review_immediately:
    'The document has been saved successfully. Should we proceed with the review immediately?',
  select_processed_item: 'select Processed products',
  audit_failed: 'audit failed',
  check_order_qty: 'actual number',
  check_order_stock_qty: 'amount number',
  local_actual_money: 'amount money',
  check_order_money: 'actual money',
  check_order_base_qty: 'base actual number',
  check_order_base_stock_qty: 'base amount number',
  win_loss_money: 'Win loss money',
  check_diff: 'Check diff',
  total_summary: 'Total summary',
  check_win_count: 'Check_win_count',
  check_win_unit_price: 'Check win unit price',
  check_win_money: 'Check win money',
  check_loss_count: 'Check loss count',
  check_loss_unit_price: 'Check loss unit price',
  check_loss_money: 'Check loss money',
  summary_of_procurement_classifications: 'Summary of procurement classifications',
  summary_of_supplier_classifications: 'Procurement Supplier Summary',
  summary_of_supplier_location: 'Supplier-Store Summary',
  summary_of_supplier_product: 'Supplier-Item Summary',
  summary_of_supplier_product_type: 'Supplier-Item Classification Summary',
  multi_unit_check: 'Multi unit check',
  default_store_spec:
    'The current warehouse is the default warehouse and the properties of the distribution warehouse cannot be modified. When set as a processing room, it can also be used as a management warehouse for processed products.',
  negative_inventory_deductions: 'Negative inventory deductions',
  not_allowed_except_pos_sales: 'Not allowed (except POS sales)',
  allow_negative_inventory: 'Allow negative inventory deductions for all operations',
  all_businesses_include:
    'All businesses include transfer out orders, voiding of warehousing orders, voiding purchase receipt orders, returns and shipments, inventory adjustment outgoings, inventory loss outgoings, transfer warehouse outgoings, production picking outgoings, and production outgoings.',
  awaiting_receipt: 'Awaiting receipt',
  partial_receipt: 'Partial receipt',
  receipt_completed: 'Receipt completed',
  receipt_close: 'Receipt close',
  receipt_status: 'Receipt status',
  downstream_order_number: 'Downstream Order Number',
  expected_date_delivery: 'Expected date of delivery',
  classification_type: 'Classification type',
  system_created: 'System created',
  manually_created: 'Manually created',
  allow: 'Allow',
  not_allowed: 'Not allowed',
  change_tips_del_goods_formula:
    'Switching the processing room will clear the information filled in the processed product raw materials. Do you want to confirm the operation?',
  file_name: 'File name',
  size: 'Size',
  upload_time: 'Upload time',
  uploader: 'Uploader',
  download: 'Download',
  please_select_file: 'Please select file',
  choose_file: 'Choose file',
  batch_download: 'Batch download',
  upload_tips:
    'Support for uploading images, documents and other formats, up to 10MB, up to 15 uploads',
  upload_max_tip: 'Upload up to 15 files',
  upload_exceeded_tip: '{{names}}Size over 10M, please re-upload',
  batch_distribution: 'Batch distribution',
  distributed_locations: 'Distributed locations',
  latest_distributed_date: 'Latest distributed date',
  terminate: 'Terminate',
  related_purchase_receipt: 'Related Purchase Receipt',
  setting_location: 'location setting',
  request_order_use_template_config: 'Request order must use request template',
  kit_item_request_check_rate: 'Kit item request check rate',
  template_used_location_config: 'Has used {{count}} locations',
  use_template_add: 'Use template add',
  discontinued: 'Discontinued',
  pending_partial_receipt: 'Pending receipt、partial receipt',
  receive_order_no: 'Receive order no',
  purchase_order_no: 'Purchase order no',
  save_and_distribute: 'Save and distribute',
  read_purchase_return_order: 'Read purchase return order',
  processed_product_production: 'Processed product production',
  processed_product_production_desc:
    'The production plan order has undergone raw material picking or processed product production in the production Kanban and cannot be de-audited。It is not allowed to pick up raw materials and produce processed products across stores. Please re-screen before operating.',
  processed_product_desc:
    'If the processed product is successfully produced, you can proceed to the production receipt order to continue the operation.Generate {{num}} production receipt document',
  processed_product_production_success: 'Processed products produced successfully',
  the_following_processed_products_cannot_generate:
    'The following processed products cannot generate picking lists',
  reason_cannot_be_generated: 'Reason why picking list cannot be generated',
  input_code_sku: 'Item code, name',
  overview_of_processed_products: 'Overview of processed products',
  picking_date: 'Picking date',
  processing_quantity: 'Processing quantity',
  machining_room_allowance: 'machining room allowance',
  theoretical_picking_quantity: 'Theoretical picking quantity',
  theoretical_consumption_of_work_in_progress: 'Theoretical consumption of work in progress',
  estimated_picking_quantity: 'Estimated picking quantity',
  actual_picking_quantity: 'Actual picking quantity',
  quantity_received_by_basic_unit: 'Quantity received by basic unit',
  basic_unit_inventory_balance: 'Basic unit inventory balance',
  picking_warehouse: 'Picking warehouse',
  theoretical_consumption_of_work_in_progress_desc:
    'Theoretical consumption of work in progress = Theoretical consumption of raw materials corresponding to processed products whose processing order status is picked but not detained',
  estimated_picking_quantity_desc:
    'Estimated picking quantity = theoretical picking quantity of this processed product - (inventory balance in raw material processing room - theoretical raw material consumption of work in progress)',
  picking_warehouse_desc: 'Picking warehouse, according to warehouse item rules',
  edit_the_actual_quantity_received_with_one_click:
    'Edit the actual quantity received with one click',
  one_click_picking_quantity:
    'One-click editing Actual picking quantity = Theoretical picking quantity',
  one_click_estimated_picking_quantity:
    'One-click editing Actual picking quantity = Estimated picking quantity',
  one_click_theoretical_piking_quantity:
    'One-click editing Actual picking quantity = Theoretical picking quantity - Processing room allowance',
  picking_order_number: 'Picking order number',
  the_picking_is_successful:
    'The picking is successful. You can check it in the production picking list. The documents are as follows:',
  current_inventory_of_the_processing:
    'The current inventory of the processing room warehouse where the processed products are located',
  expected_date_of_arrival: 'Expected date of arrival',
  purchase_order_details: 'Purchase order details',
  purchase_order_summary: 'Purchase order summary',
  order_items_summary: 'Summary of items ordered',
  order_suppliers_summary: 'Summary of Suppliers ordered',
  purchase_order_number: 'Purchase Order Number',
  purchase_aprice: 'Purchase price',
  purchase_num: 'Purchase quantity',
  purchase_num_base_unit: 'Purchase quantity with base unit',
  gift_quantity_base_unit: 'Gift quantity with base unit',
  purchase_money: 'Purchase money',
  already_received_quantity: 'Received Quantity',
  already_received_quantity_base_unit: 'Received Quantity with base unit',
  number_of_returned_goods: 'Number of Returned Goods',
  number_of_returned_goods_base_unit: 'Number of Returned Goods With Base Unit',
  tip_processed_products: 'Tip: The following processed products cannot generate picking lists',
  modify_request_template_tip:
    '1. Multiple demand templates can exist for the same distribution center and the same demand store; 2. After the item is configured here, it still needs to be sent to the corresponding store and can only be selected in the store inventory',
  purchase_barcode_desc: 'No business use yet, waiting for upgrade and update',
  base_unit_qty_and_use_unit_qty_are_required:
    'The actual picking quantity and the basic unit picking quantity cannot be empty.',
  the_following_processed_order_cannot_generate:
    'The following processed products cannot generate processing orders',
  receive_auto_update_price:
    'Purchase receipt automatically maintains the unit price of purchases in the corresponding unit of the file',
  import_product_formula_prop: 'Import product formula prop',
  export_transfer_out_formula: 'Export transfer out formula',
  select_accroding_to_machining: 'Select according to insufficient machining room allowance',
  select_semifinished_product: 'Select semi-finished product',
  is_semifinished_product: 'Is it a semi-finished product?',
  uncheck_semi_finished_product: 'Uncheck semi-finished product',
  please_choose_expected_date_delivery: 'Please choose expected date delivery',
  summary_by_location_items: 'Summary by location and items',
  operation_date: 'Operation date',
  summary_by_location_itemtype: 'Summary by location and itemtype',
  production_receiving_material_inventory: 'Production Receiving Material Inventory',
  production_material_out_stock: 'Production material out of stock',
  production_in_storage: 'Production in storage',
  production_out_storage: 'Produced out of stock',
  bring_to_account: 'Bring to account',
  out_to_account: 'Out to account',
  retail_other_entries: '(Retail) other entries',
  retail_other_outgoings: '(Retail) other outgoings',
  retail_reutrn_storage: '(Retail) return storage',
  retail_sell_out: '(Retail) sell out',
  Delivery_price_tip:
    'Delivery price: The default price when a franchise store adds an order, or when the distribution center transfers an order to a franchise store<br/>The delivery price sequence: Store delivery price in the item delivery attribute > File delivery price',
  please_input_delivery_prices: 'Please enter the delivery price (yuan)',
  reocrd: 'reocrd',
  operate_date: 'operate date',
  production_management: 'Production management',
  production_approve:
    'When the production document is saved for the first time, it prompts whether to review it.',
  edit_recipe_management_with_code: 'Edit recipe, reason: {{code}}',
  reason_for_modification: 'Reason for modification',
  puchase_upload: 'Puchase order [{{orderNo}}] upload',
  receive_upload: 'Puchase receive order [{{orderNo}}] upload',
  return_upload: 'Return order [{{orderNo}}] upload',
  default_purchasing_unit: 'Default purchasing unit',
  default_purchase_unit_price: 'Default purchase unit price',
  default_shipping_unit: 'Default shipping unit price',
  default_shipping_price: 'Default shipping price',
  headquarters_file_data:
    'The headquarters modifies the item file and overwrites the issued headquarters file data.',
  warehouse_item_rules: 'Warehouse Item Rules',
  print_template_settings: 'Print template settings',
  del_request_warehouse_with_no: 'Delete warehouse item rule [{{id}}]',
  edit_warehouse_item: 'Edit warehouse item rules [{{id}}]',
  del_request_store_with_no: 'Delete warehouse [{{name}}]',
  item_query_template: 'Item query template',
  accounting_period: 'Accounting period',
  del_item_query_template: 'Delete item query template [{{name}}]',
  edit_item_query_template: 'Edit item query template [{{name}}]',
  create_item_query_template: 'Create item query template [{{name}}]',
  del_print_template_settings: 'Delete print template settings [{{name}}]',
  edit_print_template_settings: 'Edit print template settings [{{name}}]',
  create_print_template_settings: 'Create print template settings [{{name}}]',
  history_receive_price_tip_1:
    'Item Detail - Recent Prices: Take the recent prices of the supply relationship, if the supply relationship is deleted, then the historical recent prices will be deleted together.',
  history_receive_price_tip_2:
    'Historical receipt price: query in and out of the warehouse details, not related to the supply relationship.',
  puchase_setting: 'Purchase order parameters',
  auto_generate_receive_order:
    'After the purchase order is audited, the Purchase Receipt with pending audit status is automatically generated.',
  supplier_delivery: 'Supplier delivery',
  required_for_purchasing: 'Required for purchasing document clerks',
  required_for_production: 'Required for production document clerks',
  required_for_productStorage:
    'The production receipt allows the addition of raw materials other than the formula',
  required_for_delivery: 'Required for delivery document salesperson',
  required_for_inventory: 'Required for inventory document clerks',
  financial_management: 'financial management',
  financial_management_desc:
    'When saving financial documents for the first time, you will be prompted whether to review them.',
  financial_document_clerks: 'Required for financial document clerks',
  please_select_salesperson: 'Please select a salesperson',
  operate_tips: 'Operation tips',
  export_transfer_out_suppiler: 'Export supplier profile',
  supplier_data_instructions: 'Note: The headquarters issues supplier data that will cover stores',
  product_data_instructions:
    'Note: The data distributed to the stores will be affected by the data distributed by the headquarters, and will not be affected if the stores build their own data. If the store is a franchise store, the file delivery price will be applied to the store cost price when it is issued for the first time.',
  whether_funds_are_settled: 'Whether funds are settled',
  extra_points_for_delivery: 'Extra points for delivery',
  lock_delivery_price: 'Lock in the delivery price and add points according to the reference cost',
  lock_delivery_points: 'Lock delivery points',
  proportionately: 'Proportionately',
  by_amount: 'by amount',

  order_date: 'Order date',
  voucher_type: 'Document type',
  order: 'Orders',
  coupon_order: 'Card coupon orders',
  order_refund: 'Order refund',
  deposit_customer_refund: 'Customer value refunds',
  deposit_customer: 'Customer store value',
  card_order_refund: 'Voucher order refund',
  deposit_refund_order: 'Deposit refund form',
  business_receipts_audit: 'Business receipts audit',
  reconciliation_status: 'Reconciliation status',
  reconciliation_finished: 'Reconciliation completed',
  have_difference: 'There are differences',
  collection_type: 'Collection type',
  business_receipts_description:
    'The business collection audit is mainly used to compare the data of Lemon Catering business system with the payment/refund data of the finance center. If the data is consistent, the reconciliation is normal, if the data is inconsistent, the difference is displayed.',
  amount_of_receive_refund_money: 'Collection/Refund Amount',
  number_of_receive_refund: 'Number of receipts/refunds',
  amount_of_lemon_pay: 'Lemeng Payment Amount',
  number_of_lemon_pay: 'Number of payments made by Le Meng',
  amount_of_difference: 'Difference amount',
  number_of_difference: 'Number of differential transactions',
  difference_data: 'Differential data',
  difference_info: 'Differential information',
  lemon_pay_no_data: 'Lemeng pays without data',
  system_no_data: 'The business system has no data',
  lemon_store_pay_data: 'Lezhi retail and payment data are inconsistent',
  pay_flow_document_no: 'Transaction serial number',
  document_sale_no: 'Business document number',
  lemon_pay_data: 'Lemeng payment data',
  document_time: 'Document time',
  difference_error_info: 'Error information',
  pay_start_time: 'Payment start time',
  pay_end_time: 'Payment end time',
  amount_of_receive_money: 'Amount Collected',
  amount_of_refund_money: 'Refund amount',
  card_order: 'Card coupon order',
  shiftNumber: 'Shift number',
  handover_person: 'Handover person',
  opening_time2: 'Opening time',
  shift_handover_time: 'Shift handover time',
  collection_for_this_shift: 'Collection for this shift',
  shift_handover_statistics: 'Shift handover statistics',
  receipt_statistics_description1:
    '1. Collection for this shift: Calculate the total amount recorded in the actual payment method for this shift, including the portion that needs to be signed for repayment, and does not include signing, balance payment, gift card payment, and point deduction.',
  receipt_statistics_description2: '2. Click View to view the details.',
  cash_pay: 'cash payment',
  origin_petty_cash: 'Primary imprest fund',
  amount_put_in: 'Amount put in',
  amount_put_out: 'Withdrawal amount',
  expected_cash: 'Expected cash',
  cash_received: 'Cash received',
  diff_money_short: 'Balance',
  composition_of_business_incentives: 'Composition of Business Incentives',
  business_composition: 'Business Composition',
  member_consumption_statistics: 'Member consumption statistics',
  shift_handover_details: 'Shift handover details',
  discount_type_01: 'Discount type',
  preferential_superposition: 'Preferential superposition',
  preferential_superposition_tip:
    'Buyer orders can only be used with the selected activity type at the same time, if not selected, the goods after participating in the full X Y discount activity cannot use coupons.',
  special_discount: 'Special discount',
  collection_statistics: 'Collection statistics',
  deposit_statistics: 'Deposit statistics',
  sale_shift_order: 'Handover note',
  number_of_receive: 'Number of payments received',
  subtotal_of_receipts: 'Subtotal of receipts',

  statistics_dimension: 'Statistical dimension',
  order_source: 'Source of order',
  wechat_miniprogram: ' WeChat mini program',
  web_admin: 'Webpage',
  oms_mt: 'Meituan takeout',
  oms_elm: 'Eleme',
  miniprogram: 'Platform mini program',
  oms_eb: 'ElemeBWM',
  oms_eb_tb: 'Ele.me Retail (including Taobao Flash Purchase)',
  douyin_takeout: 'Douyin takeout',
  alipay_mini_program: 'Alipay mini program',
  tiktok_self_verification: 'Tiktok self-verification',
  date_range: 'Date range',
  all_range: 'all',
  search_order_source: 'Search order source',
  adjustment_enterprise_credit_limit_log:
    '{{changeType}} Enterprise hanging [{{enterpriseName}}] Line of credit {{creditLimitValue}}',
  adjustment_credit_limit: 'Adjustment of credit limit',
  adjustment_credit_limit_success: 'Successfully adjusted credit limit',
  please_enter_credit_limit: 'Please enter the credit limit',
  adjustment_method: 'Adjustment method',
  increase_limit: 'Increase limit',
  reduce_limit: 'Reduce limit',
  adjustment_limit: 'Adjustment limit',
  confirm_delete_enterprise:
    'Confirm to delete the enterprise, it cannot be restored after deletion',
  debtor_enterprise: 'Debtor enterprise',
  head_enterprise_ledger_management: 'Management of corporate accounts at headquarters',
  group_meal_status: 'Group meal status',
  head_people_ledger_management: 'Headquarters personal billing management',
  store_people_ledger_management: 'Store personal billing management',
  peeson_ledger_management: 'Personal billing management',
  enterprise_ledger_management: 'Enterprise ledger management',
  nature_of_enterprise: 'Nature of enterprise',
  credit_line: 'Amount of charge',
  amount_charged: 'Amount charged',
  remain_pending_account_money: 'The remaining amount in the account',
  create_payee: 'Create a payee',
  edit_payee: 'Edit the payee',
  read_payee: 'View the debtor',
  name_debtor: 'Name of the debtor',
  repayment_history: 'Repayment history',
  charge_record: 'Charge record',
  quota_change: 'Quota change',
  nationalized: 'State-owned enterprise',
  private: 'Private enterprise',
  foreing_invested: 'Foreign-invested enterprise',
  collectively_owned: 'Collectively owned enterprise',
  joint_stock: 'Joint-stock enterprise',
  limited_partnership: 'Limited partnership',
  affiliates: 'Joint venture',
  sole_proprietoreship: 'Sole proprietorship',
  unknown_enterprise: 'Unknown enterprise',
  store_enterprise_ledger_management: 'Store business accounting management',
  edit_enterprise_staffs: 'Edit enterprise customer',
  read_enterprise_staffs: 'Read enterprise customer',
  create_enterprise_staffs: 'Create enterprise customer',
  enterprise_name: 'Company name',
  enter_enterprise_name: 'Enter the company name',
  enterprise_staff: 'Enterprise customers',
  enterprise_LOGO: 'Enterprise logo',
  enterprise_profile: 'Company profile',
  please_enter_enterprise_profile: 'Please enter the company profile',
  please_enter_the_debit_amount: 'Please enter the debit amount',
  group_meal_rule: 'Group meal rules',
  enable_group_meals: 'Enable group meals',
  credit_discount: 'Credit discount',
  no_discount: 'No discount',
  discount_ratio: 'Discount ratio',
  maximum_99: 'Maximum value 99',
  maximum_999: 'Maximum value 999',
  credit_discount_tips: 'If it is 20%, there will be a 20% discount on credit',
  delete_address: 'Delete address',
  update_address: 'Modify address',
  add_group_meal_address: 'Add address',
  address_max: 'Supports adding up to 10 addresses',
  local_deliver_address: 'Delivery address',
  does_support_account_suspension: 'Does it support account suspension',
  enterprise_employee: 'Enterprise employee',
  supports: 'Support',
  not_supports: 'Not supported',
  staff_status: 'Employee status',
  confirm_staff: 'Confirm employee',
  entry_job_tips:
    'After confirmation of employment, the employee will become a new employee of the company.',
  leave_job_tips:
    'After confirmation of resignation, the employee will be removed from the company and no longer enjoy corporate benefits, becoming an ordinary member status!',
  not_query_more_staff_info: 'No more employee information found',
  create_enterprise_employee: 'Creating enterprise employees',
  search_staff_phone: 'Search for employee phone number',
  affiliated_enterprise: 'Affiliated enterprise',
  please_enter_staff_name: 'Please enter the employee is name',
  password_check_one: 'Please enter a 6-digit pure numeric password',
  password_check_two: 'Please enter the correct numerical password',
  staff_full_name: 'Name',
  support_account_suspension: 'Account',
  payment_password: 'Password',
  read_enterprise_staff_list: 'View enterprise employee list',
  read_enterprise_ledger_staff_list: 'View the list of corporate debtors',
  read_enterprise_staff_info: 'View information of enterprise employee [{staffName}}]',
  edit_enterprise_staff_info: 'Edit the information of enterprise employee [{staffName}}]',
  create_enterprise_staff: 'Create enterprise employee [{{staffName}}]',
  confirm_staff_entry_job: 'Confirm employee onboarding',
  confirm_staff_leave_job: 'Confirm employee resignation',
  create_enterprise_ledger_staff_info:
    'Create a profile of the enterprise ledger employee [{{staffName}}]',
  edit_enterprise_ledger_staff_info:
    'Edit the information of the enterprise debit employee [{{staffName}}]',
  debtor: 'Debtor',
  canteen_food: 'Dine in',
  takeaway: 'Takeaway',
  self_pick: 'Pick up at the branch',
  search_business_scenario: 'Search business scenario',
  description_statements: 'Description of statements',

  report_description: 'Description of report',
  business_discounts_tips:
    'Business discounts for system commodity orders, including: payment of Stored-value card gift amount, point deduction payment, marketing activity discount, coupon discount, etc',
  business_discounts_report: 'Business discounts report',
  business_flow: 'Business flow',
  business_income: 'Operating income',
  business_discounts: 'Business discounts',
  business_discounts_analysis: 'Business discounts analysis',
  order_no_normal: 'Order No.',
  search_for_order_number: 'Search for order number',
  cashier: 'Cashier',
  business_refund_statistic: 'Business refund statistics',
  sign_payment_detail: 'Sign payment detail',
  composition_payment_method: 'Composition of payment method',
  busincess_discounts_composition: 'Composition of business discounts',
  busincess_income_composition: 'Composition of operating income',
  sales_item_composition: 'Composition of sales item',
  composition_of_marketing_discounts: 'Composition of marketing discounts',
  original_order_no: 'Original order number',
  return_time: 'Return time',
  performance_mode: 'Business type',
  customer_name: 'Customer Name',
  customer_name2: 'Customer Name',
  contact_number: 'Contact number',
  shipping_address: 'Delivery address',
  refund_or_return_reason: 'Reasons for refund/return',
  order_created_at2: 'Created date',
  statistical_indicators: 'Statistical indicators',
  single_average_after_discount: 'Single average after discount',
  number_of_valid_orders: 'Number of valid orders',
  average_before_discount: 'Average before discount',
  statistical_cycle: 'Statistical cycle',
  month_range: 'Month Range',
  date_on: 'Date on',
  by_month: 'By Month',
  channel_business_statistic_tip_1:
    'Revenue: The amount of system product orders after deducting business discounts, excluding coupon orders. Operating revenue=operating revenue - operating discounts',
  channel_business_statistic_tip_2:
    'Business discounts: System product order business discounts, including: payment of stored value card gift amount, point deduction payment, marketing activity discounts, coupon discounts, etc',
  channel_business_statistic_tip_3: 'Business flow: pre discount amount for product orders',
  channel_business_statistic_tip_4:
    'Non operating income: Other income other than product orders, including stored value cards, coupon packages, equity cards, gift cards, etc',
  channel_business_statistic_tip_5:
    'Number of valid orders: Excluding all refunded orders, the number of valid orders=number of orders - number of refunded orders',
  channel_business_statistic_tip_6: 'Pre discount average: business flow/number of valid orders',
  channel_business_statistic_tip_7: 'Average discounted orders: revenue/number of valid orders',
  channel_business_statistic: 'Channel business statistic',
  operating_revenue: 'operating revenue',
  phone_num: 'Phone number',
  please_enter_your_mobile_number: 'Please enter your phone number',
  member_card_no: 'Member card number',
  card_type_name: 'Card type name',
  deduction_store: 'Deduction store',
  deduction_amount: 'Deduction amount',
  principal_deduction: 'Principal deduction',
  deduction_bonus: 'Deduction bonus',
  amount_after_deduction: 'Amount after deduction',
  deduction_time: 'Deduction time',
  deduction_order_no: 'Deduction order number',
  related_consumption_order_no: 'Related consumption order number',
  deduction_channel: 'Deduction channel',
  product_marketing_tips:
    'Product Marketing Statistics: Primarily analyzes the products for which coupons are used, and counts the quantity and amount of products redeemed with coupons.',
  regional_dimension: 'Regional dimension',
  dining_area: 'Dinging Area',
  stage: 'Platform',
  stage_area: 'Station area',
  stage_name: 'Station name',
  search_for_stage_name: 'Please enter a station name',
  table_tips1:
    'You can view the corresponding business transactions, business income, business discounts, number of diners, per capita, and per table business conditions according to the store, table area, and individual table seats.',
  table_tips2:
    'The table area and individual table seats are divided according to the information in [Settings] [Store Setup]; if adjustments are needed, modifications can be made in [Settings] [Store Setup].',
  table_tips3:
    'Table utilization rate: The percentage of consumed tables to the total number of tables, used to measure the efficiency of table usage in a restaurant.',
  table_tips4:
    'Turnover rate: Refers to the rate at which dining tables are reused. The formula is: ((Consumed table count - Number of tables) / Number of tables) * 100%.',
  table_tips5:
    'Occupancy rate: (Number of diners / Maximum total number of seats in the area) * 100%.',
  table_tips6:
    'Average table revenue before discount: Business turnover / Number of consumed tables',
  table_tips7: 'Average table revenue after discount: Business income / Number of consumed tables',
  table_tips8: 'Average revenue per person before discount: Business turnover / Number of diners',
  table_tips9: 'Average revenue per person after discount: Business income / Number of diners',
  table_tips10:
    'Other instructions: If the number of diners does not need to be selected during the meal, then the number of diners is taken as 1 for statistical purposes.',
  table_tips11:
    'Number of diners: For sit-down orders, the number of diners takes the number of people at the table. If it is a scan code order, the number of people selected by the scan code is taken',
  number_of_stations: 'Table number',
  area_stage_total_num: 'Total number of seats in the area',
  station_type: 'Type of station',
  stage_num: 'Number of people standing',
  consume_table: 'Consumption tables',
  eat_num: 'Number of diners',
  discount_front_table_average: 'Fold the front table',
  discount_late_table_average: 'Fold the back table',
  discount_front_num_average: 'Pre-conversion per capita',
  discount_late_num_average: 'Discounted per capita',
  service_charge: 'Service charge',
  start_rate: 'Rate of start',
  turnover_rate: 'Table turnover rate',
  attendance: 'attendance',
  average_meal_time_min: 'Average meal time (minutes)',
  table_business_statistics: 'Table business statistics of dining area',
  table_business_statistics_1: 'Table business statistics of dining area',
  time_dimension: 'Time dimension',
  closing_date: 'Closing date',
  business_date2: 'Business date',
  search_product_or_attributes_name: 'Search product or attributes name',
  product_sales: 'Product sales',
  attribute_sales: 'Attribute sales',
  package_fee_money: 'Package fee',
  delivery_fee: 'Delivery fee',
  sales_mix: 'Sales mix',
  product_package: 'Product and package',
  product_package_details: 'Product and package details',
  product_only: 'Product',
  package_only: 'Package',
  package_details_only: 'Package details',
  statistical_methods: 'Statistical methods',
  product_or_attributes_name: 'Item/property name',
  average_unit_price: 'Average Unit Price',
  average_selling_price: 'Average Selling Price',
  number_of_flows: 'Number of Flows',
  sale_man: 'Saleman',
  single_remark: 'Detail remark',
  order_remark: 'Order remark',
  description_report8: 'Support query dimensions: store/date',
  description_report9:
    'Operating revenue=Operating flow - Operating discounts=Subtotal of order type=Subtotal of order source=Subtotal of operating revenue payment',
  description_report10: 'Customer unit price=operating revenue/passenger flow',
  description_report11: 'Average price per order=operating revenue/number of valid orders',
  description_report12: 'Member customer unit price=Member revenue/Member customer flow',
  description_report13:
    'In the payment method, the balance payment does not include the gift balance payment part.',
  description_report14:
    'In the marketing discount composition, it includes the payment part of the gift balance and displays specific marketing discounts.',
  description_report15:
    'In the composition of payment methods, only the non coupon orders paid by non preferential payment methods are counted (including WeChat payment, Alipay payment, etc., excluding free balance payment)',
  category_sales_ranking_report1:
    'Product click through rate: The percentage of sales orders for this product in total sales orders for all products',
  category_sales_ranking_report2:
    'Customer traffic: During this period, the number of customers in all sales orders has been reduced',
  category_sales_ranking_report3: 'Average unit price: running amount/running quantity',
  category_sales_ranking_report4: 'Average sales unit price: sales amount/sales quantity',
  description_report20: 'Average unit price: running amount/running quantity',
  description_report21: 'Average unit price: running amount/running quantity',
  description_report22: 'Running quantity: equal to sales quantity+gift quantity',
  description_report22_2: 'Running quantity: equal to sales quantity(away gift)+gift quantity',
  description_report23: 'Order amount: equal to the running amount+refund amount',
  description_report24: 'Daily amount: equal to sales amount+discount amount',
  description_report25: 'Gift amount: The original price of the gift',
  description_report26:
    'The category of unassociated goods includes goods attributes/feeding, packaging fees, delivery fees, and goods not associated with third-party platforms',
  product_sales_summary: 'Product Sales Summary',
  sku_item_number: 'SKU (Product number)',
  area: 'Area',
  shop: 'Shop',
  mall_product_order: 'Mall order',
  points_redemption_order: 'Point exchange order',
  express_mall_statistics_tip_1:
    'Mall operating revenue: The amount of mall orders after deducting business discounts in the system. Mall operating revenue=Mall operating revenue - Mall operating discounts',
  express_mall_statistics_tip_2:
    'Mall Business discounts: System mall order business discounts, including points deduction amount, etc',
  express_mall_statistics_tip_3: 'Mall Business Flow: Pre discount amount for system mall orders',
  express_mall_statistics_tip_4:
    'Refund amount: The total amount of the actual received portion of the completed refund order, only counted for mall orders.',
  express_mall_statistics_tip_5:
    'Number of valid orders: Excluding the number of mall orders that have been fully refunded, the number of valid orders=number of orders - number of refund orders',
  express_mall_statistics_tip_6:
    'Number of Refund Orders: The number of mall orders that have been fully refunded',
  mall_business_flow: 'Mall Business Flow',
  mall_operating_income: 'Mall operating income',
  mall_business_discounts: 'Mall business discounts',
  refund_order_number: 'Number of refund orders',
  total_refund_money: 'Refund amount',
  express_mall_statistics: 'Express Mall Statistics',
  order_type1: 'Order type',
  statistical_interval: 'Statistical interval',
  signle_average_price: 'Single average price',
  passenger_flow: 'Passenger flow',
  order_avg_price: 'Customer unit price',
  per_diner: 'Per diner',
  session_business_statistics: 'Session business statistics',
  performance_mode_composition: 'Business type composition',
  single_point_sales: 'Single point sales',
  sing_point_amount: 'Single point amount',
  sales_within_the_package: 'Sales within the package',
  package_amount: 'Package amount',
  card_type: 'Card type',
  customer_custom_value_report: 'Customer custom detail',
  dining_type: 'Dining type',
  query_by_store_code_and_name: 'Search for the store code or name (separated by multiple commas)',
  franchise_store: 'Franchise branch',
  direct_store: 'Outlet branch',
  goods_summary: 'Goods summary',
  order_quantity_01: 'order quantity',
  order_amount: 'Order amount',
  flow_money: 'Flow money',
  refund_flow: 'Refund flow',
  sales_number_except_gift: 'Sales quantity except gift',
  sale_money: 'sale money',
  for_sale_all_amount: 'Discount amount',
  platform_commission_money: 'Platform commission',
  ref_order_count: 'Associated order number',
  customer_click_through_rate_sales_quantity_customer_traffic:
    'Customer click through rate: sales quantity/customer traffic',
  product_sale_ranking: 'Product sales ranking',
  commodity_barcode: 'Product bar code',
  sales_number: 'Sales quantity',
  number_of_sales_orders_for_goods: 'Number of sales orders for goods',
  order_numbers: 'Number of orders',
  product_click_through_rate: 'Product click through rate',
  customer_click_through_rate: 'Customer click through rate',
  search_goods_category: 'Search by category',
  store_wants_goods: 'Store wants goods',
  please_select_distribution_warehouse: 'Please select a distribution warehouse',
  distribution_warehouse: 'Distribution warehouse',
  choose_customer: 'Select Customers',
  name_phone_card_no: 'Customer name/mobile phone number/associated card number',
  deposit_source: 'Source of stored value',
  deposit_type: 'Storage type',
  store_value_increase_balance: 'Store value (add balance)',
  store_value_reduce_balance: 'Stored value (reduced balance)',
  adjust_fact_recharge: 'Adjustment charge',
  merchant_import: 'Merchant import',
  re_deposital: 'Customers recharge and refund',
  customer_recharge: 'Customer recharge',
  merchant_recharge: 'Merchant recharge',
  gift_consume: 'Consumption courtesy',
  collect_card: 'Registration courtesy',
  gift_level: 'Upgrade with courtesy',
  return_without_order: 'Refund without document',
  card_no: 'Card number',
  cutomer_name: 'Customer name',
  phone_number: 'Phone number',
  deposit_id: 'Stored value list number',
  deposit_channel: 'Store channel',
  deposit_location: 'Store store',
  deposit_pay_type: 'Payment method',
  deposit_money_count: 'Actual amount',
  gift_money_count: 'Amount of gift',
  deposit_money: 'Amount of stored value',
  after_deposit_money: 'Balance after storage',
  customer_stored_value_report: 'Customer stored value details',
  search_phone_cardNo_orderNo: 'Search for mobile phone number, card number, order number',
  cash_card: 'Cash card',
  times_card: 'Product card',
  deposit_card: 'deposit card',
  gift_card_buy: 'Gift card purchase',
  gift_card_rebuy: 'Gift card purchase returned',
  gift_card_consume: 'Customer consumption',
  gift_card_refund: 'Customer refund',
  merchant_send_gift_card: 'Merchants give gift cards',
  fun_game_prize: 'Fun contest prizes',
  cancel_payment: 'Cancel payment',
  customer: 'Customer',
  gift_card_tmpls: 'Gift card template',
  change_time: 'Variable time',
  change_type: 'Variation type',
  change_gift_money: 'Variable grant',
  change_principal: 'Variable principal',
  change_location: 'Changing branch',
  gift_card_balance_log: 'Gift card details',
  dynamic: 'Active',
  archived: 'File',
  draft: 'Drafts',
  has_been_active: 'Effective',
  part_active: 'Part Effective',
  none_active: 'None Effective',
  not_active: 'Not effective',
  card_tmpls_name: 'Card template name',
  activated: 'Activated',
  issued: 'Issued',
  activation_rate: 'Activation rate',
  cancel_money_or_times: 'Amount/number of write-offs',
  use_money_or_times: 'Available balance/times',
  sequence: 'Sequence',
  coupon_template_analysis: 'Voucher template report',
  gift_card_analysis: 'Card template report',
  card_tmpl_kind: 'Card template type',
  issue_date: 'Issue date',
  write_off_date: 'Write off date',
  full_reduce: 'Coupon template',
  discount_coupon: 'Discount coupon',
  reduce_minus_coupon: 'Write down coupon',
  freight_coupon: 'Freight certificate',
  exchange_voucher: 'Voucher',
  exchange_coupon_a_b: 'Buy A and get B coupons',
  free_pass: 'Limited number of tickets free',
  s_coupon_reduction: 'Coupon reduction',
  vouther_name_state: 'Vouther name state',
  not_started: 'Not started',
  expired: 'Expired',
  stoped: 'Terminated',
  write_off_store: 'Write-off store',
  write_off_channels: 'Write off channels',
  usage_note: 'Usage note',
  search_usage_note: 'Search Purpose Remarks',
  discount_ticket_tmpl_name: 'Coupon template name',
  full_reduce_id: 'Coupon template ID',
  released_quantity: 'Released quantity',
  write_off_number: 'Number of write-offs',
  writeoff_rate: 'Write-off rate',
  write_off_money: 'Amount written off',
  pulling_amount: 'Pulling amount',
  pull_rate: 'Pull rate',
  sale_discount_income: 'Sale discount income',
  category_sales_ranking: 'Category Sales Ranking',
  take_out_platform: 'Delivery platform',
  location_take_out_platform: 'Branch - delivery platform',
  OMS_Order_Analysis: 'OMS Order Analysis',
  platform_order_analysis_report: 'Platform order analysis report',
  whether_virtual_phone: 'Whether it is a virtual phone number',
  whether_system_custom: 'Whether it is a system customer',
  customer_order_count: 'Order volume',
  sales_consumptions: 'Sales and consumption of raw materials',
  sensitive_operation_report: 'Sensitive operation report',
  modified_quantity_amount: 'Modified quantity amount',
  number_of_price_changes: 'Number of price changes',
  modify_price_amount: 'Modify price amount',
  number_of_gifts: 'Number of gifts',
  amount_of_gift: 'Amount of gift',
  number_deletions: 'Number of deletions',
  number_deletions_amount: 'Delete quantity amount',
  delete_order_qty: 'Total number of deletes',
  delete_order_money: 'Delete the amount of the entire order',
  discount_nu_qty: 'Number of document discount',
  discount_nu_money: 'Invoice discount amount',
  pending_orders: 'Number of pending orders',
  number_of_returns: 'Number of returns',
  money_of_returns: 'Return amount',
  inverse_closing_frequency: 'Inverse closing frequency',
  inverse_closing_frequency_money: 'Reverse closing amount',
  money_box_was_opened: 'The number of times the money box was opened',
  invalid_business_card_printing_form: 'Invalid business card printing form',
  gift_card_voided: 'Gift card voided',
  create_mark_up_purchase: 'Create a markup purchase',
  total_number_of_additional_purchases: 'Total number of additional purchases',
  additional_purchase_amount: 'Additional purchase amount',
  questionnaire_survey: 'Questionnaire survey',
  loading_questionnaire_survey: 'Loading questionnaire survey',
  deleting_questionnaire_survey: 'Deleting questionnaire survey',
  ending_questionnaire_survey: 'Ending questionnaire survey',
  max_add_n_options: 'Add a maximum of {{n}} options',
  questionnaire_upload_image_tip_1:
    '1、The size of the uploaded image is 1:1. If the size is not set, the image will not be displayed on the client',
  questionnaire_upload_image_tip_2:
    '2、Add [other] item, the client can input text after checking, and add a maximum of 1 other item',
  questionnaire_upload_image_tip_3: '3、You can add up to 15 options',
  create_questionnaire_survey: 'Create questionnaire survey',
  satisfaction_evaluation: 'Satisfaction evaluation',
  service_attitude: 'Service attitude',
  service_speed: 'Service speed',
  very_dissatisfying: 'Very dissatisfied',
  dissatisfying: 'Dissatisfy',
  ordinary: 'Normal',
  satisfying: 'Satisfied',
  very_satisfying: 'Very satisfied',
  mt: 'Meituan',
  douyin: 'Tik Tok',
  ks: 'KuaiShou',
  koubei: 'Public praise',
  deposite: 'Deposite',
  gift_card: 'Gift card',
  benefit_card: 'Equity card',
  discount_ticket_pack: 'Coupon pack',
  repay_on_account: 'Repay on account',
  down_payment: 'Down payment',
  search_performance_mode: 'Search performance mode',
  order_pay_status: 'Order payment status',
  partial_payment: 'Partially paid',
  already_paid: 'Paid',
  partial_refund: 'Partially refunded',
  refunded: 'Refunded',
  abolished: 'Voided',
  request_refund_take_out_platform: 'Request refund (takeaway platform)',
  refuse_refund_take_out_platform: 'Refuse refund (takeaway platform)',
  business_receipt_detail_text1:
    '1. Payment amount: Pay the current amount, such as the balance of 100 yuan (principal 80 bonus 20), the payment amount is 100 yuan.',
  business_receipt_detail_text2:
    '2. Payment of concessions: The amount that counts as the discount portion of the payment amount. For example, if you pay the balance of 100 yuan (principal 80 bonus 20), the discount amount is 20 yuan.',
  business_receipt_detail_text3:
    '3. Paid-in amount: The amount of the paid amount that counts as income. For example, if the balance is paid 100 yuan (principal 80 bonus 20), the actual amount received is 80 yuan.',
  pay_time: 'Pay time',
  pay_money: 'Payment amount',
  payment_preference: 'Payment preference',
  paid_in_amount: 'Paid-in amount',
  businessReceiptDetail: 'Business Receipt Detail',
  amount_involved: 'Amount involved',
  session_product_statistics: 'Meal/time product statistics',
  return_product_statistics_report: 'Return food/product return statistics',
  please_choose_allow_policy: 'Please select a store to order goods',
  allow_request_rule_desc:
    'If it is only available in a store and the item is set to be unavailable for purchase, then only the store is not allowed to order it.',
  business_type: 'Business type',
  businessCategory: 'Business category',
  businessSubcategories: 'Business subcategories',
  businessReceiptStatistics: 'Business Receipt Statistics',
  please_input_sku: 'Please input sku',
  business_store_number: 'Business store number',
  business_store_name: 'Business store name',
  check_store_number: 'Checkout store number',
  check_store_name: 'Checkout store name',
  cost_name: 'Expense items',
  sale_person_statistic: 'Sales statistics report',
  received_the_number_coupons_received_statistical_period:
    'The number of coupons received within the period',
  used_the_number_used_coupons_received_within:
    'The number of coupons used in a period is collected',
  write_off_amount_coupon_template:
    'The amount of an order using a coupon template that is written off by the coupon template',
  active_order_sales_amount: 'Order sales amount using coupon template',
  pulling_amount_tips: `Excluding the actual payment amount of the order after coupon discount, for example, if the order is 100 ${currency_suffix}, the coupon will be deducted 30 ${currency_suffix}, and the remaining 70 ${currency_suffix} will be the pulling amount`,
  pull_rate_tips: 'Pull amount/write-off amount, reflecting the pull effect of the coupon',
  verification_rate_tips:
    'Write-off rate = used/issued, reflecting the write-off status of coupons',
  event_order_customer_tips:
    'The number of customers who placed orders using coupons, and the number of repeat users',
  event_order_new_customer_tips:
    'For new customers who place orders using coupons, filter the number of repeat customers',
  sale_discount_income_tips:
    'The total amount paid for coupons issued within the valid issuance period',
  activity_customer_ordered: 'Active customer',
  activity_new_customer_ordered: 'Activity order new customers',
  received_gift_ttips: 'The number of gift cards the store has issued',
  active_count_tips: 'Number of active gift cards in the store',
  bound_total_amount_tips: 'Activated Total/issued total',
  write_off_money_gift_tips: 'The amount spent using a gift card',
  available_money_tips: 'Amount of the total balance remaining on the gift card',
  cancel_times_of_card: 'The number of times the product card is checked off',
  left_times_of_card: 'Number of times the remaining goods are available',
  available_balance: 'Available balance',
  write_off_count: 'Number of write-offs',
  available_count: 'Available frequency',
  non_operating_income: 'Non-operating income',
  customer_order_price: 'Customer price',
  business_target_report: 'Operating indicators on a sequential basis',
  cashierStatistics_text:
    '1. Collection Subtotal: Counts the total payment amount for all business scenarios of this payment method, including revenue, stored value, gift cards, and signed repayment.',
  account_suspension_pay: 'Repay on account',
  cashier_statistics: 'Cashier statistics',
  deposit_report_analysis: 'Stored value report',
  proportion: 'Proportion',
  new_principal_amount: 'New principal amount',
  bonus_amount_newly_added: 'Bonus amount for newly added storage value',
  new_stored_value_order: 'New stored-value order',
  stored_value_consumption_principal: 'Stored value consumption principal amount',
  stored_value_consumption_gift_amount: 'The proportion of stored-value consumption gift amount',
  new_consumption_orders: 'New stored-value consumption orders',
  newly_added_storage_value_principal_amount_orders:
    'The proportion of newly added storage value principal amount orders',
  stored_value_consumption_principal_proportion:
    'The proportion of stored value consumption principal amount',
  value_gift_amount_orders: 'The proportion of newly added storage value gift amount orders',
  location_date: 'Branch - Date',
  store_payment_method: 'Branch Payment method',
  device_number: 'Device number',
  please_input_device_number: 'Please input device number',
  gate_name: 'Gate name',
  enable_function: 'Enable function',
  screen_settings: 'Side dish screen Settings',
  screen_settings1: 'Transfer screen Settings',
  screen_settings2: 'Production screen Settings',
  kds_settings: 'KDS setup',
  check_store: 'Check store',
  pay_trade_subtitle:
    'Because upstream banks or channels clear and settle the previous transaction day at 15:00 every day, transaction summary only supports querying the data that has been reconciled as of yesterday',
  del_confirm_is: 'Confirm to delete {{title}} ?',
  record: 'record',
  pos_built_in: 'POS built-in',
  bluetooth: 'Bluetooth',
  classic_bluetooth: 'Classic bluetooth',
  drive: 'Drive',
  port: 'Port',
  sale_order: 'Product checkout form',
  order_return: 'Product Return Form',
  card_checkout: 'Card and voucher settlement form',
  card_order_return: 'Card and coupon return note',
  stored_value_note: 'Stored value note',
  member_stored_value_note: 'Member stored value note',
  anti_deposit_order: 'Reverse stored value order',
  point_exchange_order: 'Point redemption form',
  product_rank: 'Product ranking',
  product_type_rank: 'Category ranking',
  inventory_adjust_order: 'Inventory Adjustment Document',
  print_template: 'Print Template',
  print_num: 'Number of copies printed',
  batch_no: 'Batch no',
  label_print: 'Label printing',
  batch_set_printing_templates: 'Batch set printing templates',
  label_print_form: 'Label printing form',
  expiry_price_label_print_form: 'Expiry Price label printing form',
  back_kitchen_menu: 'Back to kitchen menu',
  chef_master_list: 'The master chef',
  kitchen_order_distribution: 'Order in the kitchen',
  business_overview: 'Business overview',
  product_selling_list: 'Product selling list',
  collection_ranking: 'Collection ranking',
  all_pay_name: 'Name of payment method',
  current_sort: 'Current sort',
  comprehensive_data_statistics: 'Comprehensive data statistics',
  composition_of_product_categories: 'Composition of product categories',
  business_scenario_composition: 'Business scenario composition',
  queuing_settings: 'Queue setting',
  queue_call_settings: 'Queue call setting',
  store_selection_list: 'Branch selection list',
  click_a_single_page: 'Single point page',
  confirm_order_page: 'Order confirmation page',
  order_details_page: 'Order details page',
  queue_display: 'Queue display',
  status_setting: 'Status setting',
  color_selection: 'Color selection',
  relaxed: 'Easy',
  production_quantity_less_than: 'Produce less than',
  warning: 'Warning',
  production_quantity_higher_than: 'Produce more than',
  time_setting: 'Time setting',
  current_quantity_not_full: 'Current shortage',
  production_time_is: 'Production duration:',
  every_full_quantity_after_exceeding: 'After the amount of each full',
  production_time_increased: 'Production time increase',
  queuing_display_position: 'Shows location',
  enable_status_display: 'Enabled status display',
  within_minutes: 'Within minutes',
  be_careful: 'Pay attention',
  cannot_be_empty: 'Cannot be empty',
  minute_value: 'Minute',
  cannot_less_than_or_equal_to_quantity_of_easy_production:
    'Cannot be less than or equal to the easily made quantity',
  cannot_less_than_or_equal_to_relaxed_time:
    'Cannot be less than or equal to the state of ease time',
  queued_call_display_location_required: 'Queue call display position Mandatory',
  queue_settins_tip:
    'The queue path for empty stores cannot display the corresponding quantity status based on the current set quantity',
  brand_manage: 'Brand management',
  brand_tatus: 'Brand status',
  brand_logo: 'Brand Logo',
  brand_intro: 'Brand introduction',
  deactivate: 'Deactivate',
  brand_id: 'Brand id',
  actived: 'Activated',
  create_brand: 'Create a brand',
  compile_success: 'Compile success',
  compile_fail: 'Compile fail',
  pos: 'POS',
  kds_equipment: 'KDS equipment',
  printer: 'Printer',
  cloud_printer: 'Cloud printer',
  equipment_setting: 'Equipment setting',
  pos_type: 'POS type',
  binding_state: 'Binding state',
  equipment_state: 'Equipment state',
  equipment_title: 'Equipment title',
  please_input_equipment_title: 'Please input equipment title',
  host: 'Host',
  store_default: 'Store default',
  bound: 'Bound',
  not_bound: 'Not yet bound',
  equipment_code: 'Equipment code',
  invalid_name: 'Invalid',
  refresh: 'Refresh',
  expire_date: 'Expire date',
  create_equipment: 'Create equipment',
  set_host: 'Set host',
  unbind: 'Unbind',
  unbind_success: 'Unbind success',
  application_status: 'status',
  application_version: 'version',
  search_area: 'Search Area',
  activation_quantity: 'Activation quantity',
  total_precipitate_money:
    'The total amount of historical cash cards/stored value cards as of the last day of the statistical period',
  total_precipitate_count:
    'The total number of historical product sub cards as of the last day of the statistical cycle',
  precipitate_money: 'Final settlement amount',
  precipitate_count: 'Final sedimentation frequency',
  rename: 'Rename',
  move_up: 'Move up',
  move_down: 'Move down',
  new_classification_succeeded: 'New classification succeeded',
  parent_classification: 'Parent classification',
  success: 'Success',
  available_point: 'Available point',
  available_point_tips: 'Available credits: indicates the currently available credits',
  total_point: 'Total point',
  loading_customer_list: 'Loading the customers',
  total_point_tips: 'Total points: total points of the user at present, including frozen points',
  freezn_point: 'Freezing point',
  search_customer_with: 'Search for customers',
  freezn_point_tips:
    'Frozen credits: In the case of incomplete payment, in order to avoid repeated use of credits, the credits used in the unpaid order will be frozen as frozen credits; Cancel the unpaid order to unfreeze the frozen points.',
  total_balance: 'Total balance',
  total_balance_tips:
    'Total balance: indicates the total current balance of the user, including the frozen balance',
  freezn_balance: 'Frozen balance',
  freezn_balance_tips_1:
    'Frozen balance: 1.The total of the actual amount and the gift amount in the pending state of the application for refund of stored value.',
  freezn_balance_tips_2:
    "After the merchant sets the frozen store value amount, the amount of the customer's store value will be frozen.",
  freezn_after_function_tips:
    "After freezing, members' points and value storage functions will no longer be used, no longer enjoy the rights and interests of members, and the small program cannot carry out relevant operations. Sure freeze?",
  are_you_sure_thaw: 'Are you sure you want to defrost?',
  adjust_balance_deposite_rule_other_reward:
    'Note: The balance adjustment does not trigger the stored value rule, and there is no extra bonus',
  available_point_tip: 'Total points available to members under screening conditions',
  point_expend_rate_tip: 'Cumulative consumption points/cumulative distribution points',
  total_give_out_point_tip: 'Total points issued under screening conditions',
  total_consume_point_tip: 'Sum of point consumption under screening conditions',
  expired_point_tip: 'The total number of expired credits under the screening condition',
  interact_customer_count_tip:
    'The number of members who consume or obtain points under the screening condition',
  gain_interact_customer_count_tip:
    'The number of members who have the behavior of obtaining points under the screening condition',
  expend_interact_customer_count_tip:
    'The number of members who consume points under the screening condition',
  point_expend_rate: 'Point consumption rate',
  expired_point_count: 'Number of expired credits',
  interact_customer_count: 'Total interactive members',
  gain_interact_customer_count: 'Get the number of points members',
  expend_interact_customer_count: 'Consume the number of points members',
  total_give_out_point: 'Cumulative credit',
  total_consume_point: 'Cumulative consumption point',
  expired_point: 'Overdue credit',
  point_statistics_tip:
    'The increase in the consumption rate of points and the number of interactive members indicates that points can effectively stimulate the activity of members.',
  point_analysis_report: 'Point analysis',
  point_analysis: 'Point report',
  point_statistics: 'Point statistics',
  point_trend: 'Point tendency',
  give_out_point: 'Issue credits',
  expend_point: 'Consumption point',
  interact_customer: 'Interactive membership',
  point_total_got_distribution: 'The point accumulates to obtain the distribution',
  point_total_consume_distribution: 'Point cumulative consumption distribution',
  point_report: 'Point statement',
  give_out_type: 'Distribution channel',
  give_out_point_value: 'Issue point value',
  expend_type: 'Path of consumption',
  expend_point_value: 'Consumption point value',
  store_unfinished_order_statistics: 'Store unfinished order statistics',
  cash_pledge: 'cash pledge',
  benefit_card_analysis: 'Equity card report',
  benefit_card_customer: 'Right card customers',
  not_benefit_card_customer: 'Non Right card customers',
  money_rate: 'Proportion of amount',
  customer_order_count_rate: 'Proportion of customer orders',
  customer_order_product_count: 'The number of items in the customer order',
  current_customer_count: 'Current number of customers',
  cumulative_customer_count: 'Cumulative number of customers',
  cumulative_sale_money: 'Cumulative sales amount',
  cumulative_renew_money: 'Cumulative renewal amount',
  benefit_card_purchase_count: 'Right card purchases',
  benefit_card_sale_money: 'Right card sales amount',
  choose_datetime_range_data: 'Data for the selected time period',
  benefit_card_data: 'Right card data',
  generate_production_command_order: 'Generate Production Order Form',
  production_command_order: 'Generate Production Order',
  export_production_command_order: 'Export Generate Production Order',
  dimension_of_raw_materials: 'Dimension of raw materials',
  task_release_date: 'Task release date',
  produce_product_info: 'Processed product information',
  plan_production_quantity: 'Planned production quantity',
  raw_material_info: 'Raw material information',
  production_order: 'Production order',
  production_order_no: 'Production order numbers',
  produciton_product_desc:
    'A total of {{num}} tasks have been released, which can be allocated in the production task order',
  sit_down_setting: 'Sit-down setting',
  sit_down_tip: 'Customers dine in and scan the code to place an order',
  self_pickup_settings: 'Self pickup settings',
  self_pickup_tip: 'Customers place orders online and pick them up in store',
  takeout_settings: 'Takeout settings',
  takeout_tip: 'Customers place orders online and merchants deliver them',
  group_meal_self_pickup_settings: 'Group Meal - Self pickup Settings',
  group_meal_self_pickup_tip: 'Group meal customers place orders online and pick them up in store',
  group_meal_takeout_settings: 'Group Meal - Takeout Settings',
  group_meal_takeout_tip: 'Group meal customers place orders online and merchants deliver them',
  go_set_it_up: 'Go set it up',
  week_retained_users: '{{name}} Number of retained users per week',
  week_retention_rate: '{{name}} Weekly retention rate',
  day_retained_users: '{{name}}day retained users',
  daily_retention_rate: '{{name}}Daily retention rate',
  time_p: 'time',
  order_distance_limit: 'Point order distance limit',
  headquarters_setting: 'Headquarters setup',
  location_setting: 'Store setup',
  order_conversion_rate_tips:
    'Access to a display of data changes that occur from order to payment. The number of visitors includes wechat mini program, excluding platform mini program, POS and webpage background.',
  mall_traffic_overview_report: 'Overview of Mall Traffic',
  view_examples: 'View example',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  del_distribution_tips:
    'Determine the deletion of this scheme it cannot be restored after deleting',
  locations_participate_count: '{{count}} branch do participate',
  locations_not_participate_count: '{{count}} branch does not participate',
  temporary_assignment: 'Temporary Assignment',
  daily_settlement: 'Daily Settlement',
  monthly_settlement: 'Monthly Settlement',
  cash_on_delivery: 'Cash on Delivery',
  payment_before_shipment: 'Payment Before Shipment',
  settlement_method: 'Settlement Method',
  auxiliary_quantity: 'Auxiliary quantity',
  main_parameters: 'Main parameters',
  unitPrice: 'Unit Price',
  unit_of_Measurement_desc:
    'When used by dish cost cards, production recipes, and virtual items, the unit and conversion rate cannot be modified.',
  please_enter_name: 'Please enter{{name}}',
  applet: 'Applet',
  title: 'Title',
  the_length_of_appid_must_be_18_digits: 'The length of appid must be 18 digits',
  mp_path: 'Mini program path',
  cover: 'Cover',
  please_enter: 'Please enter',
  associated_with_the_enterprise: 'Associated with the enterprise',
  please_view_the_path_of_the_mini_program:
    'Please view the path of the mini program in the data analysis section of the mini program management background',
  web_page: 'web page',
  link_name: 'Link',
  please_enter_the_correct_link_format: 'Please enter the correct link format',
  picture: 'Picture',
  please_upload_pictures: 'Please upload the image first!',
  text_content: 'Text content',
  video: 'Video',
  please_upload_image: 'Please upload image',
  material_library: 'Material library',
  batch_delete: 'Batch delete',
  confirm_delete_transfer:
    'Are you sure you want to delete it? (cannot be restored after deletion)',
  delete: 'Delete',
  creation_time: 'Creation time',
  text: 'Text',
  search: 'Search',
  customer_source: 'Customer Source',
  loss: 'Loss',
  remain: 'Reamin',
  is_vip: 'Is it a member',
  support: 'Yes',
  not_support: 'No',
  tag_name: 'Tag name',
  synchronize_customers: 'Synchronize customers',
  label: 'Label',
  customer_exception: 'There is an exception for this customer, please contact the administrator',
  processing_state: 'Processing state',
  delivery_status: 'Delivery status',
  unprocessed: 'Unprocessed',
  successful_retweet: 'Successful repush',
  have_ignored: 'Have ignored',
  undelivery: 'Ship pending',
  shipped: 'Shipped',
  partial_shipment: 'Partially delivered',
  ready: 'Ready',
  o_received: 'Received',
  pending_order: 'Pending order',
  has_taken_order: 'Received order',
  order_receiving_exception: 'Order receiving exception',
  distribution_anomaly: 'Distribution anomaly',
  abnormal_payment: 'Abnormal payment',
  deposit_exception: 'Deposit exception',
  abnormal_order: 'Abnormal orders',
  retweet: 'Retweet',
  ignore: 'Ignore',
  batch_retweet: 'Batch retweet',
  batch_ignore: 'Batch ignore',
  abnormal_reason: 'Abnormal reason',
  ignore_success: 'ignore success',
  ignore_acknowledgement: 'Ignore acknowledgement',
  confirm_ignore: 'Confirm ignore',
  repush_confirmation: 'Repush confirmation',
  confirm_repush: 'Whether to confirm repush',
  redelivery: 'Redelivery',
  refund: 'refund',
  re_delivery_confirmation: 'Re delivery confirmation',
  sure_to_resend: 'Are you sure to resend',
  look: 'View',
  pending_fulfillment_order: 'Ship pending',
  repaired_successfully: 'Repaired successfully',
  pending_processing: 'Pending processing',
  payment_platform_status: 'Payment platform status',
  refund_success: 'Refund successful',
  appeal_success: 'Successful appeal',
  appeal: 'Appeal',
  refresh_check: 'Refresh check',
  select_used_narks_add_to_product:
    'Select the previously used tag from the list below and add it to this item.',
  all_labels: 'All labels',
  add_tag_tip:
    'If the target label is not found, you can try clicking on the update to synchronize the label, or simply adding a new one',
  customer_base: 'Customer base',
  group_Name: 'Group Name',
  group_leader: 'Group leader',
  group_size: 'Group size',
  join_the_group_on_the_same_day: 'Join the group on the same day',
  withdrawal_on_the_same_day: 'Withdrawal on the same day',
  sync_customer_groups: 'Synchronisation of customer groups',
  ready_to_pick_up: 'Ready to pick up',
  to_be_picked_up: 'Wait for oneself',
  account_outstanding: 'Account outstanding',
  account_closed: 'Account closed',
  withdrawn_order: 'Withdrawn order',
  cleared_table: 'Cleared table',
  invite_to_join_the_group_1: 'Directly invite to join the group',
  invite_to_join_the_group_2: 'Link invitation to join group',
  scan_code_into_group: 'Scan code into group',
  staff: 'Staff',
  visitors: 'Visitors',
  group_owner_management: 'Group owner management',
  belong_department: 'Departments',
  search_department: 'Search department',
  sex_male: 'Male',
  sex_female: 'Female',
  employee_management: 'Employee management',
  tips: 'Tips',
  application_role: 'Application Role',
  binding_time: 'Binding Time',
  total_customers: 'Total Customers',
  community_data: 'Community Data',
  total_groups: 'Total Groups',
  join_the_group_today: 'Join the group today',
  withdrawal_from_group_today: 'Withdrawal from group today',
  today_add: 'New Today',
  today_loss: 'Todays loss',
  employee_interface_manage: 'Employee Interface Manage',
  order_record: 'Order Record',
  account_details: 'Account details',
  export_license_account: 'Export License Account',
  interface_permission_sceret: 'Interface License Key',
  wecompany_role_management: 'Enterprise and Micro Role Management',
  loading_role_management: 'Loading enterprise and micro role management',
  no_query_role_management: 'No enterprise micro role management found',
  sure_you_want_to_delete_role: 'Are you sure you want to delete the role',
  sure_you_want_to_delete_group_code: 'Are you sure you want to delete the community active code',
  sure_you_want_to_delete_channel_code: 'Are you sure you want to delete the channel active code',
  role_name: 'Name',
  return_goods: 'return goods',
  permission_wecom_error_tips:
    '60020, error message: Access IP is not on the whitelist; The service provider is applying for an IP whitelist. Please try again later.',
  please_permission_wecom: 'Please authorize enterprise WeChat',
  scrm_wechat_application_title: 'Linking enterprise WeChat to make enterprise operations simpler',
  scrm_wechat_application_title_sub:
    'By combining mini programs, h5, and enterprise WeChat, marketing reach is made more effective. Make work easier through unified membership management.',
  authorized_agent_development_application: 'Authorized agent development application',
  completion_of_authorization:
    'Completion of authorization for development of applications on behalf of others',
  scan_code_to_use_lezhi_enterprise_micromanager: 'Scan code to use Lezhi Enterprise Micromanager',
  authorized_development_application:
    'Authorized development application - Lezhi Enterprise Micromanager',
  authorized_development_application_subtitle:
    'Employ enterprise WeChat QR code scanning authorization to develop applications, distribute tasks to customers, communities, and other headquarters, and employees can receive information on their mobile phones',
  using_enterprise_scaning: 'Using Enterprise WeChat QR Code Scanning',
  config_contact_secret_tips:
    'The authorization for the proxy development application has been completed. Please contact the customer service manager to complete the proxy development application configuration for the official backend of the enterprise and WeChat',
  have: 'have',
  accounts_will_expired: 'Account is about to expire, please renew as soon as possible',
  accounts_expired: 'The account has expired, please renew it as soon as possible',
  sub_industry_of_the_enterprise: 'Sub industry of the enterprise',
  enterprise_id: 'enterprise id',
  application_logo: 'application Logo',
  application_expiration_time: 'Expiration time',
  application_available_accounts: 'Available accounts',
  wechat_add_purchase_account: 'Enterprise WeChat Assistant adds purchase account',
  wechat_account_fee_renewal: 'Renewal of Enterprise WeChat Assistant Account',
  enterprise_permanent_authorization_code: 'Enterprise Permanent Authorization Code',
  application_name: 'Application Name',
  surplus: 'Surplus',
  buy_now: 'Buy now',
  account_renewal: 'Account renewal',
  add_purchase_account: 'Additional purchase account',
  application_free_desc:
    'Due to the "interface call license fee" charged by Enterprise WeChat to service providers, the Enterprise WeChat application will be charged according to the new method, Click the button below to view the details.',
  amount_number: 'Number of accounts',
  and_above: 'And above',
  fee_standard: 'Fee standard (yuan)',
  yuan_account_year: 'Yuan/Account/Year',
  discuss_personally: 'Discuss personally',
  charging_for_account_fee: "The account fee is collected by the enterprise's WeChat account",
  charging_policy: 'Charging policy',
  charging_standards_follows: 'The charging standards are as follows:',
  application_account_fee_desc:
    'Explanation: 1. Adding an account does not affect the validity period of the function. 2. Account billing cannot cross levels, for example, if a merchant requires 300 accounts, the fee is 5 × 50+(200-5) × 40+(300-200) × 30=11050',
  application_cost_desc: 'Explanation of Enterprise Micro Application Costs',
  dear_lemon_user: 'Dear Lemon user',
  hello: 'Hello',
  application_cost_desc_content:
    'Due to the fact that Enterprise WeChat has been charging interface call license fees to service providers across the industry since May 16, 2022, in order to provide better long-term, healthy, and stable service to merchants, merchants who install applications after May 16, 2022 will be charged according to the new charging standard: software service fee+account fee. The detailed cost description is as follows,Please be informed that:',
  cost_rules:
    'Account billing cannot cross levels, for example, if a merchant requires 300 accounts, the fee is 5 × 50+(200-5) × 40+(300-200) × 30=11050',
  lemon_production_team: 'Lemon Product Team',
  year_month_day: 'January 2, 2024',
  thanks_for_you: 'Thank you for your understanding and support of Lemon all along!',
  mini_program_payment_verification: 'Mini program payment verification',
  short_message: 'Text message',
  create_equity_account: 'Create equity account',
  equity_account: 'Equity account',
  title_of_account: 'title of account',
  search_for_account_name: 'Search for account name',
  account_type_2: 'Account type',
  store_account_settings: 'Store account settings',
  suit_to_location: 'Applicable branch',
  export: 'Export',
  export_success: 'Exporting. Check the task center',
  function_description: 'Function description',
  batch_operation: 'Batch operation',
  application_infomoration: 'Application infomoration',
  charging_standard: 'Charge standard',
  buy_and_renewal: 'Purchase and renewal',
  cost_accounts: 'Renewal account',
  group_name_prefix: 'Group name prefix',
  add_purchase_account_tip: 'Additional purchase account cannot be 0',
  renew_account_tip: 'Please check at least one renewal account',
  affirm: 'Affirm',
  current_number_of_accounts: 'Current number of accounts',
  costs: 'Costs',
  selected_accounts: 'Number of selected accounts',
  pay_one_yaer: 'Renewal for one year',
  delivery_platform_orders: 'Delivery platform orders',
  meituan_waimai_API_call: 'Takeaway API Call',
  support_platform: 'Support platform',
  call_base_setting: 'Call basic Settings',
  order_overtime_limit: 'Order timeout limit',
  voice_call_setting: 'Voice call setting',
  call_switch: 'Voice call switch',
  call_switch_tip:
    'When it is turned on, the kitchen voice prompt will be displayed in the corresponding calling terminal when the number is called',
  call_content: 'Voice call content',
  call_num: 'Number of calls',
  call_speed: 'Call speech speed',
  fast: 'fast',
  slow: 'Low speed',
  abort: 'Abort',
  hook: 'loss',
  unhook: 'unhook',
  support_order_type: 'Support order type',
  collected_order_display: 'The collected order is displayed',
  app: 'APP',
  order_assistant_app: 'Order assistant app',
  channels: 'Sales channels',
  coupon: 'Coupon',
  full_reduction_full_discount: 'Full minus full discount',
  time_limit_discount: 'Limited time discount',
  second_half: 'Full of X pieces Y discount',
  show_second_half: 'View full of X pieces Y discount',
  full_gift: 'Full gift',
  figt_deposit: 'Be polite when storing value',
  gift_birthday: 'Birthday courtesy',
  friend_fission: 'Friend fission',
  collect_stamp: 'Collector card',
  point_mall: 'Points mall',
  pop_up_coupon: 'Popover coupons',
  gift_sign_in: 'Sign in courtesy',
  get_discount: 'Coupon activity',
  send_discount: 'Precision marketing',
  freight_reduction: 'Reduced freight',
  any_choice: `N ${currency_suffix} optional`,
  recommend_product: 'Recommended goods',
  new_customer_exclusive: 'New guest only',
  random_fullReduce: 'Random increment',
  adjustment_is_product_library_variant_price_cannot_empty:
    'When the dimension of the price adjustment sheet is the product library, the product specification price cannot be empty',
  check_at_least_one_member_price_or_current_price:
    'Check at least one member price or current price',
  check_at_least_one_member_price_or_current_price1:
    'Check at least one equity card price or current price',
  enter_greater_zaro_and_less_ten_tips:
    'Please enter 1 decimal place greater than 0 and less than 10',
  enter_specified_price: 'Enter specified price',
  between_discount: 'Between 0.1 and 9.9',
  import_reduction_amount: 'Import reduction amount',
  choose_goods: 'Select product',
  discount_method: 'Preferential mode',
  adjust_price_location: 'Price change branch',
  adjust_price_order: 'Price adjustment',
  adjust_product: 'Price adjusted goods',
  adjust_product_tip:
    'If the current price is not filled in, the product file will be read. For the same product, different levels of membership prices can only choose the same discount method, such as setting a specified price for all levels, setting discounts, or setting price reductions',
  adjust_price_order_info: 'Price adjustment sheet information',
  adjust_price_order_order_no: 'Price Adjustment Order Number',
  effect_time: 'Effective time',
  immediate_effective: 'Effective immediately',
  fixed_time_effective: 'Effective on schedule',
  modify_specified_price_bulk: 'Modify the specified price in bulk',
  batch_modification_discount: 'Batch modification discount',
  bulk_modification_reduction: 'Bulk modification reduction',
  create_adjust_price_order: 'Create price adjustment form',
  edit_adjust_price_order: 'Edit price adjustment form',
  copy_adjust_price_order: 'Copy price adjustment form',
  cancel_adjust_price_order: 'Cancel price adjustment form',
  delete_adjust_price_order: 'Delete price adjustment form',
  submit_adjust_price_order: 'Submit price adjustment form',
  adjust_price_dimension: 'Price adjustment dimension',
  total_discount_money: 'Discount',
  condition: 'Condition',
  special_price: 'Special price',
  special_price_not_support_pos_application:
    'Special price type does not support POS application, only supported by micro shop and platform mini program',
  reduce_price: 'Reduce price',
  product_cost_price: 'Cost price',
  current_location_price: 'Current branch price',
  current_price: 'Current price',
  give_discount: 'Discount',
  appoint_price: 'Specify price',
  product_price_rounding: 'Rounding',
  product_price_rounding_desc:
    'For each level rule, when selecting the discount method as discount or discount, you can set points to be deducted, corners to be deducted, and points to be deducted',
  retain_dime_and_cent: 'Preserve angles and minutes',
  remove_cent: 'Remove points',
  remove_dime_and_cent: 'Remove corners and divisions',
  get_product_price: 'Read File Price',
  must_order_product_plan: 'Must point product plan',
  must_order_product_plan_search: 'Search based on the required product scheme name',
  plan_channels: 'Solution channels',
  required_point_type: 'Required point type',
  plan_status: 'Plan status',
  loadding_must_order_product_plan: 'Loading mandatory product proposals',
  create_plan: 'Create Scheme',
  show_must_order_product_plan: 'View a must order plan',
  copy_must_order_product_plan: 'Copy a must order plan',
  create_must_order_product_plan: 'Create a must order plan',
  edit_must_order_product_plan: 'Edit a must order plan',
  end_must_order_product_plan: 'End mandatory product plan',
  confirm_end_must_order_product_plan:
    'Confirm the end of the mandatory product plan, which cannot be restored after completion',
  delete_must_order_product_plan: 'Delete mandatory product scheme',
  confirm_delete_must_order_product_plan:
    'Confirm the deletion of the mandatory product plan, which cannot be restored after deletion',
  enter_scheme_name: 'Please enter the scheme name',
  plan_time: 'Plan time',
  plan_cycle: 'Plan cycle',
  sell_mode: 'Sale model',
  table_meal_mode: 'Table meal mode',
  table_meal_mode_tip:
    'Click on "Table" in the POS/Waiter Ordering APP and select a table for ordering and checkout. Only the Lemon Catering Platform version is effective',
  direct_ordering_mode: 'Direct ordering mode',
  scan_order_mode: 'Scan code ordering mode',
  scan_order_mode_tip:
    'Customers use their mobile phones to scan the location code on the table to order food, and then the waiter delivers it to the table',
  direct_ordering_mode_tip:
    'Directly proceed with ordering and checkout. The non stand and stand versions of Le Meng Catering will take effect by clicking "Fast Food" on the fast food version or stand version',
  online_self_pickup: 'Online self pickup',
  online_self_pickup_takeout: 'Online self pickup takeout',
  plan_detail: 'Plan details',
  in_store_cash_register: 'In store cash register',
  search_empty_station: 'Search station type',
  specify_station_type: 'Specify station type',
  no_query_station: 'No station type found',
  select_station: 'Select the type of workstation',
  please_enter_station_type_name: 'Please enter the name of the station type',
  loading_station: 'Loading station types',
  pre_people_must_order: 'Each person must order 1 copy',
  pre_people_must_order_tip:
    'Suitable for occasions where each person must order tableware, tea table fees, dipping sauces, etc',
  each_order_must: 'Each order must be ordered once',
  each_order_must_tip:
    'Suitable for scenarios where tissues, hot pot bottoms, and other items are ordered on a per order or per table basis, not based on the number of people',
  change_sell_mode_tip:
    'The selected sales model does not support setting the mandatory order type to "1 order per person". It has been automatically changed to "1 order per order" for you',
  fixed_products: 'Fixed products',
  optional_products: 'Optional products',
  essential_rules: 'Essential Rules',
  product_to_be_must: 'Required product',
  select_product_less_than_100: 'Select up to 100 products',
  product_add_to_cart: 'Required items automatically added to the shopping cart',
  product_add_to_cart_tip:
    'Fixed products "add required products to the shopping cart according to the set requirements. If the required product is a package and there are optional product groups, a pop-up window will display the product for the waiter or customer to select and add to the shopping cart; The "optional products" will pop up a window displaying all optional mandatory items for the waiter or customer to select and add to the shopping cart',
  customer_can_update: 'Customers can manually modify required items',
  customer_can_update_tip: 'If it can be modified, customers can change the quantity to "0"',
  place_check: 'Check required dishes when placing an order',
  place_check_tip:
    'Check if there are mandatory items in the shopping cart or ordered items when placing an order',
  checkout_check: 'Check required items during settlement',
  checkout_check_tip: 'Check if there are any required items in the ordered items during checkout',
  only_tip: 'Only provide prompts',
  can_not_checkout: 'Cannot settle the bill',
  please_select_sell_mode: 'Please select the sales model first',
  please_enter_plan_name: 'Please enter the scheme name',
  please_choose_sell_mode: 'Please choose a sales model',
  cart_tip:
    'The sales mode for automatically adding required products to the shopping cart must select at least one option',
  customer_tip:
    'Customers can manually modify the sales mode of required products by selecting at least one option',
  order_check_tip:
    'When placing an order, check the sales mode of the required dishes and select at least one option',
  settle_check_tip:
    'Check the sales mode of the required item during settlement and select at least one option',
  product_time_period: 'Product Period',
  recommend_add_purchase: 'Recommend additional purchases',
  collect_point: 'Collector card',
  store_order_discount: 'Store value order offer',
  lucky_draw_gift: 'Raffle courtesy',
  scan_code_pay_discount: 'Pay discount',
  title_display: 'Title display',
  food_delivery_code: 'Food delivery code',
  del_supplier_role_with_no: 'Please confirm whether to delete[{{name}}]',
  supplier_user_role: 'Supplier user role',
  supplier_user: 'supplier user',
  supplier_whchat_unbind: 'Unbind supplier WeChat',
  read_supplier_whchat_unbind: 'Read Unbind supplier WeChat',
  whchat_unbind: 'Unbind WeChat',
  confirm_unbind: 'Are you sure to unbind?',
  confirm_unbind_tip:
    'After unbinding, this account will not receive ordering information. If you need to bind again, you need to scan the code again on the supplier management interface to bind',
  bind_wechat_nickname: 'Already bound WeChat nickname',
  times: 'Times',
  call_number_setting: 'Call setting',
  weapp: 'weapp',
  channel_code: 'Channel code',
  add_grouping: 'Add grouping',
  code_name: 'Live code name',
  please_enter_code_name: 'Please enter a code name',
  search_location: 'Search branch',
  all_location: 'All branches',
  designate_location: 'Designated branch',
  use_staff: 'employee',
  today_new_add_friends_num: 'Number of new friends added today',
  new_seven_add_friends_num: 'Number of new friends added in the last 7 days',
  number_of_lost_friends_today: 'Number of lost friends today',
  Number_of_lost_friends_in_the_past_seven_days: 'Number of lost friends in the past seven days',
  new_add_friends_total: 'Total new friends',
  retained_friends: 'Number of retained friends',
  new_add_friends_num: 'Add friends',
  total_number_friends_added: 'Total number of friends added',
  total_loss: 'Total loss',
  create_channel_code: 'Create channel tokens',
  download_channel_code: 'Download channel code',
  all_group: 'Total grouping',
  please_input_group_name: 'Please enter the group name',
  cannot_input_spaces: 'Cannot input spaces',
  add_success: 'Successfully added',
  confirm_delete_module: 'Are you sure you want to delete {{title}}',
  after_del_group_not_recovery: 'Confirm to delete the group, it cannot be restored after deletion',
  enter_group_name: 'Please enter a group name',
  add_custom_group: 'Add custom grouping',
  edit_custom_group: 'Edit Custom Group',
  del_custom_group: 'Delete Custom Group',
  group: 'Group',
  group_name: 'Group Name',
  mp_qr_code: 'Mini program QR code',
  select_group: 'Select group',
  design_store_do_not_particpate: 'Designated stores will not participate',
  delete_area_succeeded: 'Successfully deleted region',
  move_area_up_successfully: 'Successfully moved area up',
  move_area_down_successfully: 'Successfully moved area down',
  move_area_succeeded: 'Successfully moved area',
  add_subarea: 'Add Sub Region',
  delete_area: 'Delete Region',
  change_store_area: 'Change branch area',
  area_renamed_successfully: 'Region rename successful',
  area_rename: 'Area renaming',
  area_name: 'Area Name',
  subregion_added_successfully: 'Successfully added sub region',
  new_area: 'New Area',
  superior_region: 'Superior Region',
  change_area_succeeded: 'Successfully changed the area',
  confirm_want_to_delete_the_selected_area: 'Are you sure you want to delete the selected area?',
  deleted_region_content:
    'Only delete the region, do not delete the stores under the region, and the stores in that region will automatically be classified as the upper level region',
  please_enter_a_region_name: 'Please enter a region name',
  select_location_zone: 'Support platform, please select region',
  batch_import_account_benefits: 'Batch import account benefits',
  default_template_for_account_equity: 'Default template for account equity',
  deposit_card_retrieve: 'Stored value card recycling',
  refund_shipping: 'Refund of freight',
  deliver_fee_total_money: 'Freight',
  only_you_see_reason: 'Only you and other staff members can see this reason',
  restock_product: 'Reentry goods',
  items_that_have_been_refunded_willbe_removed: 'Refund items will be removed from the order.',
  under_delivery: 'Under delivery',
  picking_up: 'The goods are being taken',
  please_fill_remarks_reason: 'Refund Processing Remarks Mandatory',
  order_refund_successful: 'Order refund successful',
  the_goods_have_been_refunded_successfully: 'The goods have been refunded successfully',
  the_goods_have_been_put_back_into_storage: 'The goods have been put back into storage',
  abstract: 'Abstract',
  commodity_subtotal: 'Product subtotal',
  product_mount_suffix: 'Item',
  total_refund: 'Total refund',
  no_products_selected: 'No merchandise was selected',
  this_order_is_pending_payment: 'This order is awaiting payment',
  ok_refund_money: 'Refundable amount',
  amount_are_refunding_different_total_suggested_refund:
    'The amount you are refunding is different from the suggested total',
  updating: 'Update',
  returnable_quantity: 'Returnable quantity',
  refund_quantity: 'Refund quantity',
  customer_base_searth: 'Search for customer groups',
  customer_base_searthing: 'Searching for group chat',
  whether_to_automatically_reate_a_group: 'Whether to automatically create a group',
  go_group_person: 'Number of people entering the group',
  back_group_person: 'Number of people leaving the group',
  automatic_group_building_tips:
    'After the group chat reaches the maximum number of people (the maximum number is 200 people), a new group will be automatically created as the original group owner (a live code can have up to 5 group chats, and when it reaches 5 group chats, there will be no automatic group creation)',
  automatic_group: 'Automatic group building',
  set_group_meaasge: 'Set group messages',
  total_number_of_group_members_retained: 'Total number of group members retained',
  total_number_of_group_members_loss: 'Total number of group members lost',
  create_community_01_code: 'Create a community code',
  batch_import_of_store_account_benefits: 'Batch import of store account benefits',
  default_template_for_store_account_settings: 'Default template for store account settings',
  pocket_code_is_required: 'Pocket code is required',
  link_name_required: 'Link name required',
  create_lbs_friends: 'Create LBS friends',
  p_please_enter_name: 'Please enter name',
  p_link_name: 'Link name',
  link_name_tips: 'The name is not shown to the user and is used for linking business records',
  select_pocket_code: 'Select pocket size',
  search_pocket_code: 'Search the pocket code',
  copywriting1: 'Copy 1',
  copywriting2: 'Copy 2',
  please_enter_copy: 'Please enter copy',
  here_background_image: 'Here is the background image',
  selective_code: 'Selective code',
  please_enter_link_name: 'Please enter a link name',
  pocket_code: 'Pocket code',
  create_link: 'Create a new link',
  employee_friend_code: 'Configure shop channel friend code',
  friend_code_tips:
    'LBS add friends function, you can set the channel code to associate with the corresponding store, automatically locate the corresponding store and push the employee channel code after the setting is successful, so as to quickly add the store employee as a friend, and send a welcome message after the successful addition',
  channel_code_association: 'Channel code association',
  number_of_friends_added: 'Number of friends added',
  friend_code_list: 'Buddy code list',
  query_by_store_name: 'Search by store name',
  loading_lbs_friends_code: 'Loading friend code',
  no_query_lbs_friends_code: 'The friend code is not found',
  download_lbs_promotion_code: 'Download LBS Promotion Code',
  lbs_promotion_code: 'LBS Promotion Code',
  download_lbs_qr_code: 'Download LBS QR code',
  lbs_qr_code: 'LBS QR Code',
  de_authorize: 'de-authorize',
  download_lbs_applet_code: 'Download LBS applet code',
  copy_path: 'Copy Path',
  edit_supplierUser_with_name: 'Edit supplier user [{{supplierName}}]',
  create_supplierUser_with_name: 'Create supplier user [{{supplierName}}]',
  gift_card_order: 'Gift card order',
  right_card_order: 'Equity card order',
  ticket_pack_order: 'Coupon order',
  payment_status_2: 'Payment status',
  un_pay: 'Payment pending',
  balance_pay: 'Balance payment',
  gift_card_payment: 'Gift card payment',
  customer_phone: 'Customer mobile phone number',
  view_details: 'View details',
  copy_settings_to_other_stores: 'Copy settings to other stores',
  copy_content: 'Copy content',
  category_dimension: 'Category dimension',
  all_categories: 'All categories',
  first_level_category: 'First level category',
  secondary_category: 'Secondary Category',
  branch: 'Branch',
  select_employees: 'Select Employees',
  select_operation_mode: 'Select Operation Mode',
  search_operation_mode: 'Search Operation Mode',
  operation_time: 'Operation Time',
  operation_function: 'Operation Function',
  operation_mode: 'Operation Mode',
  operation_log: 'Operation Log',
  client_ip: 'Client IP',
  terminal_name: 'Terminal name',
  authorized_user: 'Authorized user',
  customers_of_total_contain:
    'The total number of enterprise WeChat customers, including historical customers whose friends have been deleted',
  customers_of_total_notcontain:
    'Net number of enterprise WeChat customers, excluding historical customers whose friends have been deleted',
  customers_of_total_notcontain_add:
    'Net number of new customers added to Enterprise WeChat, excluding historical customers whose friends have been deleted',
  compared_to_the_previous_day: 'Compared to the previous day',
  community_code: 'Community code',
  customer_group_sends: 'Customer group posting',
  community_post: 'Community post',
  group_send_assistant: 'Group send assistant',
  join_group_people:
    'This parameter mainly calculates the ability of live code to attract new users, including the number of people leaving the group',
  number_of_friends_added_tip:
    'This parameter mainly calculates the ability of live code to attract new users, including the number of lost users',
  wechat_ranking: 'Ranking',
  delivery: 'Distribution',
  logistics: 'Logistics',
  rider_did_not_accept_order: 'Rider (or Courier) did not receive order',
  rider_has_accepted_order: 'The rider (or Courier) has taken the order',
  no_accept_order: 'Missed order',
  deliverying: 'In delivery',
  mercury_2: 'Mercury 2.0 (Micro Mall)',
  wholesale_sales_list: 'Wholesale sales order',
  light_meal: 'Light meal',
  mars_product: 'Mars products',
  ama_product: 'AMA products',
  wxjsps: 'Instant delivery on wechat（WXJSPS）',
  mtps: 'Meituan distribution（MTPS）',
  sftc: 'Sf Express express in the same city（SFTC）',
  sjps: 'Merchant distribution（SJPS）',
  dada: 'Dada express（DADA）',
  uu: 'UU runs errands（UU）',
  arrived: 'Delivered',
  speed_of_light: 'Light velocity-{{number}}',
  fast_reach: 'Rapid access-{{number}}',
  arrive_in_time: 'Timely arrival',
  ss: 'ShanSong（SS）',
  location_tag: 'Location tag',
  tag_label_name: 'Tag name',
  use_location: 'Using a store',
  please_input_tag_name: 'Please enter a label name',
  select_start_date: 'Select start date',
  select_end_date: 'Select End Date',
  location_status: 'Branch status',
  deactivate_store: 'Deactivate branch',
  enable_store: 'Activate branch',
  temporary_branch_closed: 'Temporary closure',
  recover_business: 'Resume business',
  contacts: 'Contact person',
  select_location: 'Please select a branch',
  close_branch_tip_1:
    'After the store is closed, the store can continue to log in to the system to view revenue data, accounting data, sales and storage data.',
  close_branch_tip_2: 'Do you want the selected store to be closed?',
  close_branch_tip_3: 'Do you want to set the selected stores to open again?',
  active_or_stop_tip: 'Is the selected store set to the {{type}} state?',
  whether_recover_branch: 'Whether to reopen {{name}}',
  temporary_close_branch_tip:
    'After the temporary closure of the store, most of the business of the store will not be able to proceed, you can continue to log in to the system to view revenue data, accounting data, sales and storage data.',
  whether_close_branch: 'Whether to temporarily close {{name}}',
  store_deactivated_all_businesses_of_the_store_cannot_carried_out:
    'If a branch is discontinued, all business in that branch cannot proceed.',
  store_not_used_for_storing_inventory_shipping_orders_or_selling_products_please_disable_it:
    'If this branch is not used for storing inventory, shipping orders, or selling products, please deactivate it.',
  deactivated_stores_will_not_included_in_your_store_limit_n:
    'Discontinued branches will not be counted towards your branch limit (N branches).',
  effective_stores_will_affect_your_limit_on_the_number_of_stores:
    'Effective branches will affect your branch limit.',
  please_enter_the_store_code: 'Please enter the branch code',
  please_enter_the_store_name: 'Please enter the branch name',
  store_area: 'Store area',
  belong_region: 'Region',
  pre_deposit: 'Prestored value',
  activity_name: 'Activity name',
  please_enter_the_activity_name: 'Please enter the activity name',
  activity_title: 'Activity title',
  please_enter_the_activity_title: 'Please enter the activity title',
  activity_title_placeholder:
    'Please enter the activity title, used for the activity name display in the mini program/POS, if not filled, the activity name will be displayed by default',
  activity_rules: 'Activity rules',
  discount_rules: 'Discount rules',
  discount_rules_tip:
    'Example: every 5 items get 3 items off, by price lowest, means the lowest 3 items get off, by price highest, means the highest 3 items get off',
  discount_rules_price_order_asc: 'By price lowest',
  discount_rules_price_order_desc: 'By price highest',
  cycle_discount_is: 'Cycle discount is',
  second_half_rules_tip:
    'According to your operating rules, you can enter a discount of 5 and 0 to achieve the xx-half price and the xx-free; you can also choose the discount type to be a special price, enter the amount as 9.9 yuan, to achieve the xx-9.9 yuan',
  active_status: 'Active state',
  enter_activity_name: 'Please enter the activity name',
  customer_info: 'Customer information',
  print_coupon_order: 'Print the card voucher order',
  confirm_stop_scan_code:
    'Are you sure you want to deactivate {{title}}?  You cannot scan the QR code to pay after deactivating it.',
  delivery_method: 'Delivery method',
  gift_cards: 'Gift card',
  used_cannot_be_returned: 'Used, cannot be returned',
  used_can_not_be_returned: 'Used, cannot be returned',
  card_specifications: 'Card specification',
  return_reason_1: 'Reason for refund',
  refund_coupon_orders: 'Refund card coupon order',
  when_refunding_coupon_package_orders_refund_amount_calculated_based:
    'When a coupon package order is refunded, the refund amount will be calculated based on the actual amount paid for the unused coupon.',
  after_sale_processing: 'After-sale processing',
  rejected_refund: 'Refund refused',
  cancelled_refund: 'Cancelled refund',
  refund_type: 'Type of refund',
  only_refund: 'Refund only',
  refunds: 'Refund for returned goods',
  order_created_location: 'Order branch',
  return_number: 'Return number',
  search_return_number: 'Search return number',
  search_customer_phone: "Search for customer's mobile phone number",
  refund_no: 'Refund number',
  pick_up_number: 'Pick-up number',
  product_money: 'Amount of goods',
  express_delivery: 'express delivery',
  after_sale_order: 'After-sale orders',
  batch_agree: 'Bulk consent',
  batch_refuse: 'Batch rejection',
  batch_agree_to_refund: 'Batch agree to refund',
  batch_refusal_of_refunds: 'Batch refusal of refunds',
  refund_orders_number: 'Currently selected refund number',
  refund_money_back: "The refund amount will be returned to the buyer's account.",
  sure_batch_agree_refund: 'Confirm the batch agree refund?',
  batch_refuse_refund_tip:
    'It is recommended that you consult with the buyer before deciding whether to refuse a refund. If you refuse to refund, the buyer can modify the refund application agreement to initiate a new refund',
  bill: 'Bill',
  batch_agree_refund_successfully: 'Batch agreed refund success',
  batch_refuse_refund_successfully: 'Batch refund rejected successfully',
  handle_notes: 'Processing remarks',
  please_fill_in_the_rejection_remarks: 'Please fill in the rejection remarks',
  bill_merchant_template: 'Bill merchant template',
  location_print_setting: 'Store print setup',
  export_after_sales_orders: 'Export after-sales orders',
  failed_please_try_again_later: '{{type}}failed, please try again later',
  product_after_sales_information: 'Product after-sales information',
  refund_details: 'Refund details',
  order_status: 'order status',
  refund_instructions: 'Refund instructions',
  refund_voucher: 'Refund voucher',
  refund_statu: 'Refund status',
  refund_processin_time: 'Refund processing time',
  product_does_not_match_actual_product: 'The goods do not agree with the real thing',
  product_damaged: 'Products damaged',
  not_send_out_at_appointed_time: 'The shipment has not been delivered as agreed',
  delivery_time_out: 'Delivery timeout',
  logistics_signed_but_not:
    'The logistics shows that the goods have been signed but have not actually been received',
  not_like_or_want: "Don't like/want",
  express_local_deliver: 'Express delivery',
  whether_to_restock: 'Whether to restock',
  processing_remarks_required: 'Processing remarks are required',
  agree_remark_information_not_filled: 'Agree Note information is not filled in',
  agree_to_refund_successfully: 'Agree to refund successfully',
  order_refused_to_refund: 'Order refusal to refund',
  denied_refund_successfully: 'Successful denial of refund',
  rejected_remark_information_not_filled: 'Refused Remarks Information is not filled in',
  shipping_fee_rejected_refunded_successfully: 'Freight refused refund successful',
  specification_name_cannot_duplicate: 'The specification name cannot be duplicate',
  specification_name_cannot_empty: 'Specification name cannot be empty',
  edit_product_variant: 'Edit Specification',
  create_variant: 'Create multiple specifications',
  delete_variant: 'Delete Specification',
  crad_order_export: 'Credit card order export',
  card_coupon_after_sales_order: 'Card coupon after-sales order',
  after_sales_processing_information: 'After sales processing information',
  buyer_applies_after_sales: 'Buyer application after sale',
  merchant_processes_refund_request: 'Merchants process refund requests',
  brought_the_wrong_thing: 'Brought the wrong thing',
  after_sales_progress: 'After sales progress',
  packaging: 'packaging',
  invalidator: 'invalidator',
  voidTime: 'void time',
  availability_status: 'Availability status',
  processed: 'processed',
  bulk_submission: 'Bulk submission',
  edit_cashier_receipt_rules: 'Edit cashier receipt rules',
  edit_label_printing_rules: 'Edit label printing rules',
  edit_kitchen_printing_rules: 'Edit Kitchen Printing Rules',
  copy_cashier_receipt_rules: 'Copy cashier receipt rules',
  copy_label_printing_rules: 'Copy Label Printing Rules',
  copy_kitchen_printing_rules: 'Copy Kitchen Printing Rules',
  create_cashier_receipt_rules: 'Create cashier receipt rules',
  create_label_printing_rules: 'Create label printing rules',
  create_kitchen_printing_rules: 'Create Kitchen Printing Rules',
  cashier_receipt: 'Cashier receipt',
  label_ticket: 'Label ticket',
  report_receipt: 'Report receipt',
  member_receipt: 'Member receipt',
  SETTLEMENT: 'SETTLEMENT',
  PRE_SETTLEMENT: 'PRE_SETTLEMENT',
  SIGN_IN: 'SIGN_IN',
  WITHDRAW_FOOD_ORDER: 'WITHDRAW_FOOD_ORDER',
  TURN_FOOD_ORDER: 'TURN_FOOD_ORDER',
  TURN_TABLE: 'TURN_TABLE',
  CALL_UP_ORDER: 'CALL_UP_ORDER',
  DINING_IN_LABEL: 'DINING_IN_LABEL',
  TAKE_OUT_LABEL: 'TAKE_OUT_LABEL',
  URGE_FOOD_ORDER: 'URGE_FOOD_ORDER',
  URGE_TABLE_ORDER: 'URGE_TABLE_ORDER',
  DISCOUNT_TICKET_BILL: 'DISCOUNT_TICKET_BILL',
  MEMBER_CONSUME_BILL: 'MEMBER_CONSUME_BILL',
  POINT_CONSUME_BILL: 'POINT_CONSUME_BILL',
  TAKEOUT: 'TAKEOUT',
  CHECK_ORDER: 'CHECK_ORDER',
  no_print: 'No print',
  print_one: 'Print 1 copy',
  print_two: 'Print 2 copy',
  print_three: 'Print 3 copy',
  day_before: 'Previous {{dayInAdvance}} days',
  birthday_current_day: 'On his birthday',
  birthday_current_week: 'Birthday week',
  birthday_current_month: 'Birthday month',
  sms_merchant_name: '【 Store name 】',
  sms_signature: '【 SMS Signature 】',
  sms_gift_content: '【 Gift content 】',
  sms_discount_content: '【 Coupon Content 】',
  return_t_unsubscribe: 'Return to T to unsubscribe',
  sms_tips_second:
    '[Store name] and [Gift content] are variable labels. The actual text message content is subject to preview.',
  sms_tips_first:
    'If {{input}} characters (including signature and suffix) have been entered, the charge is based on {{ssmNumber}} short messages.',
  create_time_desc: 'Creation time (new-old)',
  create_time_asc: 'Creation time (old - new)',
  true: 'Yes',
  false: 'No',
  third_code: 'Third party coding',
  whether_difference: 'Whether there is a difference',
  canceld: 'Canceld',
  not_paid: 'Not paid',
  refunding_01: 'Refunding',
  refuse_denied: 'Refuse denied',
  became_invalid: 'Became invalid',
  operate_record: 'Operation record',
  to_be_paid: 'To be paid',
  not_invoiced: 'Not invoiced',
  invoiced: 'Invoice has been issued',
  have_paid: 'Have paid',
  not_pay: 'Unpaid',
  location_year: '/location/year',
  point_location_year: '/point/location/year',
  supply_chain: 'Supply chain',
  station_pos_point: 'Station version POS point',
  member_crm_professional: 'Member CRM Professional Edition',
  supply_chain_basic: 'Supply Chain Basic Edition',
  supply_chain_professional: 'Supply Chain Professional Edition',
  separate_member: 'Account Sharing - Membership',
  separate_revenue: 'Revenue Sharing - Revenue',
  separate_supply_chain: 'Account Allocation - Supply Chain',
  wechat_software_fee: 'Enterprise WeChat Assistant Software Function Fee',
  level_up: 'level up',
  jump: 'jump',
  lezhi_service: 'Lezhi service',
  service_type: 'Service type',
  renew_success: 'renew success',
  due_date: 'due date',
  rise: 'Rise',
  buy: 'Purchase',
  software_fee_renewal: 'Software Function Renewal',
  wechat_software_fee_renewal: 'WeChat Assistant Software Function Renewal',
  wechat_software_fee_renewal_tip:
    'WeChat Assistant software function has expired, please renew the software function first',
  details: 'details',
  billing_record: 'Billing record',
  billing_status: 'Billing status',
  billing_shop: 'Billing shop',
  invoice_number: 'Invoice number',
  invoice_content: 'Invoice content',
  invoice_details: 'Invoice Details',
  invoice_code: 'Invoice code',
  please_select_invoice: 'Please select invoice',
  please_enter_invoice_title: 'Please enter invoice title',
  invoice_title_required: 'Invoice title required',
  loading_invoice_title: 'Loading the invoice title......',
  invoice_amount: 'Invoice amount',
  please_enter_invoice_amount: 'Please enter invoice amount',
  invoice_amount_required: 'Invoice amount required',
  date_of_drawing: 'Date of drawing',
  screening_invoice_number: 'Screening invoice number',
  loading_billing_record: 'Loading the invoicing record......',
  download_invoice: 'Download invoice',
  not_found_billing_record: 'No billing record found',
  default_store_hours: 'Default store hours',
  invoice: 'Invoicing',
  keyword_search_not_empty: 'Keyword cannot be empty',
  taxpayer_identification_number: 'Taxpayer identification number',
  change_filter_search_term: 'Try to change the filter or search term.',
  keyword_search: 'Keyword search',
  invoice_management: 'Invoice',
  invoice_type: 'Invoice type',
  issuing_body: 'Issuing body',
  issuing_explain: 'Issuing explain',
  create_subject: 'Create subject',
  screening_of_sellers: 'Filter billing subjects',
  loading_invoice: 'Loading invoice......',
  name_of_invoicing_entity: 'Name of invoicing entity',
  billing_channel: 'Billing channel',
  look_suit_to_location: 'View applicable stores',
  confirm_delete_content_header: 'Make sure to delete {{name}}',
  confirm_delete_content_issuing:
    'Confirm that you want to delete the subject {{name}}, which cannot be recovered after deletion',
  create_a_billing_body: 'Create a billing body',
  nono: 'Nono',
  name_of_taxpayer: 'Name of taxpayer',
  please_enter_your_tax_name: 'Please enter your tax name',
  taxpayer_identification_number_required: 'Taxpayer identification number required',
  please_enter_taxpayer_identification_number: 'Please enter taxpayer identification number',
  business_details_address: 'Business details address',
  please_enter_business_details_address: 'Please enter the business address',
  account_bank_name: 'Account bank name',
  account_bank_name_require: 'Account bank name required',
  please_enter_the_bank_name: 'Please enter the bank name',
  a_bank_account: 'Open a bank account',
  a_bank_account_required: 'Open a bank account required',
  please_enter_your_bank_account_number: 'Please enter your bank account number',
  taxpayer_telephone: 'Taxpayer telephone',
  please_enter_taxpayer_phone_number: 'Please enter taxpayer phone number',
  receiving_phone: 'Sms receiving phone',
  please_enter_receiving_phone: 'Please enter SMS receiving phone',
  please_enter_appkey: 'Please enter AppKey',
  get_token: 'Get Token',
  small_scale_taxpayer: 'Small-scale taxpayer',
  general_taxpayer: 'General taxpayer',
  tax_rate: 'Tax rate',
  please_enter_the_tax_rate_: 'Please enter the tax rate, tax range 1-99',
  tax_service_name: 'Tax service name',
  please_enter_tax_service_name: 'Please enter a tax service name',
  please_select_the_applicable_store: 'Please select the applicable store',
  invoice_allowed: 'Invoice allowed',
  payee: 'Payee',
  please_enter_the_payee: 'Please enter the payee',
  reviewer: 'Reviewer',
  please_enter_the_reviewer: 'Please enter the reviewer',
  drawer: 'Drawer',
  please_enter_drawer: 'Please enter the drawer',
  drawer_name_required: 'Drawer name is required',
  billing_limit: 'Billing limit',
  please_enter_billing_limit: 'Please enter 0.01-999999.99',
  tax_rate_setting: 'Tax rate setting',
  flat_rate: 'Flat rate',
  project_name: 'Project name',
  project_info: 'Project information',
  uniform_name: 'Uniform name',
  please_enter_uniform_name: 'Please enter a unified name',
  billing_setup: 'Billing setup',
  billing_time: 'Billing time',
  billing_time_custom: 'Time of billing: custom',
  billing_time_cannot_empty: 'The Billing time cannot be empty',
  billing_time_pla: 'Please enter 1-92',
  invoicing_is_allowed_inside: 'Invoicing is allowed inside',
  billing_tips_1:
    '1. After submitting the invoice information form, the electronic invoice will be sent to your email within 1-3 working days. (1-3 days of each month, invoices cannot be issued during the financial tax filing process)',
  billing_tips_2:
    '2. Currently, only VAT electronic ordinary invoice and VAT electronic special invoice are supported.',
  billing_tips_3:
    '3. You are only allowed to apply for electronic invoice within 30 days after the payment is successful. If you exceed this period, please send email to finance@cnlemon.net for invoice application. You need to provide the payment receipt, invoice name and tax ID at that time.',
  billing_tips_4: '4. Due to tax requirements, New Year invoicing is not allowed.',
  information: 'information',
  ordinary_invoice: 'Ordinary invoice',
  vat_invoice: 'VAT special invoice',
  pay_module: 'Payment mode',
  pay_status: 'Payment status',
  pay_success_time: 'Time of payment',
  order_desc: 'Order description',
  view_invoice: 'View invoice',
  create_invoice: 'Create invoice',
  company_address: 'Company address',
  company_phone: 'Company phone',
  company_phone_require: 'Company phone is required',
  address_can_not_be_null: 'Address is required',
  chain_version_type: 'Chain version',
  open_platform_request_class_push_class_interface:
    'Open platform request class and push class interface',
  number_of_successful_calls_open_platform_gateway:
    'Number of successful calls to the open platform gateway',
  thank_you_for_understanding_support_of_lezhi_retail:
    'Thank you for your understanding and support to Lezhi Retail all the time!',
  mt_interface_cannot_called_enough_times_affect_mt_function:
    'If the number of callable times of Meituan interface is insufficient, the synchronization function of Meituan delivery inventory will be affected. Please recharge in advance to ensure sufficient times.',
  notes_on_meituan_charge_range:
    'Note: Meituan Platform will adjust the API charging range, business type and charging standard from time to time. Lemeng will inform you in advance by means of system announcement',
  querying_remaining_callable_times: 'Querying the remaining number of callable times',
  meituan_interface_callable_times: 'Number of times the takeaway platform interface can be called',
  charge_description: 'Charge description',
  call_details: 'Call details',
  to_recharge: 'Detop-up',
  push_statistics: 'Push statistics',
  meituan_takeaway_api_interface_charge_prompt:
    'Since Meituan has charged the whole industry for connecting to the takeout API call since January 1, 2022, Lezhi Retail will officially start charging from November 1, 2022 in order to provide better long-term, healthy and stable service to merchants. The charging rules are as follows:',
  toll_interface: 'Toll interface',
  interface_charging_standard: `Price (${currency_suffix} / 100 times）`,
  call_source: 'Call source',
  billing_rules: 'Accounting rule',
  inventory_synchronization_api: 'Inventory synchronization API',
  lezhi_retail_team: 'Lemon Retail Team',
  date_day: 'Day',
  oms_mt_api: 'Takeaway API Service',
  please_enter_minimum_number_of_transactions: 'Please enter the minimum number of strokes',
  number_of_orders_less_than: 'Orders are less than',
  pen_hour: 'Strokes',
  order_balance_reminder: 'Order balance reminder',
  package_one: 'Combo 1',
  package_two: 'Combo 2',
  package_three: 'Combo 3',
  querying_remaining_available_orders: 'Checking for remaining available orders',
  remaining_orders_available_in_current_store: 'Current branch remaining available orders',
  basic_rule: 'Basic rule',
  point_deduct_rule: 'Points deduction rule',
  not_found_info: 'No information yet',
  point_got_rule: 'Point acquisition rule',
  point_order_source: 'Order source for participating credits',
  every_consume: 'Per consumption',
  get: 'acquire',
  every_order_get: 'Per order acquisition',
  please_select_order_source: 'Please select the source of the order',
  all_ways: 'All mode',
  add_point_got_rule: 'Add an point acquisition rule',
  enter_correct_mobile_number: 'Please enter the correct phone number',
  original_mobile_phone_number_verification_code:
    'Enter the original phone number verification code',
  please_enter_original_mobile_phone_number_verification_code:
    'Please enter the original phone number verification code',
  reacquire: 'Retrieve{{remainSecond}} second',
  please_enter_correct_email_address: 'Please enter the correct email address',
  getting_configuration_information: 'Obtaining configuration information',
  sms_reminder: 'SMS reminder',
  email_reminder: 'Email reminder',
  no_reminder_has_been_set: 'No reminder has been set',
  sms_balance_reminder_settings: 'Set SMS balance reminder',
  lemon_software: 'Lemon Software',
  please_enter_a_signature_name: 'Please enter a signature name',
  please_upload_basic_voucher: 'Please upload the underlying credentials',
  please_upload_power_of_attorney: 'Please upload the letter of authorization',
  submitted_successfully: 'Submitted successfully',
  not_submitted: 'Not submitted',
  requesting_signature_information: 'Requesting signature information',
  signature_setting_reminder: "The signature information cannot contain the words' Le Meng '",
  basic_voucher: 'Underlying document',
  note_please_upload_business_license: 'Note: Please upload business license',
  power_of_attorney: 'Power of attorney',
  note_fill_in_power_of_attorney_according_to_template_instructions:
    'Note: Please fill in the power of attorney according to the template description (the content is marked in red), and upload the screenshot after filling in it',
  download_power_of_attorney_template: 'Download the Letter of Authorization template',
  decorate_navigation_suspended_window: 'Shop decoration suspended window',
  not_enabled: 'not enabled',
  enable_or_not: 'Enable or not',
  read_suspended_window: 'View floating window',
  remind_once_a_day: 'Remind once a day',
  record_not_found: `Could not find the record`,
  try_to_change_filter_criteria: 'Try to change the filter criteria',
  meituan_takeout_call_service: 'Meituan takeout call service',
  requesting_meituan_takeout_details: `We are requesting details of Meituan delivery`,
  call_interface_here: 'Call interface here',
  after_recharging_meituan_takeout_can_synchronized:
    'After topping up, you can synchronize Meituan takeout and Eleme me orders to the current system',
  pen: 'order number',
  please_enter_minimum_number: 'Please enter the minimum number of entries',
  mtordertips:
    'Under the specific call charge interface: waimai/ng/dish/queryFoodList - query stores food list waimai/dish/updateStock - food inventory sku inventories waimai 】 update/dish/mapping - based mapping',
  end_random_fullReduce: 'End random reduction',
  takeout_api_call_service: 'Takeout API call service',
  order_now: 'Order immediately',
  after_recharging_system_inventory_specified_goods_can_automatically_synchronized_to_takeout:
    'After recharging, you can use the inventory synchronization function of the food delivery platform',
  dear_lezhi_retail_user: 'Dear Lezhi Retail User',
  platform_charging_rules:
    'Due to the increased cost of connecting online platform technology, in order to better serve merchants in a long-term, healthy, and stable manner, combined with the current market development situation, Lezhi Retail will start charging for the order receiving function of Meituan Delivery/Hungry Mai platform from September 1, 2022. The charging rules are as follows：',
  recharge_package: 'Recharge Package',
  number_of_take_out_orders: 'Number of takeout orders',
  standard_package_price: `Standard Package Pricing (${currency_suffix})`,
  unit_price: `Unit price (${currency_suffix})`,
  univalent: 'Unit price',
  orders_with_sufficient_recharge:
    'If the number of orders is insufficient, the system will no longer accept orders from third-party platforms. Please recharge in advance to ensure sufficient times.',
  recharge_now: 'Recharge Now',
  thank_you: 'Thank you for your understanding and support of Lezhi Retail',
  charge_publicity_time: 'August 22, 2022',
  yesterday_rise: 'Yesterday',
  please_configure_data_display_content:
    'Currently, no data display content is configured. Please configure it',
  configure_more_features:
    'Configure more features to allow customers to have a detailed understanding of your business.',
  oms_order_sync: 'Delivery platform order synchronization service',
  platform_charge_notice:
    'Notice on Charging for the Order Receiving Function of Meituan Delivery/Hungry Mai Platform',
  purchase_time: 'Purchase time',
  not_found_record: 'Not found record',
  purchase_service: 'Purchase service',
  short_message_balance_reminder: 'Short message balance reminder',
  get_verification_code: 'Get code',
  platform_call: 'Platform call',
  platform_api_quotas_notice: 'Platform api quotas notice',
  platform_api_quotas_rules:
    'Wechat will charge the number of mobile phone numbers from august 28 2023',
  platform_api_quotas_rules_tip: 'Platform api quotas rules tip',
  wechat_official_instructions: 'Wechat official instructions',
  wechat_official_charges: 'Wechat official charges',
  wechat_phone_verify_service: 'Wechat phone verify service',
  wechat_get_phone_times: 'Wechat get phone times',
  remind_three_day: 'remind three day',
  remind_call_times_balance: 'Remind call times balance',
  audit_fail: 'Audit failed',
  auditing: 'Under review',
  audit_status: 'Audit status',
  location_renewals: 'Location Renewals',
  commodity_maintenance: 'Commodity maintenance',
  search_by_product_name_initials: 'Search by product name/initials',
  add_product_2: 'add product',
  device_type: 'Device type',
  unlimited_no: 'unlimited',
  this_week: 'This week',
  this_month: 'This month',
  this_quarter: 'Current quarter',
  this_year: 'Current year',
  days_number: 'Days number',
  month_number: 'Month number',
  year_number: 'Year number',
  custom: 'Custom',
  please_input_query_days: 'Please input query days',
  please_input_query_months: 'Please input query months',
  please_input_query_years: 'Please input query years',
  amount_value_with_unit: 'Dollar balance',
  sheet: 'Sheet',
  removed_successfully: 'Removed successfully',
  do_you_want_to_remove_this_item: 'Do you want to remove this item',
  order_clerk: 'Order clerk',
  next_person: 'Next person',
  notification_sms: 'Notification SMS',
  verification_code_sms: 'Verification code SMS',
  marketing_sms: 'Marketing SMS',
  voice_message: 'Voice message',
  other: 'Others',
  received: 'Received',
  has_been_sent: 'sent',
  fail_in_send: 'Send failure',
  send_date_is_required: 'Send date This parameter is mandatory',
  no_push_details_found: 'The push details are not found',
  sms_push_details: 'Details of SMS push',
  requesting_push_details: 'Requesting details to be pushed',
  verification_code_notification: 'Captcha notification',
  etting_push_statistics: 'Getting push statistics',
  current_statistical_period: 'Current statistical period',
  total_number_of_sms_senders: 'Total number of short messages sent',
  number_of_successful_sms_arrivals: 'Number of successful SMS arrivals',
  number_of_charging_messages: 'Number of short message charging packets',
  push_details: 'Push details',
  recent_details: 'Recent details',
  receiving_number: 'Receiving number',
  all_history: 'All historical records',
  sms_balance_reminder: 'SMS balance reminder',
  sms_signature_without_bracket: 'SMS signature',
  sms_signature_describe: 'SMS signature must be approved before using SMS service normally',
  shop_abbreviation: 'Branch abbreviation',
  send_sms: 'Send a short message',
  sms_content: 'Text message content',
  sms_discount_tips_second:
    '[Store name] and [Coupon content] are variable labels. The actual text message content is subject to preview.',
  notifiction_setting_tips:
    'To avoid harassing customers, the SMS notification time range is limited from 08:00 to 22:00. If the notification time is outside the displayed time, the notification is delayed to the next 08:00.',
  deliver: 'Send',
  scene_description: 'Scene Description',
  scene_description_text1:
    'Describe the use scenarios of the online businesses in detail, and provide information such as website links, filed domain names, application market download links, official account or full names of applets that can verify these businesses.',
  scene_description_text2:
    'For login scenarios, a test account password is also required. A well-informed application description will improve the efficiency of signature and template review.',
  please_enter_a_scene_description: 'Please enter a scene description',
  bar_hour: 'Bar hour',
  recharge_time: 'Recharge time',
  number_of_recharge_items: 'Number of recharge (items)',
  pay_in_fact_money_items: 'Pay in fact money (items)',
  placing_an_order: 'Placing an order',
  placing_an_order_phone: 'placing an order phone',
  no_query_recharge_record: 'No query for recharge record',
  this_option_apply_mp_1:
    'If this option exceeds the limit, you will not participate in the limited time discount event and will purchase at the pre event price.',
  sms_group_send_tips:
    'Billing description: Currently, there are 4 words, and the expected number of sent items is 1. (When actually sending, signature, variable length, and T back unsubscribe will affect the total number of words.)',
  senting: 'Sentings',
  order_time_allowed: 'Allow booking time slots',
  business_hours_only: 'Hours only',
  all_hours_including_non_business_hours: 'All hours, including non-business hours',
  secondary_card: 'Secondary card',
  immediate_improvement: 'Immediate improvement',
  please_improve_the_SMS_signature_first: 'Please improve the SMS signature first',
  unable_to_recharge_temporarily: 'Unable to recharge temporarily',
  please_enter_the_correct_signature_name: 'Please enter the correct signature name',
  other_types: 'Other types',
  total_number_of_senders: 'Total number of senders',
  number_of_successful_arrivals: 'Number of successful arrivals',
  billing_number: 'Charge number',
  successfully_arrived_at_the_source: 'Successful arrival of source',
  incorrect_date_format: 'Incorrect date format',
  no_more_push_records_found: 'No more push records were found',
  sms_push_statistics: 'SMS push statistics',
  real_time_data_statistics: 'Real-time data statistics',
  remaining_sms: 'Residual SMS',
  push_record: 'Push record',
  cut_off: 'cutoff',
  notify_desc_1:
    '1. To use the applet template message, you must authorize the applet first; And add small program service category in the background of small program:',
  notify_desc_2: 'Life service',
  notify_desc_3: 'Department/supermarket/convenience branch',
  notify_desc_4:
    '2. Each small program can enable a maximum of 50 one-time subscription templates at the same time. Once the number of added templates reaches 50, it may not be able to push messages normally',
  notify_desc_5: 'Enter the applet background',
  notify_desc_6:
    'Delete some inactive templates and reselect corresponding applet subscription messages. The system recreates the enabled templates.',
  notify_desc_7: '3. Follow the following rules when using the public account template message:',
  notify_desc_8: 'Wechat public platform operation standard',
  notify_desc_9: ',Frequently sending marketing template messages risks being blocked.',
  notify_desc_10: '4. The public account template message must be in',
  notify_desc_11: 'Public account background',
  notify_desc_12: 'Select template message industry:',
  notify_desc_13: 'Department stores/Supermarkets/Convenience stores',
  notify_desc_14:
    '5. Each public account can enable a maximum of 25 template messages at the same time. Once the number of added templates reaches 25, it may not be able to push messages normally',
  notify_desc_15:
    'Delete some templates that are not enabled. After the deletion, reselect the corresponding public account template message. The system creates the enabled template again.',
  notify_desc_16:
    '6. To use SMS notification, you need to purchase SMS package service and recharge the short message number.',
  notify_desc_17:
    '7. If both official account template message and applet subscription message are checked, only official account template message will be used; When the official account template message fails, the application applet subscribes to the message.',
  notify_desc_18:
    '8. If you have added "Applet Subscription Message" before authorization, please reselect all "Applet Subscription Message" after authorization.',
  copy_success: 'Replicating Success',
  copy_failed: 'Copy failed',
  download_mp_code: 'Download mini program code',
  your_mp_version_not_match: 'Your WeChat mini program version does not support',
  un_bind_mp: 'You have not bound the mini program yet',
  go_bind_mp: 'Unbind the mini program',
  no_can_download_qr_code: 'No applet code available for download',
  extension: 'Promote',
  extension_location: 'Promote stores',
  searching_bind_mp_is: 'Querying whether to bind the applet',
  creating_mp_qr_code: 'Generating Mini Program QR Code',
  querying_group_data: 'Requesting group data',
  invite_open_group: 'Come and join the group！',
  exchange_category: 'Exchange type',
  aisle_type: 'Channel type',
  aisle_location: 'Channel store',
  delivery_service: 'Delivery service',
  recipient_name: 'Addressee name',
  recipient_phone: 'The recipient phone',
  recipient_addres: 'Addressee address',
  recipient_latitude_longitude: 'Addressee latitude and longitude',
  whether_make_appointment: 'Reservation or not',
  courier_name: 'Name of distributor',
  courier_phone: 'Distributor telephone',
  order_delivery_price: 'Order delivery price',
  available_amount: 'Discount available amount',
  actual_price_paid: 'Actual price paid',
  distributor_information: 'Distributor information',
  batch_quantity_message: 'Batch set inventory completed, please go to the task center for details',
  batch_setting_quantity_success: 'Succeeded in batch setting inventory. Procedure',
  go_to_read_detail: '{{operation}} Complete. Check the details in the task center',
  confrim_batch: 'Are you sure you want to batch {{operation}}?',
  recipient_people: 'Addressee',
  appointment_order: 'Reservation order',
  dywm_sales_auth_tip:
    'To start selling your products in douyin takeaway and managing your douyin takeaway orders and products locally please bind douyin merchants first',
  douyin_merchant_id_binding: 'Douyin merchant id binding',
  douyin_merchant_id: 'Douyin merchant id',
  read_dywm_auth_manager: 'View douyin takeaway authorization management',
  dywm_auth_manager: 'Douyin takeaway authorization',
  stop_sell_dy_products_tip:
    'For the time being it is not supported by the product and the inventory can only be modified to 0 to stop the sale or the vibrato background operation',
  complete: 'Complete',
  store_bind_settings: 'Store Binding Settings',
  store_bind_settings_operation:
    'Manage products, orders and other operations for corresponding stores',
  authoried: 'Authorized',
  binding_new_merchants: 'Bind New Merchant',
  bind_now: 'Bind Now',
  please_enter_the_merchant_id: 'Please enter merchant ID',
  notify_product_example_1: 'Ice cream cake*1,candle*22,Strawberry fruit box*2',
  notify_product_example_2: '黄山休宁松萝茶*1',
  notify_product_example_3: 'Ice cream cake*1,candle*12,Strawberry fruit box*2',
  notify_product_example_4: 'Huangshan Xiuning Organic Tea*1',
  notify_product_example_5: 'Ice cream cake, candles, strawberry boxes',
  pick_address: 'Pick-up address',
  address_example_2: 'Jianye District, Nanjing, Jiangsu Province',
  order_date_time: 'Order Time',
  total_number_of_items: 'Total number of items',
  total_order_quantity: 'Total order quantity',
  pick_up_location: 'Pick-up branch',
  pick_up_time: 'Pick-up time',
  already_picked_remard_value: 'Thank you for your purchase at (store name).',
  location_name_example: 'Emerald Bay store',
  no_group: 'Ungrouped',
  grouped: 'Formed into a group',
  grouping: 'In group',
  full_group: 'Full regiment',
  product_example_1: 'Huangshan Maofeng',
  product_example_1_unit: 'Huangshan Maofeng*1',

  metafield: 'Metafield',
  metafield_name: 'Metafield name',
  metafield_name_required: 'Please enter the metafield name',
  only_supported_in_wechat_miniprogram: 'Only supported in WeChat mini program',
  namespace: 'Namespace',
  namespace_required: 'Please enter the namespace',
  create_metafield: 'Create metafield',
  edit_metafield: 'Edit metafield',
  use_metafield: 'Using metafields',
  code_key: 'Code key',
  code_key_required: 'Please enter the code key',
  description: 'Description',
  description_required: 'Please enter the description',
  text_min: 'Minimum length',
  text_min_required: 'Please enter the minimum length',
  text_max: 'Maximum length',
  text_max_required: 'Please enter the maximum length',
  value_tips: 'Content prompt',
  value_tips_required: 'Please enter the content prompt',
  value_type: 'Value type',
  value_type_required: 'Please select the value type',
  field_type: 'Information format',
  field_type_required: 'Please select the information format',
  field_type_tooltip: 'Information format cannot be modified after saving',
  date_can_be_over_the_current_date: 'Can be over the current date',
  value_options: 'Value options',
  value_options_placeholder: 'Enter Enter or comma to add options',
  value_options_required: 'Please enter the value options',
  choice_max_required: 'Please enter the maximum number of choices',
  number_min: 'Minimum value',
  number_min_required: 'Please enter the minimum value',
  number_max: 'Maximum value',
  number_max_required: 'Please enter the maximum value',
  number_max_precision: 'Maximum precision',
  number_max_precision_required: 'Please enter the maximum precision',
  guide_customer_to_fill_in_personal_information_can_help_you_better_understand_the_store_user_portrait_and_prepare_for_subsequent_marketing:
    'Guide customers to fill in personal information can help you better understand the store user portrait and prepare for subsequent marketing.',

  fields_can_expand_various_functions_in_the_store:
    'Fields that can expand various functions in the branch',
  ok_to_delete_the_meta_field: 'Are you sure to delete the meta field?',
  delete_item_meta_field: 'Delete product meta fields',
  want_to_delete_the_meta_field_grouping: 'Are you sure you want to delete the meta field grouping',
  switch: 'switch',
  date_time: 'Date Time',
  single_choice: 'Single Choice',
  multiple_choice: 'Multiple Choice',
  decimal: 'decimal',
  quality_guarantee_period: 'Shelf life',
  integer: 'Integer',

  product_example_2: 'Huangshan Xiuning Songluo Tea',
  product_example_3: 'Ice cream *1, candle *1, strawberry box *1',
  group_buy_send_time_desc: 'When the grouping succeeds or fails, a notification message is sent',
  group_buy_state_notify: 'Group status notification',
  group_buy_order_pay_success: 'Your purchase order has been paid successfully ~',
  group_buy_result_notify: 'Group results notification',
  group_buy_result_notify_tip: 'Your new group order has been successfully formed',
  group_buy_result_remind: 'Group results reminder',
  group_information: 'Group information',
  group_details: 'Group details',
  group_state: 'Cluster state',
  group_people: 'Group size',
  joint_group_people: 'Group size',
  pay_order_no: 'Bill of payment number',
  pay_success_money: 'Payment amount',
  list_of_product: 'List of goods',
  pay_money_ready: 'Amount to be paid',
  pay_reminder: 'Payment reminder',
  order_cancel_pay_fund: 'The order is about to be cancelled, please pay as soon as possible',
  endline_time: 'Cut-off time',
  click_to_detail: 'Click here for more details',
  payment_money: 'Payment amount',
  refund_status: 'Refund status',
  refund_fail: 'Refund failed',
  fake_product_templete: 'green tea',
  click_to_order_evaluation: 'Click to review the order',
  merchant_order_evaluation_reminder_to:
    'Send immediately after the merchant replies to customer reviews',
  merchant_name_1: 'merchant',
  merchant_example_1: 'The experience store of Le Zhi Jia',
  reply_content: 'Reply content',
  reply_content_01: 'Thank you for your review. Next time you visit',
  change_reason: 'Cause of change',
  point_modify_value: 'Variable point value',
  change_money: 'Variable amount',
  balance_change_sms_content:
    'Your membership card number (Membership card number) balance change at (Store name) :(change amount), current balance :(current balance), change time :(change time), Change type: Consumption/recharge',
  account_balance: 'Account amount',
  member_account_example: 'Lezhi retail member',
  efficity_time: 'Effective time',
  no_efficity_time: 'Failure time',
  current_leve: 'Current level',
  origin_level: 'Original grade',
  current_growth: 'Current growth value',
  remark_desc: 'remarks',
  level_name_example_1: 'Gold member',
  level_name_example_2: 'Silver member',
  expired_date: 'Expiration date',
  ticket_qty: 'Coupon quantity',
  discount_strength: 'Preferential intensity',
  vouther_type_example_1: 'Discount coupon',
  discount_strength_example_1: '50% off',
  ticket_reminder_example_1: 'Your coupon is about to expire',
  coupon_name_example_1: '【voucher】100-20',
  coupon_name_example_2: '50% off coupon',
  sign_in_reminder_example: "I haven't checked in yet",
  sign_in_reward: 'Check-in bonus',
  sign_in_reward_example: '1 bonus point for each check-in',
  sign_days: 'Sign-in days',
  merchant_designation: 'Merchant name',
  card_name: 'Card name',
  gift_card_reminder: 'The gift card is about to expire, please use it within the specified time',
  festival_gift_card: 'Holiday gift card',
  oms_ebls: 'ElemeBWM',
  ebls_auth_manager: 'ElemeBWM empower',
  read_ebls_auth_manager: 'View Hungry Retail Authorization Management',
  ebls_authed: 'Hungry Hundred Retail Authorized',
  authorization_manager: 'Authorization manage',
  auth_new_merchant: 'Authorize new merchant',
  immediate_auth: 'Immediate authorization',
  auth_merchant: 'Authorized merchant',
  elm_sales_auth_tip:
    'To start selling your goods on Eleme and to manage your Eleme orders and merchandise locally, please authorize Eleme first',
  elm_authed: 'Eleme has authorized it',
  ebls_sales_auth_tip:
    'To start selling your products on ElemeBWM and manage your Hungry Retail orders and products locally, please authorize Hungry Retail first',
  tiktok_self_auth: 'Douyin self-verification authorization management',
  tiktok_self_locations: 'List of Douyin self-verification stores',
  tiktok_self_products: 'Tiktok self-write-off store goods',
  tiktok_self_setting: 'Tiktok self-verification Settings',
  cancel_empower_shop: 'Cancel authorized store',
  cancel_auth_success: 'Succeeded in canceling authorization',
  mt_shop_list: 'List of Meituan takeout outlets',
  auth_state: 'Authorization status',
  cancel_auth: 'Cancel authorization',
  store_auth: 'Store authorization',
  mt_location_id: 'Meituan branch ID',
  elm_location_id: 'Eleme me branch ID',
  mt_location_name: 'Name of Meituan branch',
  elm_location_name: 'The name of Eleme me branch',
  filter_location_name_code: 'Filter the branch name or branch code',
  querying_location: 'Requesting branch',
  read_mt_shop_setting: 'Check Meituan takeout store Settings',
  mt_shop_setting: 'Meituan take-out store Settings',
  douyin_takeaway_store_number_id: 'Douyin takeaway store number id',
  douyin_takeaway_store_number_name: 'Douyin takeaway store number name',
  read_dywm_shop_list: 'View douyin takeaway store list',
  dywm_shop_setting: 'Douyin takeaway store list',
  douyin_store_binding: 'Douyin store binding',
  dywm_store_products: 'Douyin takeaway store product',
  dywm_store_products_fetch: 'Douyin takeaway store product capture',
  read_dywm_setting: 'View douyin takeaway settings',
  dywm_setting: 'Douyin takeaway settings',
  edit_dywm_setting: 'Edit douyin takeaway settings',
  ebls_location_id: 'Ele.me Retail Store ID',
  ebls_location_name: 'Ele.me Retail Store Name',
  ebls_store_products: 'Ele.me Retail Store Products',
  ebls_store_products_fetch: 'Ele.me Retail Store Products Fetch',
  bind_ebls_shop: 'Bind Ele.me Retail Store',
  ebls_shop: 'Ele.me Retail Store',
  read_ebls_shop_list: 'View Ele.me Retail Store List',
  ebls_shop_setting: 'Ele.me Retail Store List',
  dy_location_id: 'TikTok Store ID',
  please_enter_correct_platform_store_id: 'Please enter correct platform store ID',
  please_selecet_authorized_merchant: 'Please select authorized merchant',
  oms_complete: 'complete ',
  dywm_authed: 'Douyin takeaway has been authorized',
  complete_time: 'Complete time',
  ticket_money: 'Ticket money',
  after_end_can_not_recovery: 'Confirm to end the activity, unable to resume after completion',
  after_del_can_not_recovery:
    'Confirm to delete the activity, it cannot be restored after deletion',
  edit_point_exchange: 'Edit point redemption',
  copy_point_exchange: 'Copy point redemption',
  create_point_exchange: 'Create point redemption',
  read_point_exchange: 'View point redemption',
  end_point_exchange: 'End point redemption',
  del_point_exchange: 'Delete point redemption',
  end_confirm_is: 'Confirm to end {{title}} ?',
  advertise_mangae: 'Advertising management',
  read_advertise_mangae: 'View AD management',
  end_advertise_mangae: 'End advertising management[{{title}}]',
  delete_advertise_mangae: 'Delete AD management[{{title}}]',
  activity_dates: 'Event date',
  activity_status: 'Active state',
  location_suitable_to: 'Applicable branch',
  collect_stamp_activity: 'Gathering card activity',
  no_collect_stamp_activity: 'No point card activity found',
  select_collect_stamp_activity: 'Select collection point card activity',
  search_activity_name: 'Search event name',
  join_location: 'Participating stores',
  to: 'to',
  not_found_friend_fission: 'No friend fission activity found',
  select_friend_fission_activity: 'Choose friend fission activity',
  loading_friend_fission: 'Loading friend fission',
  fun_game: 'Fun game',
  activity_date: 'Activity time',
  custom_activity_date: 'Activity time: custom',
  no_query_fun_game_activity: 'Fun Quiz not found',
  select_fun_game: 'Choose Fun game',
  gift_lucky_draw_activities: 'Raffle courtesy event',
  lucky_group_empty_tip: 'Lucky group empty',
  choose_gift_rewards_draw: 'Select raffle courtesy activities',
  group_activities: 'Group activities',
  not_join_location_count: 'Stores do not participate',
  join_location_count: 'Participating stores',
  no_query_group_activity: 'No group activity found',
  select_group_activities: 'Choose a group activity',
  group_people_number: 'Number of people in the group',
  group_relay_activities: 'Group relay activity',
  group_relay_empty_tip: 'Group solitarism is not queried',
  choose_group_relay: 'Choose group soloing activities',
  receive_coupon_center: 'Coupon collection center',
  page_setting: 'Page settings',
  not_found_discount_ticket_pack: 'Coupon package not found',
  edit_decorate_recevice_coupon_center: 'Edit store decoration coupon center',
  decorate_recevice_coupon_center: 'Shop decoration coupon center',
  read_decorate_recevice_coupon_center: 'Check out the store renovation coupon center',
  add_decorate_recevice_coupon_center: 'New store decoration voucher center',
  boot_page: 'Launch screen',
  enter_custom_picture: 'Please upload a custom image',
  edit_boot_page: 'edit first Screen Launch Page',
  decorate_navigation_boot_page: 'Shop Decoration First Screen Launch Page',
  read_boot_page: 'show first Screen Launch Page',
  product_content_management: 'Product content management',
  batch_set_message: 'Batch set message',
  welcome: 'Welcome to your visit',
  edited_asc: 'Edited (old new)',
  edited_desc: 'Edited (new old)',
  title_name_asc: 'Title name (A-Z)',
  title_name_desc: 'Title name (Z-A)',
  blank_space: 'Blank',
  default: 'Default',
  decorate_navigation_content_management: 'Decorate navigation content management',
  fiter_product: 'Filter products',
  product_series: 'Collections',
  no_product_category_information: 'There is currently no product category information available',
  material_management: 'Material management',
  read_decorate_navigation_custom_module_list: 'Read decorate navigation custom module list',
  decorate_navigation_custom_module: 'Decorate navigation custom module',
  delete_custom_module: 'Delete custom module',
  batch_delete_custom_module: 'Batch delete custom module',
  edit_custom_module_page_name: 'Edit custom module page name',
  modified_success: 'Modified successfully',
  copy_custom_module: 'Copy custom module',
  not_custom_module: 'Not custom module',
  delete_module: 'Delete module',
  grid: 'Grid',
  list: 'List',
  customiz_page: 'Custom module',
  custom_module_desc:
    'The custom module is mainly used for store page decoration; You can create a  custom module and embed it into any other store page',
  please_enter_module_name: 'Please enter module name',
  custom_module_name: 'Custom module name',
  custom_module_setting: 'Custom module settings',
  return_custom_module_page: 'Return custom module page',
  view_load_animation: 'View loading animation',
  decorate_navigation_load_animation: 'Store decoration loading animation',
  edit_load_animation: 'Edit Load Animation',
  read_classification_template: 'View classification template',
  decorate_navigation_classification_template: 'Store decoration classification template',
  main_window_setting_icon: 'Please improve the main window settings icon',
  sub_window_setting_icon: 'Please improve the sub window settings icon',
  edit_suspended_window: 'Edit floating window',
  create_suspended_window: 'Create a floating window',
  read_gift_card: 'View Gift Card',
  decorate_navigation_gift_card: 'Shop Decoration Gift Card',
  please_add_tile_content: 'Please add tile content',
  please_add_grouping_content: 'Please add grouping content',
  group_title_cannot_empty: 'Group title cannot be empty',
  group_subtitle_cannot_empty: 'Group subheadings cannot be empty',
  group_add_cannot_empty: 'Group addition content cannot be empty',
  edit_gift_card: 'Edit gift card',
  read_commodity_page_template: 'View product page template',
  decorate_navigation_commodity_page_template: 'Store decoration product page template',
  descorate_navigation_package_decoration: 'Store decoration package decoration',
  add_to_card: 'Add to shopping cart',
  please_fill_in_title_name: 'Please fill in the title name',
  please_fill_in_purchase_button: 'Please fill in the add purchase button',
  please_fill_in_buy_button: 'Please fill in the purchase button',
  complete_auxiliary_navigation_information:
    'Please improve the added auxiliary navigation information',
  please_add_at_least_one_recommended_advertisement:
    'Please add at least one recommended advertisement',
  please_recommend_the_advertisement: 'Please recommend the advertisement',
  add_picture: 'Add picture',
  picture_one: ' one',
  picture_two: ' two',
  picture_three: ' three',
  picture_four: ' four',
  picture_five: ' five',
  picture_six: ' six',
  picture_seven: ' seven',
  picture_eight: ' eight',
  picture_nine: ' nine',
  picture_ten: ' ten',
  edit_commodity_page_template: 'Edit Product Page Template',
  create_commodity_page_template: 'Create product page template',
  decoration_page: 'Decoration page',
  related_goods: 'Related products',
  commodity_page_template: 'Product page template',
  add_commodity_page_template: 'New product page template',
  filter_template: 'Filter template',
  product_page_template: 'Product page template',
  read_decorate_navigation_list_template: 'View store decoration list template',
  decorate_navigation_list_template: 'Store decoration list template',
  edit_decorate_navigation_list_template: 'Edit store decoration list template',
  list_template: 'List template',
  decorate_navigation_point_shop: 'Shop decoration points mall',
  please_fill_page_name: 'Please fill in the page name',
  mall_page: 'Mall page',
  integral: 'Point',
  balance: 'Balance',
  read_shop_page: 'View store page',
  decorate_navigation_shop_page: 'Shop decoration shop page',
  configure_three_asset_informatio: 'You need to choose three assets',
  edit_shop_page: 'Edit store page',
  create_shop_page: 'Create store page',
  flower_template: 'Flower template',
  tea_module: 'Tea drink template',
  light_meal_module: 'Light meal template',
  cure_module: 'Baking template',
  tea_with_milk_module: 'Milk tea template',
  fruit_template: 'Fruit template',
  cooked_food_template: 'Cooked food template',
  create_new_page: 'Create a new page',
  blank_space_module: 'Blank template',
  ues_template: 'Using templates',
  read_shop_page_list: 'View store page list',
  shop_name: 'Store name',
  label_operate_content: 'Label the store page [{{operationPage}}]',
  operate_success: 'Operation successful',
  delete_home_page_warning: 'Batch deletion cannot delete the homepage',
  batch_delete_shop_page: 'Batch delete store page',
  delete_shop_page: 'Delete store page',
  set_home_page_operate_content: 'Set the store page [{{name}}] as the homepage',
  setting_fail: 'Setting failed',
  copy_shop_page: 'Copy store page [{{name}}]',
  no_shop_page: 'No store page',
  delete_page: 'Delete page',
  page_face: 'Page face',
  HOME_PAGE_NAME: 'Home',
  home: 'Home',
  setting_home: 'Set as home page',
  page_name: 'Page name',
  belong_location: 'Belonging branch',
  update_time: 'Update time',
  filter_page_name: 'Filter page name',
  merchant_page: 'Store page',
  active: 'Enable',
  distribution_location_operate_content: 'Assign stores to the store page [{operationPage}}]',
  distribution_success: 'Allocation successful',
  online_store_status: 'Online store status',
  number_of_selected_items: '{{selectedResources}} selected',
  not_query_location: 'No stores found',
  please_enter_location_name: 'Please enter the branch name',
  area_change: 'Please select a province',
  provinces_and_cities: 'Provincial and urban areas',
  please_select_custom_image: 'Please select a custom image',
  my_point: 'My point',
  exchange_history: 'Exchange history',
  read_point_mall: 'View the points store',
  edit_point_mall: 'Edit points mall',
  point_mall_setting: 'Points mall settings',
  return_point_mall_page: 'Return to the points store page',
  category_template: 'Classification template',
  read_search_page: 'View search page',
  decorate_navigation_search_page: 'Shop decoration search page',
  please_fill_default_keyword: 'Please fill in the default keywords',
  please_fill_hot_word:
    'There are hot words that have not been filled in. Please enter them before saving',
  edit_search_page: 'Edit Search Page',
  create_search_page: 'Create search page',
  search_page: 'Search page',
  share_store_copy: 'Share with you a treasure shop, come and explore it quickly',
  collate_together: 'Collaborate orders together',
  read_share_page_list: 'View share page list',
  share_page: 'Sharing page',
  please_fill_custom_share_title: 'Please fill in the custom sharing title',
  please_select_custom_share_page: 'Please select a custom shared image',
  edit_share_page: 'Edit share page',
  decorate_navigation_share_page: 'Store decoration dharing page',
  edit_classification_template: 'Edit classification template',
  hot_sell: 'Hot selling',
  read_merchant_navigation_template: 'View store navigation template',
  decorate_navigation_store_navigation: 'Shop decoration shop navigation',
  please_improve_primary_navigation_information:
    'Please improve the first level navigation information',
  please_improve_secondary_navigation_information:
    'Please improve the secondary navigation information',
  please_add_navigation: 'Please add navigation',
  please_improve_navigation_information: 'Please improve the navigation information',
  edit_merchant_navigation_template: 'Edit store navigation template',
  create_merchant_navigation_template: 'Create store navigation template',
  merchant_navigation_template: 'Store navigation template',
  edit_store_style: 'Edit store wide style',
  decorate_navigation_store_style: 'Store decoration, full store style',
  read_store_style: 'View the entire store style',
  wecheat_applet_page_style: 'WeChat mini program page style',
  secondary_classification: 'Secondary classification',
  settle_accounts: 'Balance',
  classification: 'Classification',
  another_order: 'Another order',
  immediate_payment: 'Immediate payment',
  page_color_system: 'Page color scheme',
  system: 'System',
  theme_color: 'Theme colors',
  secondary_color: 'Auxiliary color',
  top_color_system: 'Top color scheme',
  system_color_tootip:
    'Only applicable to WeChat mini programs, the top color of the decoration page and user center can be modified separately',
  table_order: 'Table monogram',
  edit_table_order: 'Edit share page',
  decorate_navigation_table_order: 'Shop decoration table spot meal',
  address_management: 'Address management',
  my_shop: 'My store',
  lisr_template_dispose_desc:
    'Here, you can set a list display of all products and product series in the store, and modify the title, description, and other content shared on the page',
  navigation_bar_settings: 'Navigation bar settings',
  top_background: 'Top background',
  background_color: 'Background color',
  background_picture: 'Background image',
  size_color: 'Font color',
  card_setting: 'Card settings',
  biserial: 'Double column',
  arrange_style: 'Arrange style',
  waterfall_flow: 'Waterfall flow',
  product_style: 'Product style',
  white_ground_and_no_border: 'Borderless white background',
  card_projection: 'Card projection',
  outline_and_white_background: 'Sketch',
  product_border_raduis: 'Product border raduis',
  product_spacing: 'Product spacing',
  display_setting: 'Display settings',
  list_template_desc:
    'The recommendation reason and short title need to be set in [Store Decoration], [Product Decoration], and [Content Management]. If the product contains both the following content, only the highest priority part will be displayed: Member Price Label>>Recommendation Reason',
  product_detail_dsiplay: 'Product details display',
  standard_edition: 'Standard edition',
  concise_version: 'Concise version',
  top_style_background_img:
    'The recommended size is 375*88px. It can upload marketing pictures, brand logos, etc. It is suggested that the background color should be the same as the background color of the classification page',
  gift_card_picture_propose:
    'Add up to 5 images, drag and drop the mouse to adjust the image order, with recommended pixels of 375 * 180',
  photo_ads: 'Photo ads ',
  recommend_product_display_limit:
    'Recommended products will only be displayed after setting up an activity',
  activity_product: 'Activity products',
  activity_product_tooltip:
    'Add activity product categories and display system set discount products, including full discounts, full discounts for X items, and Y discounts for X items;',
  most_display_product_number: 'Display up to 100 products.',
  custom_name: 'Custom Name',
  discount_item_category_picture_size:
    'Pictures of discount product categories. It is recommended to upload 72 * 72 pixels of png pictures',
  activity_display: 'Event display',
  choose_dining_information_before_dining_in_the_cafeteria: 'Select information before eating in',
  click_standard_edition_product:
    'Standard version: When clicking on a product, it will jump to the details page to display the product details',
  click_concise_version_product:
    'Concise version: When clicking on the product, the pop-up box displays the product details',
  other_instructions: 'Other instructions',
  if_both_of_the_following_contents_are_included_only_the_highest_priority_part_will_be_displayed_activity_tag_member_price_tag_recommendation_reason:
    'If a single page product contains the following content at the same time, only the highest priority part will be displayed: activity tag>>member price tag>>recommendation reason',
  double_column_mode_does_not_display_product_sales_by_default:
    'By default, the two-column mode does not display item sales',
  shopping_cart_settlement_display: 'Shopping cart settlement display',
  shopping_cart_settlement: 'Shopping cart settlement',
  single_entry: 'Pinyin entrance',
  coupon_entry: 'Coupon entrance',
  go_shopping: 'Shop',
  please_add_limited_time_discount_activity: 'Please add a limited time discount activity',
  please_add_activity_display_name: 'Please add an activity display name',
  product_style_setting: 'Product style settings',
  transparent_and_no_border: 'Borderless transparency',
  activity_content_setting: 'Activity content setting',
  count_down: 'Countdown',
  crossed_price: 'Crossed price',
  remaining_inventory: 'Remaining inventory',
  list_style: 'List style',
  activity_setting: 'Activity setting',
  activity_drag_sort: 'Add activities (up to 5, can be dragged and sorted)',
  sort_type: 'Sort by',
  add_items_reverse_order_time: 'Add items in reverse chronological order by activity',
  show_name: 'Show name',
  add_to: 'Add',
  product_text_setting: 'Product text settings',
  get_the_countdown: 'Countdown to panic buying',
  to_a_group: 'Go join a group',
  add_activity: 'Add activity',
  only_add_activities_not_started: 'Only supports adding unfinished and ongoing activities',
  two_in_a_row: 'Two in a row',
  choose_a_group_event: 'Please select a group activity',
  please_add_benefit_card: 'Please add a benefit card',
  border_fillet: 'Border fillet',
  shadow: 'Shadow',
  please_add_collection_card_activity: 'Please add a collection card activity',
  card_style: 'Card style',
  four_in_a_row: 'Four in a row',
  five_in_a_row: 'Five in a row',
  six_in_a_row: 'Six in a row',
  background_setting: 'Background settings',
  color: 'Color',
  text_color: 'Text color',
  content_area_style_setting: 'Content area style settings',
  most_one_activity_can_added: 'Allow at most one activity to be added',
  text_format: 'Text format',
  specify_date: 'Specify date',
  new_product: 'New product',
  number_format: 'Number format',
  single_select: 'Single select',
  multiple_choices: 'Multiple choices',
  fill_current_day: 'Fill in the current day',
  fill_in_before: 'Fill in the previous day',
  fill_in_after: 'Fill in the future',
  enter_reason_recommendation: 'Please enter the recommendation reason',
  enter_message_title: 'Please enter the message title',
  please_add_common_message: 'Please add a frequently used comment',
  enter_common_message: 'Please enter a commonly used message',
  best_sellers: 'Best sellers',
  subheading_application_scenario:
    'This title is mainly used for in-store scenarios, including module decoration, some product recommendation streams, and other scenarios',
  words_written_at_departure: 'Leave a message',
  message_application_scenario:
    'This message is mainly used in the store scenario: when purchasing goods, the buyer can enter a message, and a maximum of 10 messages can be set',
  field_format: 'Field format',
  default_value: 'Default value',
  enter_message_prompt: 'Please enter the message prompt',
  add_option: 'Add option',
  checked_cannot_empty: 'After checking, this field cannot be empty',
  common_message_options: 'Common message options',
  add_common_message: 'Add common message',
  add_field: 'Add field',
  picture_material: 'Picture materials',
  picture_application_scenario:
    'This image is mainly used for scenes in the store, including module decoration, some product recommendation streams, and other scenes',
  system_default: 'Default',
  series: 'Series',
  recommendz: 'Recommend',
  default_food_name2: 'Tofu Mousse',
  default_food_name3: 'Osmanthus and Tremella fuciformis',
  default_food_name4: 'green apple',
  new_customer_exclusive_empty_tip: 'No new guest exclusive activity found',
  filter_material_name: 'Filter image names',
  icon_mode: 'Icon mode',
  list_mode: 'List mode',
  created_desc: 'Edited (New - Old)',
  created_asc: 'Edited (Old - New)',
  alpha_asc: 'Material Name （A-Z）',
  alpha_desc: 'Material Name (Z-A)',
  select_all: 'Select all',
  items_selected: 'Selected {{selectSum}} item',
  confirm_delete_classification: 'The classification is about to be deleted. are you sure',
  select_specified_product: 'Select specified product',
  search_specified_product: 'Search specified product',
  no_find_limited_time_discount_activities: 'No limited time discount activities found',
  select_time_limited_discount_activities: 'Choose a limited time discount activity',
  select_product_restrictions: 'Up to 5 items can be selected',
  join_customer: 'Participate in customers',
  my_module: 'My module',
  basic_module: 'Basic module',
  basic_components: 'Basic components',
  member_component: 'Member component',
  module_title: 'Module title',
  picture_advertisement: 'Picture advertise',
  picture_and_text_navigation: 'Image navigation',
  product_search: 'Search product',
  notice: 'Notice',
  split: 'Splitters',
  cube: 'Cube',
  rich_text: 'Rich text',
  marketing_component: 'Marketing components',
  point_exchange_activity: 'Point exchange activity',
  public_account: 'Public account',
  pocket: 'Coupon pack',
  please_upload_title_icon_image: 'Please upload a title icon image',
  please_upload_background_image: 'Please upload a background image',
  please_improve_picture: 'Please improve the picture!',
  incomplete_content_setting_information:
    'The content setting information is incomplete, please complete the relevant information',
  no_select_product: 'No product has been selected. Please select the product before saving',
  please_add_product_series: 'Please add product collection',
  please_fill_menu_name: 'Please fill menu name',
  please_fill_number_displays: 'Please fill in the number of displays',
  announcement_incomplete:
    'The announcement content is incomplete, please complete the announcement content',
  please_select_custom_icon: 'Please select custom icon',
  rubik_cube_layout_picture: 'Please upload the layout image of the Rubik s Cube',
  please_upload_local_video: 'Please upload a local video',
  please_paste_video_address: 'Please paste the video address',
  please_upload_custom_cover: 'Please upload custom cover',
  please_add_rich_text_content: 'Please add rich text content',
  please_select_custom_module: 'Please select a custom module!',
  please_add_coupons: 'Please add a coupon',
  please_upload_received_picture: 'Please upload the received image',
  please_upload_unclaimed_picture: 'Please upload unclaimed images',
  please_upload_custom_icon: 'Please upload custom icon',
  please_upload_custom_background_image: 'Please upload a custom background image',
  please_upload_redemption_history_mode_icon: 'Please upload the redemption history mode icon',
  select_coupon_bag_activity: 'Please select the coupon activity',
  form_field_tips: 'The form information is incomplete, please complete the relevant information',
  collect_success: 'Collect success',
  collect_fail: 'Collect fail',
  collect_limit: 'The maximum number of favorites has been reached, and cannot be collected again!',
  starting_from_the_event: 'From the start of the activity',
  from_end: 'End',
  this_is_the_coupon_label: 'This_is_the_coupon_label',
  discount_ticket_pack_tag: 'Coupon package label',
  every_day_sign_in: 'Every day sign in',
  any_people_group: 'a group of people',
  display_product_name: 'The product name is displayed here',
  apple: 'Apple',
  show_recommendation_reason: 'The reason for recommendation is displayed here',
  add_element: 'Add element',
  hot_zone: 'Hot zone',
  written_words: 'Word',
  rotation_chart: 'Rotation chart',
  module_setting: 'Module settings',
  module_height: 'Module height',
  screenshot: 'screenshot',
  enter_text: 'Input text',
  member_name: 'Member name',
  member_benefit: 'Member benefits',
  re_obtain: 'Reacquire ',
  upgrade_platinum_membership: ' growing value can be upgraded to platinum membership',
  acquire_membership_interests: 'Obtain exclusive membership benefits',
  unlock_more_benefits: 'More membership benefits await you to unlock, register now!',
  setting_logo: 'LOGO settings',
  customer_avatar: 'Customer avatar',
  font_color: 'Font color',
  exchange_history_mode: 'Redemption history mode',
  exchange_history_text: 'Redemption history text',
  please_upload_logo: 'Please upload a custom image for logo settings',
  default_module_content: 'I am the module content',
  default_content_description: 'I am the module description',
  see_more: 'See more',
  module_sub_title: 'I am the module subtitle',
  more: 'More',
  notice_content: 'Notice content',
  fill_notice_content: 'Please fill in the announcement content',
  single_link: 'Single link',
  navigation_one: 'Navigation one',
  navigation_two: 'Navigation two',
  navigation_three: 'Navigation three',
  navigation_four: 'Navigation four',
  navigation_five: 'Navigation five',
  navigation_six: 'Navigation six',
  navigation_seven: 'Navigation seven',
  navigation_eight: 'Navigation eight',
  navigation_nine: 'Navigation nine',
  navigation_ten: 'Navigation ten',
  navigation_eleven: 'Navigation eleven',
  navigation_twelve: 'Navigation twelve',
  exhibition_activities: 'Exhibition activities',
  please_add_point_exchange_coupon: 'Please add a point redemption voucher',
  point_redemption_activity: 'Point exchange activity',
  custom_activity: 'Custom activity',
  insufficient_points: 'Insufficient points',
  exchange_completed: 'Fully redeemed',
  to_exchange: 'Exchange',
  style: 'Style',
  style_four: 'Style four',
  nearby_stores: 'Nearby store',
  view_more_stores: 'View more stores',
  default_shop_name: 'Yuehu Shengyuan (Yuehu store)',
  distance_from_you: '500 meters away from you',
  please_reselect_product_line:
    'There are no available products in the current product series. Please reselect the product series',
  group_one: 'Group 1',
  group_two: 'Group 2',
  product_data_loading: 'Product data loading',
  search_product_you_want: 'Search for the product you want',
  preset_content: 'Preset content',
  text_position: 'Text position',
  box_color: 'Box color',
  border_color: 'Border color',
  box_height: 'Box height',
  box_fillet: 'Box fillet',
  text_setting: 'Text settings',
  registration_guide_copy: 'Registration guide content',
  show_position: 'Show position',
  floating_bottom: 'Floating at bottom',
  notice_for_use: 'Instructions for use',
  setting_wechat_focus_public_account_satisfy_condition:
    'The following conditions must be met when setting the applet following official account',
  merchant_wechat_public_account_setting:
    'Merchant background - WeChat applet - official account setting - official account (service account) has been bound in official account authorization',
  setting_public_account_with_theme_unanimous:
    'The set official account should be consistent with the applet subject',
  use_prompt_copy_of_official_account_component_before_txt:
    'Before using the component, you need to go to',
  use_prompt_copy_of_official_account_component_after_txt:
    'Set the official account to be displayed in "Settings">"Follow official account".',
  mini_program_background: 'Mini program background',
  pay_attention_public_account_the_brand_discounts_in_real_time:
    'Follow the official account, and grasp the brand discount in real time',
  focus_on: 'Focus on',
  the_public_account_associated_with_a_small_program: 'Official account associated with applet',
  lemon_shop: 'Lemon shop',
  complete_hardware_and_product_ecology_help_users:
    'Perfect hardware and product ecosystem to help users',
  rich_text_one: 'Click here to edit the content of rich text',
  rich_text_two: 'You can do the text',
  rich_text_three: ' wait for simple typesetting operations.',
  rich_text_four:
    'You can also insert pictures here and add super links to the picture to facilitate users to click.',
  oblique_body: 'oblique body',
  underline: 'underline',
  delete_line: 'delete line',
  as_well_as: 'as well as',
  font_sizes: ' font size',
  rich_text_thick: ' bold',
  rich_text_color: 'text color',
  rich_text_background: 'background',
  blank_height: 'Blank height',
  line_style: 'Line style',
  solid: 'Solid',
  dashed: 'Dashed',
  dotted: 'Dotted',
  top_and_bottom_margins: 'Top and bottom margins',
  line_width: 'Line width',
  line_color: 'Line color',
  auxiliary_blank: 'Blank',
  guide: 'Guide',
  again_collect: 'Reset',
  again_collect_after: 'Points redeemable gifts',
  convertible_gifts: 'Redeemable gifts',
  boot_page_tips:
    'When opening the applet display the starting page of the first screen by default',
  forbidden: 'Forbidden',
  custom_picture: 'Custom',
  upload_image_tips3:
    'Only supports four formats: gif, jpeg, png, and bmp. Recommended pixels are 375 * 812, with a size of no more than 5M, and a maximum of 1 image can be uploaded',
  skip: 'Skip',
  discount_ticket_type: 'Coupon type',
  show_more_product_series: 'Show more product series',
  batch_set_subscript: 'Batch set subscript',
  product_subscript: 'Product subscript',
  technical_identification: 'Lemon provides technical support',
  please_select_dinner_persons: 'Please select the number of diners',
  start_order: 'Start ordering',
  default_image: 'Default picture',
  independent_entrance_prompt:
    'To ensure the display effect of the page, select up to two independent entrances',
  independent_entrance_display: 'Independent entrance display',
  float_window_icon_size: 'Suggested size: 100px * 100px',
  custom_picture_limit: 'Please upload a GIF or SVG format file',
  load_animation_size: 'Suggested size 150 * 150 pixels, gif, svg, png format',
  default_load_animation: 'Default',
  custom_load_animation: 'Custom',
  advertisement_number_limit:
    'Adding up to 6 advertisements has reached the maximum addition limit',
  advertising_content: 'Advertising content',
  rotation_advertisement: 'Rotational advertising',
  add_up_to_six_advertisements: 'Add up to 6 advertisements,',
  first_picture_determines_module_height: 'the first image determines the module height ',
  advertisement_size:
    'drag and drop the mouse to adjust the advertising order, with a recommended width of 375px',
  module_top_spacing: 'Module top spacing',
  module_bottom_spacing: 'Module bottom spacing',
  module_left_and_right_margins: 'Module left and right margins',
  picture_fillet: 'Picture fillet',
  by_order_type: 'Display according to order type',
  by_order_progress: 'Display according to the order schedule',
  restore_default: 'Restore default',
  menu_icon: 'Menu icon',
  menu_name: 'Menu name',
  edit_menu: 'Edit menu',
  add_menu: 'Add menu',
  user_defined: 'User defined',
  icon_size: 'Icon size',
  default_icon: 'Default icon',
  add_separator: 'Add separator ',
  separator: 'Delimiter',
  menu_arrangement: 'Menu arrangement',
  classic: 'Classic edition',
  sudoku: 'Squared paper for practicing calligraphy',
  icon_show: 'Icon display',
  not_show: 'Do not display',
  menu_function: 'Menu functions',
  top_background_color: 'Top background color',
  top_background_img: 'Top background image',
  top_text_color: 'Top text color',
  page_background_color: 'Page background color',
  send_save: 'check',
  asset_allocation: 'Asset allocation',
  module_background_color: 'Module background color',
  module_text_color: 'Module text color',
  no_advertisement_please_add: 'There are currently no advertisements, please click to add!',
  platinum_member: 'Platinum membership',
  next_level_need_100001_growh_value:
    'Then obtain 10001 growth value to upgrade to Starshine member',
  pending_payment_order: 'Payment pending',
  to_self_pick: 'To be picked up',
  goods_to_be_received: 'Products to be received',
  wechat_nickname: 'WeChat nickname',
  essential_tools: 'Essential tools',
  activate_vip_membership: 'Activate VIP membership',
  customer_service_hotline: 'Hotline',
  contact_customer_service: 'Contact customer service',
  loading_coupon_package: 'Loading coupon package',
  most_optional_50_items: 'You can select a maximum of 50 items',
  no_query_coupon_package: 'No coupon activity found',
  select_couponpackage_activity: 'Select coupon activities',
  loading_coupon_package_activity: 'Loading voucher package activity',
  loading_group_buy: 'Loading group by',
  loading_grounp_activity: 'Loading group activities',
  loading_time_limit_discount: 'Loading limited time discount',
  no_find_point_redemption_activity: 'No point redemption activity found',
  all_activity: 'All activities',
  activity_selected: 'Selected activities',
  point_exchange: 'Point redeem',
  point_exchange_activity_loading: 'Loading points redemption activity',
  exchanged_and_current_inventory: 'Cashed/Current inventory',
  everyone_exchange_limit_short: 'Limit per person',
  clear_selected: 'Clear options',
  search_goods_serious: 'Search product collection',
  searching_goods_serious: 'Searching for product line',
  searching_product: 'Searching for goods',
  gift_card_themes: 'Gift card theme',
  no_find_gift_card_themes: 'No gift card theme found',
  all_themes: 'All themes',
  themes_selected: 'Selected theme',
  select_gift_card_themes: 'Choose gift card theme',
  search_gift_card_themes_name: 'Search for gift card theme names',
  term_of_validity: 'Validity period',
  all_image: 'All images',
  all_videos: 'All videos',
  category_name_cannot_empty: 'Category name can not empty',
  new_classification: 'New classification',
  classification_name: 'Classification name',
  delete_material_center_classification: 'Delete material center classification[{{name}}]',
  material_center: 'Material center',
  rename_material_center_classification: 'Rename material center classification',
  move_up_material_center_classification: 'Move up material center classification',
  move_down_material_center_classification: 'Move down material center classification',
  add_subcategory: 'Add subcategory',
  no_product_series_found: 'Product series not found',
  choose_goods_series: 'Select product line',
  filter_goods_series_name: 'Filter product series names',
  product_series_name: 'Series name',
  upload_videos_error_message: 'Please upload a file in MP4 format',
  video_name_restrictions: 'The video name must be filled in and cannot exceed 20 words',
  please_upload_the_correct_video_format: 'Please upload the correct video format',
  video_size_exceeds_limit: 'Video size exceeds limit',
  upload_image_success: 'Upload image success',
  duration: 'Duration',
  upload_video: 'Upload video',
  local_video: 'Local video',
  video_size_superior_limit: 'Please upload a video smaller than 200MB',
  please_input_title: 'Please enter title copy',
  discount_ticket_tmpl_product_exchange: 'Exchange voucher',
  purchase_a_gift_b: 'Purchase a gift b',
  limited_quantity_of_free_vouchers: 'Limited quantity of free vouchers',
  exemption: 'Exemption',
  part: 'part',
  discount_qty: 'Discount quantity',
  max_discount_qty: 'Maximum discount quantity',
  reduced_to: 'Be reduced to',
  start: 'Start',
  apply: 'Apply',
  exchange_coupon: 'Redemption note',
  full: 'Full',
  pieces: 'a',
  money_unit: currency_suffix,
  available: 'Available',
  no_threshold: 'No threshold',
  receive: 'Receive',
  collar: 'Collar',
  take: 'Take',
  claim_now: 'Immediate claim',
  nanjingwande: 'Nanjing wande building store',
  store_up: 'Storage',
  default_stored_value_discount: 'Reduce 50 from a single stored value of 200',
  product_one: 'Product 1',
  product_two: 'Product 2',
  product_three: 'Product 3',
  product_four: 'Product 4',
  high_cost_performance: 'High cost-effectiveness',
  kit_title: 'Package name',
  tangerine: 'tangerine',
  short_tangerine: 'Orange',
  kiwi_fruit: 'kiwifruit',
  short_kiwi_fruit: 'Kiwi',
  watermelon: 'watermelon',
  short_watermelon: 'west',
  select_appoint_mall_product: 'Select appoint mall product',
  no_find_category: 'No categories found',
  select_specified_category: 'Select specified category',
  search_specified_category: 'Search specified category',
  agreement_name: 'Protocol name',
  modify_time: 'Modification time',
  upload_image_error_tips: 'Only supports gif, jpeg, png, and bmp formats',
  upload_img: 'Please upload a file in png, jpg, jpeg, or gif format',
  max_upload_size: 'Up to {{size}} can be uploaded',
  upload_image_requirement: 'Please upload a jpg or jpeg image',
  upload_succeeded: 'Upload succeeded',
  first_name_cannot_be_empty: 'Name cannot be empty',
  sold_out: 'Sold out',
  application_location: 'App branch',
  navigation: 'Navigation',
  unchecked: 'Unchecked ',
  level_one_navigation: 'First level navigation',
  level_two_navigation: 'Secondary Navigation',
  select_navigation_icon: 'Select the navigation icon',
  all_series: 'Complete series',
  selected_series: 'Selected series',
  custom_icon: 'Custom icon',
  add_navigation: 'Add navigation',
  page_remark: 'Page notes',
  association_template: 'Association template',
  no_query_lbs_add_friends: 'LBS add friend is not found',
  select_lbs_friends: 'Choose LBS freinds',
  mage_and_text_customization: 'Image and Text Customization',
  confirm_delete_saved_module: 'Are you sure you want to delete the save module?',
  cancel_coolection_success: 'Cancel coolection success',
  cancel_coolection_fail: 'Cancel coolection fail',
  modules: 'Modules',
  module_saving_instructions:
    'Click ★ on the right side of the module to save it. The saved module can be dragged into other pages with one click for quick decoration.',
  not_found_get_discount: 'Coupon collection activity not found',
  elect_voucher_collection_activity: 'Choose a coupon collection activity',
  module_name: 'Module name',
  custom_module_list: 'Custom module list',
  filter_module: 'Filter module',
  searching_module: 'Searching module',
  module: 'Module',
  end_days: 'Rnd in {{days}} days',
  start_days: 'Starting in {{days}} days',
  only_has: 'Only has',
  robbed: 'Robbed',
  reservation_now: 'Pre-book',
  end: 'End',
  pieces_robbed_pieces_left: '0 pieces have been snatched | 0 pieces remaining',
  goods_have_been_robbed: 'The goods have been looted~',
  list_style_setting: 'List style settings',
  three_in_a_row: 'Three in a row',
  slide: 'Slide',
  button_color: 'Button color',
  default_shop_style: 'Default',
  custom_color: 'Custom color',
  font_size: 'Font size',
  small: 'Small size',
  middle: 'Middle size',
  super_large: 'Extra large',
  font_thickness: 'Font thickness',
  thin: 'Thin',
  thick: 'Thick',
  variant_price: 'Product price',
  product_source: 'Product source',
  add_product_series: 'Add product collection',
  add_up_to: 'Add up to 16',
  display_mode: 'Display mode',
  select_benefit_card: 'Select benefit card',
  search_benefit_card_name: 'Search benefit card name',
  benefit_card_name: 'Benefit card name',
  right_name: 'Right name',
  select_product: 'Please select product',
  duplicate: 'Duplicate',
  confirm_copy: 'Are you sure to copy?',
  display_method: 'Display method',
  tile: 'Tile',
  group_display_limit: 'Up to 10 groups can be added and can be dragged for sorting',
  group_title: 'Group title',
  group_subtitles: 'Group subheadings',
  gift_name: 'Gift Name',
  select_collapse_icon: 'Select collapse icon',
  bottom_navigation: 'Bottom navigation',
  bottom_navigation_copy:
    'The various pages of the store can be connected through navigation. Through carefully designed navigation, it is convenient for buyers to quickly switch between columns and guide them to the desired page',
  configure_navigation_templates: 'Configure navigation templates',
  template: 'Template',
  basic_setting: 'Basic settings',
  unselected_status: 'Unselected state',
  selected_status: 'Selected status',
  search_setting: 'Search settings',
  default_keyword: 'Default keywords',
  top_search_terms: 'Popular search terms',
  keyword_limit: 'Up to 10 manual matching keywords can be set',
  hot_word: 'Hot words',
  hot_word_icon: 'Hot word icon',
  hot_word_style_highlighting: 'Hot word style highlighting',
  fee_freight: 'Free shipping',
  effective_same_day: 'Effective on the same day',
  coupon_days_after: 'Coupon {{UseByDayAfterGet}} available after days',
  forever_effective: 'Valid permanent',
  effective_day: 'valid days {{day}} days',
  receive_coupon_center_img_size: 'Recommended size: 375*278',
  show_share: 'Share',
  share_title: 'Share title',
  coupon_color: 'Coupon color',
  drag_sort: 'up to 10 sheets, can be dragged and sorted',
  please_add_voucher_collection_activity: 'Please add a voucher collection activity',
  lateral_sliding: 'Lateral sliding',
  choose_color: 'Choose color',
  nape: 'Nape',
  selectd: 'Selected',
  confirm_delete_page: 'Are you sure you want to delete {deleteKeys}} pages',
  operate_can_not_undone: 'This operation cannot be undone.',
  logo_recommended_size: 'Suggested size: 42 * 42px',
  several_modules: 'Nums of modules',
  add_rotation_chart: 'Add rotation chart',
  no_data_please_add: 'No data , please add',
  switching_time: 'Switching time',
  fillet_radius_disc: 'Circular fillet radius',
  allocation_asset_type: 'Up to 2 types of assets can be configured',
  please_configure_three_asset_informatio: 'Please configure three types of asset information',
  growth_value: 'Growth value',
  headline: 'Headline',
  subheading: 'Subheading',
  module_subtitle: 'Module subtitle',
  view_more_settings: 'View more settings',
  view_more_modes: 'View more modes',
  view_more_text: 'View more text',
  title_picture: 'Title picture',
  upper_fillet: 'Upper fillet',
  lower_fillet: 'Lower fillet',
  fill_module_title: 'Fill module title',
  module_content: 'Module content',
  fill_module_content: 'Fill module content',
  content_description: 'Content description',
  fill_content_description: 'Fill in content description',
  heading_style_setting: 'Heading style setting',
  thickness: 'Thickness',
  routine: 'Routine',
  subtitle_style_settings: 'Subtitle style settings',
  view_more_style_settings: 'View more style settings',
  background: 'Background',
  background_image: 'Background',
  title_style_settings: 'Title style settings',
  title_icon: 'Title icon',
  title_icon_recommended_size: 'Suggested size 14 * 14',
  content_style_settings: 'Content style settings',
  content_description_style_settings: 'Content description style settings',
  one_line: 'Line by line',
  carousel: 'Rotate pictures',
  select_template: 'Select template',
  advertising_quantity_limit:
    'Add up to 10 advertisements, drag and drop the mouse to adjust the order of the advertisements, with a recommended width of 750 pixels',
  support_long_press: 'Support long press recognition QR code to add WeChat/Enterprise WeChat',
  content_style: 'Content style',
  rotation_interval: 'Rotation interval',
  picture_spacing: 'Picture spacing',
  picture_size: 'Picture size',
  s: 'Small',
  m: 'Middle',
  l: 'Large',
  margin_left: 'Margin left',
  scroll_type: 'Rolling mode',
  turn_page_scroll: 'Page scrolling',
  horizontal_scroll: 'Lateral roll',
  notice_quantity: 'Supports up to 5 announcements and can be dragged and sorted',
  notice_horizontal_text:
    'Please fill in the announcement content. If the number of words is too long, it will be displayed horizontally on the mobile phone',
  draw_hot_zone: 'Draw hot zone',
  navigation_content: 'Navigation content',
  navigation_style: 'Navigation style',
  fixed: 'Fixed',
  display_quantity_per_line: 'Display quantity per row',
  picture_size_scheme: 'Picture size scheme',
  fixed_size: 'Fixed size',
  custom_size: 'Custom size',
  navigation_style_setting: 'Navigation style settings',
  title_position: 'Title position',
  picture_bottom: 'Picture bottom',
  picture_inner: 'Picture inner',
  title_size: 'Title size',
  title_weight: 'Title weight',
  title_color: 'Title color',
  display_number: 'Number of displays',
  video_source: 'Video source',
  select_video: 'Select video',
  paste_video_address: 'Paste address',
  video_size_limit:
    'The video size does not exceed 50MB. It is recommended to upload a 16:9 size video, which only supports MP4 format',
  only_supports_mp4: 'Only supports video source addresses in. mp4 format',
  enter_video_address: 'Enter video address',
  original_video_cover: 'Original video',
  custom_cover: 'Custom',
  video_advice_desc:
    'Suggest that the image aspect ratio be consistent with the video aspect ratio',
  auto_play: 'Auto play',
  open: 'Open',
  afternoon: 'Afternoon',
  morning: 'Morning',
  last_edit_time: 'Last edit time',
  application_page: 'Application page',
  remind: 'Remind',
  is_restore_default_icon: 'Do you want to restore the default icon?',
  shop_home: 'Store homepage',
  suspension_mode_setting: 'Suspension mode settings',
  levitation_mode: 'Suspension mode',
  support_drag: 'Support drag',
  main_window_setting: 'Main window settings',
  main_window_description:
    'When the main window contains 2 or more sub windows, the mobile page displays the main window. Click to expand the main window, and click again to collapse the main window',
  not_expanded: 'Unexpanded',
  expanded: 'Expanded',
  main_window_picture_size: 'Suggested size: 50 * 50 pixels circular PNG image',
  sub_window_setting: 'Child window settings',
  main_window_info:
    'Clicking on a sub window will lead to the corresponding page, which can be placed in the main window or displayed as a separate entry point',
  restore_default_icon: 'Restore default icon',
  floating_windows: 'Floating window',
  float_window_description:
    'The floating window allows you to place a unified quick key entry on each page. It is recommended to configure the page entry that users frequently visit',
  enable_float_window: 'Enable floating window',
  add_label_store_page: 'Add tags to store page',
  keyword_sorting_store_page: 'Use descriptive keywords to help organize store pages',
  existing_label: 'Existing labels',
  type_enter_or_comma_to_add_options: 'Type Enter or Comma to add an option',
  used_the_x_option: 'used_the_x_option',
  minimalist_style: 'Minimalist style',
  minimalist_style_desc:
    'The style is simple and suitable for scenarios with limited quantity and variety of products. Currently, only 1000 products are supported.',
  rich_style: 'Rich styles',
  rich_style_desc:
    'Suitable for merchants with a wide variety and quantity of products, making it convenient for users to quickly purchase multiple items',
  select_classification_style: 'Select classification style',
  hint: 'Hint',
  required_item: 'Required item',
  read_copyright_logo: 'Read copyright LOGO',
  decorate_navigation_copyright_logo: 'Decorate navigation copyright LOGO',
  please_upload_custom_logo: 'Please upload custom edit copyright LOGO',
  edit_copyright_logo: 'Edit copyright LOGO',
  two_left_two_right: 'Two left two right',
  one_left_two_right: 'One left two right',
  one_top_two_bottom: 'One up, two down',
  one_left_three_right: 'One left three right',
  rubik_cube_size: 'Rubik s Cube size',
  rubik_cube_layout: 'Rubik s Cube Layout',
  add_picture_suggestions:
    'Select the layout area and add images below. It is recommended to add images with consistent proportions',
  pixel: 'Pixel',
  share_picture: 'Share pictures',
  decorate_table_order_title: 'Lezhi tea drink (Nanjing)',
  add_secondary_navigation: 'Add Secondary Navigation',
  navigation1: 'Navigation 1',
  navigation2: 'Navigation 2',
  navigation3: 'Navigation 3',
  navigation4: 'Navigation 4',
  merchant_navigation: 'Store navigation',

  mp_table_order_recommend_background_dimension: 'Recommended size 750 x 540 pixels',
  mp_table_order_recommend_background_format: 'Support JPG, PNG, GIF image files',
  mp_table_order_recommend_background_size: 'The file size does not exceed 1MB',
  title_copy: 'Title copy',
  simple_series: 'Series',
  exposure_all_count_tip:
    'The total number of advertising pictures exposed during the activity time, the same user can view a picture multiple times, to remove the weight.Tourists do not go heavy.',
  exposure_total_time_tip:
    'View the total number of advertising pictures displayed during the activity time, and the same user can view a picture multiple times without reweighting.',
  click_all_count_tip:
    'The total number of users who clicked on the AD during the activity time, deweight.Tourists do not go heavy.',
  click_total_time_tip:
    'The number of times the user clicks on the advertising picture during the activity time is not reweighted.',
  click: 'Click',
  combo: 'package',
  default_share_picture: 'Default',
  share_picture_size: 'Suggested size: 520 * 416',
  home_page_share: 'Home page sharing',
  joint_order_page_share: 'Spell single page share',
  mini_program_homepage: 'Mini program homepage',
  applet_spell: 'Applet spell',
  recent_searches: 'Recent searches',
  special_price_of_summer_high_top_sandals: 'Summer high top sandals on sale',
  summer_style_gaobang: 'Summer style high top',
  top_search: 'Popular searches',
  all_items: 'All products',
  part_product: 'Partial products',
  specify_goods_categories: 'Specify goods and categories',
  number_applied_products: 'Number of related products',
  recently_applied_in: 'Recently applied in',
  total_number_applications: 'Total number of applications',
  add_custom_module: 'Add custom module',
  exposure: 'Exposure',
  all_users: 'All users',
  new_user: 'New user',
  new_user_desc:
    'The new user is the customer with the mobile phone number, but there is no valid order (no purchase of goods, purchase of goods full refund, purchase of goods without payment automatically cancelled);',
  by_member_level: 'By customer level',
  by_member_group: 'By customer label',
  first_purchase_goods_user: 'First-time purchasers',
  first_purchase_goods_user_desc:
    'First-time buyers refer to customers who have been bound to mobile phone numbers and have purchased goods',
  no_regist_user: 'Unregistered user',
  elm_store_products: 'Eleme store products',
  one_key_match: 'One-key matching',
  match_success: 'Successful match',
  fetch_success: 'Capture success',
  elm_store_products_fetch: 'Grab goods in Eleme stores',
  cancel_link_product: 'Cancellation of associated goods',
  cancel_link_success: 'Successfully disassociated',
  cancel_link: 'Disassociate',
  confirm_cancel_link_is: 'Are you sure you want to cancel the association?',
  stop_sell_products: 'Products taken off the shelves',
  stop_sell_products_tip:
    'We do not support the removal of goods temporarily, and can only change the inventory to 0 to stop selling. Or to the United States group background operation.',
  dywm_product: 'Douyin takeaway product',
  sale_status: 'Sales status',
  on_sale: 'On sale',
  removed_from_shelves: 'Removed from shelves',
  unknown: 'Unknown',
  inventory_correlation: 'Inventory correlation',
  no_relation: 'No relation',
  related: 'Related',
  associate_now: 'Associate now',
  unbound: 'Unbound',
  inventory_setting: 'Inventory setting',
  online: 'Online',
  offline: 'Offline',
  location_product: 'Store product',
  grab: 'Grab',
  batch_setting_inventory: 'Batch set inventory',
  max_number_error_message: 'Please enter a number less than 9999',
  greater_than_or_equal: 'Please enter a number greater than or equal to 0',
  sell_out: 'Sold out',
  fill_up: 'Fill up',
  less_than_or_equal_max: 'Please enter a number less than or equal to 9999',
  product_select: 'Product selection',
  n_product_selected: 'N products selected',
  inventory_adjustment_type: 'Inventory adjustment type',
  enter_current_inventory: 'Enter current inventory',
  inventory_adjustment_tip:
    'When the product inventory adjustment type is fill up, the inventory defaults to 9999; when sold out, the product inventory is 0',
  manually_enter_current_inventory: 'Manually enter current inventory',
  input_range: 'Input range is 0-9999 integers',
  operate_async: 'Operation synchronization',
  only_modify_current_store_product: 'Only modify current store products',
  async_to_other_shop: 'Sync to all other stores',
  async_warn:
    'Synchronization operations must be products with the same name, try not to select more than 5 products when synchronizing all stores',
  batch_modify_package_fee_money: 'Batch modify packaging fee',
  batch_modify_inventory: 'Batch modify inventory',
  sale_seletion: 'Sales selection',
  product_online: 'Product online',
  product_offline: 'Product offline',
  product_offline_tips:
    'Products cannot be taken offline temporarily, can only modify inventory to 0 to stop selling',
  batch_setting_online_offline: 'Batch set online/offline',
  please_select_associated_product: 'Please select associated product',
  associated_shop_product: 'Associated store product',
  mt_product: 'Meituan product',
  elm_product: 'Eleme product',
  douyin_product: 'Douyin product',
  association_shop: 'Associated store',
  browse: 'Browse',
  dy_bind_product_warn:
    'Douyin takeaway does not support multi-specification products, please do not bind multi-specification products',
  asnyc_product_tips:
    'This operation will automatically match and bind products in the product library by product name for third-party products that have been read locally. Already bound products will be automatically ignored.',
  asnyc_product_warn_two:
    '1. For multi-specification products, specification names must be the same',
  asnyc_product_warn_three:
    '2. Platform product library should not have products with duplicate names. If there are duplicates, matching will be random among products with the same name',
  asnyc_product_warn_four: 'This operation will take a long time, please be patient...',
  pour: 'Note',
  automatically_match_by_product_name: 'Automatically match by product name',
  bind_ele_shop: 'Bind Eleme store',
  elm_shop: 'Eleme store',
  please_enter_package_fee_money: 'Please enter packaging fee',
  package_fee_money_one_before: '1. When a single product specification packaging fee exceeds',
  package_fee_money_one_after: 'yuan, it will be defined as a high packaging fee',
  package_fee_money_two_before:
    '2. The maximum high packaging fee for a single product specification cannot exceed',
  package_fee_money_three_before: '3. This store has set',
  package_fee_money_three_after: 'product specifications with high packaging fees, up to',
  read_send_discount: 'View precision marketing',
  del_send_discount: 'Eliminate precision marketing',
  end_send_discount: 'End precision marketing',
  terminate_confirm_is: 'Sure you want to terminate {{title}}?',
  terminating_send_discount: 'Is ending precision marketing',
  after_terminate_can_not_recovery:
    'Determines that the activity is terminated and cannot be resumed after termination',
  number_of_people_covered: 'Number of people covered',
  number_of_people_covered_desc:
    'The total number of people eligible to participate in the activity within the statistical period, and the weight loss across the day',
  ticket_send_success_people_count: 'Number of successful coupons issued',
  ticket_send_success_people_count_desc:
    'Statistical cycle, the number of successful coupons, across the day to weight',
  ticket_send_failed_people_count: 'Number of failed coupons issued',
  ticket_send_failed_people_count_desc:
    'Statistical period, the number of coupon failure, across the day to weight',
  ticket_send_success_count: 'Number of successful coupons issued',
  ticket_send_success_count_desc:
    'Total number of coupons issued successfully within a statistical period',
  ticket_send_failed_count: 'Number of coupon failures',
  ticket_send_failed_count_desc: 'Total number of coupon issuance failures in a statistical period',
  payment_conversion_rate: 'Payment conversion rate',
  payment_conversion_rate_desc:
    'The ratio of the number of people placing orders to the number of people successfully issuing coupons within the statistical period',
  create_order_count: 'Number of orders',
  create_order_count_desc:
    'Within the statistical period, the number of customers who have issued coupons to submit orders using issued coupons, across the day weight',
  pay_order_count: 'Payment order number',
  pay_order_count_desc:
    'During the statistical period, the number of successful orders made by issued customers using issued coupons',
  ticket_write_off_count: 'Coupon cancellation quantity',
  ticket_write_off_count_desc:
    'The total number of coupons issued by customers successfully using this activity within the period',
  ticket_write_off_rate: 'Coupon cancellation rate',
  ticket_write_off_rate_desc:
    'Within the statistical period, the total number of coupons successfully written off/the total number of coupons successfully issued',
  ticket_write_off_money: 'Coupon cancellation amount',
  ticket_write_off_money_desc:
    'Within the statistical period, the total amount of coupons issued in the successful order is actually discounted',
  pulling_amount_desc: `Within the statistical period, excluding the total paid-in amount of successful orders after coupon offers, for example: 100 ${currency_suffix} of order, 30 ${currency_suffix} of coupon deduction, and the remaining 70 ${currency_suffix} paid-in amount is the pulling amount`,
  club_card_share_group: 'Membership card sharing groups',
  share_group: 'Sharing groups',
  group_location_num: 'Number of stores',
  loadding_club_card_share_group: 'Loading membership card sharing groups',
  choose_share_group_name: 'Filter shared group names',
  create_share_group: 'Create shared groups',
  edit_share_group: 'Edit shared groups',
  share_group_name: 'Shared group name',
  location_in_group: 'Store within the group',
  ungrouped_location: 'Ungrouped stores',
  cancel_default: 'Cancel default',
  default_or_not: 'Default',
  set_as_default: 'Set as default',
  title_required: '{{title}} required',

  important_value_customers: 'Important value customer',
  important_value_customers_desc:
    'Recently there is a consumption behavior, consumption frequency is high, the amount is large',
  import_call_customer: 'Call back the customer',
  import_call_customer_desc:
    'Recently there is no consumption behavior, consumption frequency is high, consumption amount is large',
  import_deeply_cultivated_customers: 'Important deep cultivation customers',
  import_deeply_cultivated_customers_desc:
    'Recently, there is consumption behavior, consumption amount is high, but the frequency of consumption is not high',
  import_retention_customers: 'Key retention customer',
  import_retention_customers_desc:
    'Long time no purchase behavior, consumption frequency is not high, but the amount of consumption is relatively large',
  potential_customers: 'Potential customer',
  potential_customers_desc:
    'Recently, there is a consumption behavior, the consumption frequency is high, but the consumption amount is relatively small',
  new_customer: 'New customer',
  new_customer_desc:
    'Recently, there is consumption behavior, but the frequency of consumption is not high, and the amount of consumption is small',
  generally_maintain_customers: 'General maintenance customer',
  generally_maintain_customers_desc:
    'Recently, there have been consumption behaviors, consumption frequency is relatively high, but the amount is relatively small',
  lost_customer: 'Lost customers',
  lost_customer_desc:
    'No consumption for a long time, usually small amount of consumption, consumption frequency is relatively low',
  picture_required: 'Image required',
  male: 'Male',
  female: 'Female',
  open_using_mfa: 'Enable two-factor check',
  close_using_mfa: 'Turn off the two-factor check',
  no_selected_coupon: "You haven't selected the coupon yet",
  coupon_available: ' available',
  my_gift_card: 'My gift card',
  buying_gift_card: 'Purchase gift card',
  online_service: 'Online service ',
  login_background_image: 'Login background image',
  zhejiang_lemeng_information_technology_co_ltd: 'Zhejiang Lemon Information Technology Co., Ltd',
  zhejiang_icp_no: '浙ICP备20024575号-9',
  your_shop_created_successfully: 'Your store has been created successfully！',
  creating_store_please_wait: 'We are creating your store, please wait a moment',
  access_background_error_message:
    'You do not have the background operation permission of the store, please contact the administrator',
  there_are_no_stores_in_this_area: 'There are currently no stores in this area',
  enter_shop: 'Enter the branch',
  access_area: 'Enter the region',
  enter_store: 'Enter the store',
  login_account_has_changed_please_reselect_merchant:
    'Login account has changed, please re-select the merchant',
  request_fail: 'Request failed',
  login_title: 'Sign in to Lezhi Retail',
  get_code_erroe_message: 'Please enter the correct phone number or email address',
  verification_code: 'Code',
  please_enter_the_verification_code: 'Please enter the verification code',
  mobile_number_or_email: 'Mobile phone number or email',
  change_username: 'Please enter your phone number or email address',
  change_username_error_message: 'Please enter the correct phone number or email address',
  please_enter_the_account_number: 'Please enter an account',
  login_success: 'Sign in succeefully',
  password_login: 'Password sign in',
  forgot_password: 'Forgot password',
  login: 'Sign in',
  validate_code_error: 'Verification code error',
  verify_mobile_phone_number: 'Verify phone number',
  verification_code_prompt:
    'Please enter to send to{{phone}}The 6-digit verification code is valid for 3 minutes. If not received, please try to obtain the verification code or voice verification code again.',
  send_voice_verification_code: 'Send voice verification code',
  no_account: 'No account yet',
  existing_account: 'Existing account',
  register_now: 'Sign up now',
  login_now: 'Sign in Now',
  new_password: 'New password',
  please_enter_new_password: 'Please enter a new password',
  account_error_prompt: 'Incorrect format of phone number/email number',
  please_confirm_the_password_again: 'Please confirm the password again',
  confirm_password: 'Confirm Password',
  please_enter_new_password_again: 'Please enter the new password again',
  comfirm_password_empty: 'Please enter a confirmation password',
  name_cannot_be_empty: 'Name cannot be empty',
  wrong_mobile_number: 'Incorrect phone number format',
  please_input_password: 'Please input a password',
  register_success: 'login was successful',
  register_title: 'Register for Lezhi Retail',
  please_enter_your_name: 'Please enter your name',
  password: 'Password',
  please_input_password_again: 'Please input password again',
  register: 'Register',
  password_error_message: 'Password can not less than 8 characters',
  password_modified_successfully: 'Password modified successfully',
  sign_in_again: 'Re-login',
  no_password_is_set_current_account: 'The current account has no password set',
  verify_code_login: 'Sign in with verification code',
  scan_code_to_log_in: 'Please use the Lezhi Retail App to scan the code to sign in',
  qr_code_has_expired: 'The QR code has expired, click',
  other_login_methods: 'Other sign in methods',
  chinese: 'Chinese',
  china: 'China',
  interested_languages_and_regions: 'Interested Languages and Regions',
  select_interested_languages_and_regions: 'Read news in selected languages and regions',
  update: 'Update',
  please_complete_security_verification: 'Please complete the security verification',
  repair: 'Repair',
  some_functions_of_the_shop_are_abnormal:
    'Some functions of the current store are abnormal, please fix',
  shop_card_add: 'Create store',
  shop_card_add_content_text_one: 'Mini Program + Official Account Integrated WeChat Mall',
  shop_card_add_content_text_two: 'Empower offline stores and reconstruct consumption connections',
  to_set: 'To set',
  waitting_payment_or_auto_delete_after_2_hours:
    'Unpaid payment after 2 hours will be automatically deleted. Please make the payment promptly.',
  is_payment_succeeded: 'Is the payment successful',
  payment_succeeded: 'Payment successful',
  payment_fail_go_payment_page:
    'The payment has not been successful, and you will be redirected to the payment page',
  payment_failed_pay_again: 'Payment failed, repay',
  creation_time_custom: 'Creation time: custom',
  creation_time_cannot_empty: 'The Creation time cannot be empty',
  valid_until: 'Valid until',
  go_payment_page: 'Jump to payment page',
  going_payment_page: 'Jumping to payment page...',
  will_go_payment_page: 'Going to the payment page soon...',
  this_merchant_stopped: 'This store has been deactivated',
  get_verification_code_success: 'Successfully obtained verification code',
  secondary_validation_tips:
    'For the security of your account, this login requires a second verification using a verification code',
  reset_password: 'Reset password',
  password_rule:
    'The password must contain both letters and numbers, and must be at least 8 characters long',
  confirm_password_key: 'The two password inputs are inconsistent',
  reset_password_success: 'Password reset successful',
  settlement_desk: 'Settlement desk',
  not_found_order: 'No order was found',
  sub_title:
    'Please add the information below, this will be your default business address. You can always change this setting later',
  shop_information: 'Store details',
  edit_shop_information: 'Edit branch information',
  shop_information_updated: 'Branch has been updated',
  contacts_sex: 'Contact gender',
  contacts_name: 'Contact name',
  please_input_contacts_name: 'Please enter a contact name',
  contacts_name_can_not_be_null: 'Contact name is required',
  house_number: 'House number',
  house_number_can_not_be_null: 'House number is required',
  please_enter_house_number: 'Please enter your house number',
  house_number_cannot_empty: 'House number cannot be empty',
  shop_properties: 'Branch attribute',
  select_version: 'Select version',
  basic_edition: 'Basic version',
  upgraded_version: 'Upgraded version',
  marketing_version: 'Marketing version',
  chain_version: 'Chain version',
  select_payment_method: 'Select payment method',
  payment_amount: 'Payment amount',
  submit: 'Submit',
  postal_code: 'Zip code',
  please_enter_postal_code: 'Please enter a zip code',
  please_input_contact_phone: 'Please enter the contact phone number',
  please_enter_contact_number: 'Please enter a phone number',
  please_select_payment_method: 'Please select mode of payment',
  activation_code_payment: 'Activation code payment',
  activation_code_cannot_empty: 'Activation code cannot be empty',
  activation_code: 'Activation code',
  please_enter_activation_code: 'Please enter the activation code',
  online_payment: 'Online Payment',
  shop_created_successfully: 'Store created successfully',
  save_shop: 'Save store',
  please_enter_shop_name: 'Please enter the store name',
  shop_location_not_selected: 'Store location not selected',
  main_categories: 'Main category',
  please_select_main_categories: 'Please select the main category',
  country_region: 'Country / Region',
  province_city_district: 'Province/City/District',
  please_choose_province_city_district: 'Please select province/city/district',
  address_search_error_prompt_one: 'Please select a province, city and city before searching',
  address_search_error_prompt_two: 'Please fill in the detailed address before searching',
  address_search_error_prompt_three:
    'The current address coordinates are not found, please manually mark on the map',
  detailed_address: 'Address',
  please_enter_detailed_address: 'Please enter detailed address',
  search_map: 'Search map',
  shop_type: 'Branch type',
  distribution_centre_help_text:
    'After the distribution center switch is turned on, the distribution business can be carried out to the designated branch, and the distribution branch needs to be set in the distribution network',
  distribution_centre: 'Distribution center',
  physical_card_type: 'Physical card type',
  choose_card_type_tips: 'After the location created, this parameter cannot be modified',
  postal_code_requirements: 'Zip code must be six digits',
  postal_code_must_6_digit: 'Zip code must be six digits',
  store_has_been_created_some_functions_are_abnormal_please_fix_it:
    'The store has been created, some functions are abnormal, please fix it!',
  switch_shop: 'Switch store',
  sign_out: 'Sign out',
  manage_lezhi_retail_account: 'Manage account',
  profile_picture: 'Profile picture',
  client_downloads: 'Download client',
  operating_revenue_tips:
    'The amount of system product orders after deducting business discounts, excluding card and coupon orders. Operating income=营业流水-营业优惠',
  non_operating_income_tips:
    'Other revenue except for commodity orders, including the number of effective orders such as Stored-value card, coupon package, equity card and gift card: excluding the number of orders that have been fully refunded, the number of effective orders=the number of orders - the number of refunded orders',
  number_of_valid_orders_tips:
    'Excluding the number of orders that have been fully refunded, the number of valid orders=number of orders - number of refunded orders',
  refund_order_number_tips: 'Number of fully refunded orders',
  increased_customer_amount: 'Number of new customers',
  passenger_flow_tips: 'Number of customers who have placed product orders (member deduplication)',
  customer_unit_price_01_tips:
    'Operating revenue/customer flow, the same customer needs to be deduplicated',
  weapp_access_qty: 'Number of microstore visits',
  business_flow_tips: 'Amount before discount for product orders',
  configure: 'Configure',
  common_function: 'Common functions',
  rights_protection_on_order: 'Defending rights',
  wechat_mp_pending_level_up: 'Version to be upgraded',
  sms_insufficient: 'Pending fees',
  point: 'Point',
  to_do_items: 'To-do list',
  please_configure_to_do_items:
    'There are currently no to-do items configured, please configure them',
  product_sales_ranking: 'Top 10 Sales',
  no_data_today: 'No data available today',
  data_profile_set: 'Data Overview Settings',
  data_profile_set_successfully: 'Successfully set data profile',
  adjust_as_follows: 'Adjust as follows',
  to_do_items_set: 'To Do Settings',
  shop_advent: 'Store renewal fee, interim',
  pos_point_advent: 'POS point renewal fee, temporary',
  to_do_items_set_successfully: 'Successfully set to-do list',
  common_function_settings: 'Common function settings',
  current_function: 'Current function',
  decorate_navigation: 'Shop decoration',
  search_retail_functions_such_as: 'Search for Lezhi retail features such as',
  history_search: 'History search',
  clear_history: 'Clear history',
  show_all: 'Show all',
  item_result: 'Item result',
  no_result_yet: 'No result yet',
  search_in_the_help_center: 'Search in the help center',
  clear_success: 'Successfully cleared',
  android_shop_name: 'Lezhi Retail Cashier',
  edition: 'Edition',
  app_shop_name: 'Lezhi Retail Mobile Management End',
  take_goods_screen: 'Lemon Retail TV Screen',
  client_download: 'Client Download',
  click_download: 'Click to download',
  jump_to_home: 'Jump to home',
  help_center: 'Help center',
  system_update: 'System update',
  function_tab: 'Functions',
  task_center_desc: 'Data export is reserved for 30 days only. Please download it in time',
  export_processing: 'Exporting',
  export_complete: 'Export completed',
  export_fail: 'Export failed',
  import_processing: 'Importing',
  import_succeed: 'Import completed',
  update_succeed: 'Update completed',
  printing: 'Printing',
  print_succeed: 'Print completed',
  print_fail: 'Print failed',
  distribute_fail: 'Distribution failed',
  cancel_distribute_fail: 'Cancel distribution failed',
  import_detail: 'Import details',
  successfully_imported: 'Successfully imported',
  import_failure: 'Import failed',
  import_failure_reason: 'Import failure reason',
  export_failure_reason: 'Export failure reason',
  update_failure_reason: 'Update failure reason',
  distribute_failure_reason: 'Distribution failure reason',
  cancel_distribute_failure_reason: 'Cancel distribution failure reason',
  failure_reason: 'Failure reason',
  application_time: 'Application time',
  module_task_type_name: 'File type',
  update_success: 'Update successful',
  updata_fail: 'Update failed',
  cancel_distribution_success: 'Cancel distribution successful',
  send_processing: 'Sending',
  send_complete: 'Send completed',
  settle_processing: 'Settlement processing',
  settle_complete: 'Settlement completed',
  settle_fail: 'Settlement failed',
  generate_complete: 'Generate completed',
  generate_fail: 'Generate failed',
  batch_audit_processing: 'Batch audit in progress',
  batch_audit_complete: 'Batch audit completed',
  batch_audit_fail: 'Batch audit failed',
  sync_success: 'Synchronization successful',
  sync_fail: 'Synchronization failed',
  read_fail_reason: 'View failure reason',
  check_detail: 'View details',
  check_batch_number: 'View batch number',
  check_handle_result: 'Check handle result',
  task_percent: 'Task progress',
  task_status: 'Task status',
  order_module: 'Order management',
  customer_module: 'Customer management',
  marketing_module: 'Marketing management',
  ordering_module: 'Distribution management',
  inventory_module: 'Inventory management',
  procurement_module: 'Procurement management',
  processing_module: 'Production management',
  financial_module: 'Financial management',
  successfully_obtained_the_verification_code: 'Successfully obtained the verification code',
  select_an_initialization_module: 'Please select the initialization module',
  store_initialization: 'Store initialization',
  enter_store_owner_mobile_phone_verification_code:
    'Please enter the store owner mobile phone verification code',
  obtain_store_owner_verification_code: 'Get store owner verification code',
  initializing_store_please_wait_a_moment: 'We are initializing your store, please wait a moment',
  your_store_has_initialized_successfully: 'Your store has been initialized successfully',
  initialization: 'Initialization',
  failed_module: 'Failed module',
  store_initialization_failed_please_try_again_later:
    'Your store initialization failed, please try again later',
  system_desc:
    'System initialization will clear all data of the corresponding menu module and cannot be restored, please be careful!',
  this_page_asks_if_you_want_to_leave: `This page asks if you want to leave — closing the browser may cause system initialization to fail`,
  service_market: 'Service market',
  new: 'New',
  download_fail: 'Export content is empty',
  failed: 'Failed',
  generate_settlement_documents_reason: 'Generate settlement documents fail reason',
  batch_audit_fail_reason: 'Reason for batch audit failure',
  page_management: 'Page manager',
  product_decoration: 'Product decoration',
  package_decoration: 'Package decoration',
  content_manage: 'Content',
  basic_settings: 'Basic settings',
  store_navigation_page: 'Store navigation',
  member_stored_value: 'Member stored value',
  store_style: 'Whole store style',
  general_settings: 'General settings',
  copyright_logo: 'Copyright logo',
  applet_page: 'applet page',
  eq: 'Equals',
  eq_this_value: 'Exactly this number',
  eq_this_money: 'Exactly this amount',
  not_eq: 'Not equal to',
  gt: 'Greater than',
  gt_this_value: 'Greater than this number',
  gt_this_money: 'Greater than this amount',
  lt: 'Less than',
  lt_this_value: 'Less than this number',
  lt_this_money: 'Less than this amount',
  distribution_or_cancel_location: 'Assign branch/Unassign branch',
  pick_up_delivery_time: 'Pick up/delivery time',
  cancel_distribute_modal_first_title:
    'Cancelling the allocation of the following products will cause the status of the corresponding package products in the branch to also change to cancelled allocation.',
  cancel_distribute_modal_second_title:
    'Continue: The selected product and conflicting corresponding package products will be unassigned',
  cancel_distribute_modal_third_title:
    'Ignore conflicts and continue: only non conflicting products will be unassigned',
  halt_sale: 'halt the sales',
  location_price_can_not_gt_price: 'The branch price is not allowed to exceed the price range',
  location_price_can_not_lt_price:
    'The branch price is not allowed to be lower than the price range',
  deposit_receipt: 'Deposit receipt',
  booking_inquiry: 'Table order',
  down_payment_and_earnest_money: 'Deposit and earnest money',
  charge_management: 'Charge management',
  order_evaluation: 'Order evaluation',
  comment_analysis: 'Evaluation analysis',
  standard_commodity: 'Standard product',
  package_goods: 'Package product',
  product_sort: 'Product sorting',
  corner_mark: 'Corner mark',
  box: 'Box',
  store_standard_goods: 'Store standard product',
  store_classification: 'Store product category',
  location_package_goods: 'Store package product',
  store_property: 'Store product property',
  product_synchronization: 'Product synchronization',
  product_inventory: 'Product inventory',
  inventory_synchronization: 'Inventory synchronization',
  plan_inventory: 'Plan inventory',
  customer_list: 'Customer list',
  club_card_list: 'Member card list',
  card_kind: 'Card type',
  user_portrait: 'User portrait',
  rfm_analysis: 'RFM analysis',
  data_definition: 'Data definition',
  point_system: 'Point system',
  deposit_system: 'Deposit system',
  marketing_activities_center: 'Marketing activities center',
  crm_management: 'Marketing activities management',
  applet_manage: 'Applet management',
  wechat_popularize: 'Applet promotion',
  wechat_public_setting: 'WeChat public setting',
  user_agreement: 'User agreement',
  product_review: 'Product review',
  remark_manage: 'Remark management',
  auxiliary_screen_setting: 'Auxiliary screen setting',
  exp_manage: 'Expiry management',
  takeaway_channels: 'Takeaway channels',
  we_com: 'WeCom',
  branch_manage: 'Branch management',
  kds_pick_up_screen: 'TV screen setting',
  printing_business: 'Printing business',
  comment_setting: 'Evaluation setting',
  payment_method_settings: 'Payment method',
  courier_template: 'Courier template',
  aggregated_delivery: 'Aggregated delivery',
  print_sort: 'Print order',
  system_log: 'System log',
  print_settings: 'Print settings',
  exp_goods: 'Expiry goods',
  merchant_payment: 'Merchant payment',
  platform_applet_payment: 'Platform applet payment',
  franchise_distribution: 'Franchise distribution',
  data_dashboard: 'Data overview',
  pay_trade: 'Trade summary',
  pay_record: 'Payment record',
  my_application: 'My application',
  my_merchant: 'My merchant',
  channel_config: 'Channel configuration',
  location_sub_merchant_config: 'Location sub merchant config',
  money_settings: 'Money settings',
  financial_entity_change_record: 'Financial entity change record',
  flow_details: 'Flow details',
  capital_flow: 'Capital flow',
  recrod_account_flow: 'Record account flow',
  payment_record: 'Payment record',
  withdrawal_record: 'Withdrawal record',
  distribution_audit: 'Distribution audit',
  flow_summary: 'Flow summary',
  payment_record_summary: 'Payment record summary',
  distribute_bill_details: 'Distribute bill details',
  deposit_consumption_scheme: 'Deposit consumption scheme',
  deposit_consumption_settlement: 'Deposit consumption settlement',
  gift_card_consumption_scheme: 'Gift card consumption scheme',
  gift_card_consumption_settlement: 'Gift card consumption settlement',
  coupon_verification_scheme: 'Coupon verification scheme',
  coupon_verification_settlement: 'Coupon verification settlement',
  headquaters_scheme: 'Headquarters scheme',
  headquater_expense: 'Headquarters expense',
  headquaters_settlement: 'Headquarters settlement',
  branch_scheme: 'Branch scheme',
  branch_expense: 'Branch expense',
  branch_settlement: 'Branch settlement',
  custom_scheme: 'Custom scheme',
  custom_settlement: 'Custom settlement',
  goods_location_prop: 'Goods location prop',
  ordering_control: 'Ordering control',
  system_settings: 'System settings',
  receive_order: 'Receive order',
  production_plan: 'Production plan',
  production_process: 'Production process',
  production_picking: 'Production picking',
  inventory_check: 'Inventory check',
  inventory_adjustment: 'Inventory adjustment',
  stock_adjust_reason: 'Stock adjustment reason',
  stock_cost_adjustment: 'Stock cost adjustment',
  transit_Goods: 'Transit Goods',
  purchase_summary_details: 'Purchase summary details',
  purchase_order_monitoring: 'Purchase order monitoring',
  material_analysis_report: 'Material analysis report',
  process_summary_report: 'Process summary report',
  entry_exit_summary: 'Entry exit summary',
  entry_stock_summary: 'Entry stock summary',
  exit_stock_summary: 'Exit stock summary',
  statistics_of_change: 'Statistics of change',
  item_document: 'Item document',
  store_item_rule: 'Store item rule',
  supply_chain_parameters: 'Supply chain parameters',
  app_product_setting: 'APP product setting',
  business_report: 'Business report',
  sale_report: 'Sale report',
  financial_report: 'Financial report',
  member_report: 'Member report',
  operating_statement: 'Operating statement',
  business_verview: 'Business verview',
  business_statistic: 'Business statistic',
  business_beyond_statistic: 'Business beyond statistic',
  business_details: 'Business details',
  product_overview: 'Product overview',
  product_sales_details: 'Product sales details',
  product_location_sales_summary: 'Product location sales summary',
  product_marketing_report: 'Product marketing report',
  card_sale_detail: 'Card sale detail',
  customer_price_report: 'Customer price report',
  vip_data_report: 'VIP data report',
  customer_performance: 'Customer performance',
  customer_deduction_report: 'Customer deduction report',
  deposite_payment_method_detail: 'Stored value payment method details',
  small_program_analysis: 'Small program analysis',
  expense_order: 'Expense order',
  value_added_services: 'Value added services',
  basic_information: 'Basic information',
  approximately: 'Make an appointment',
  pos_point: 'POS point bit',
  must_order_product: 'Must order product',
  ic_card_import: 'IC card import',
  share_mutual_exclustion: 'Shared mutual exclusion',
  production_staff_summary_report: 'Production staff production summary report',
  cover_success: 'Cover success',
  get_recevice_center_share_title: 'Lots of coupons for you to pick up',
  queued_commodity_unit: 'Line up to call product units',
  queued_commodity_unit_example: 'For example: Cup',
  landscape_screen: 'Landscape',
  portrait_screen: 'Portrait',
  unit_of_queuing_calling_goods_cannot_empty:
    'The unit for queuing and calling products cannot be empty',
  please_take_your_meal: 'Please pick up your meal',
  please_go_to_the_food_pickup: 'Please go to the pick-up area to pick up your meal',
  screen_oritation: 'Screen oritation',
  clockwise90: 'Clockwise 90°',
  counterclockwise90: 'Counterclockwise 90°',
  no_spin: 'No spin',
  mode_selection: 'Mode selection',
  production_mode: 'Production mode',
  call_mode: 'Call mode',
  add_color: 'Add color',
  number_of_voice_calls: 'Number of voice calls',
  title_priority: 'Title priority',
  priority_of_meal_number: 'Priority for picking up meal number',
  station_number_priority: 'Station number priority',
  display_order: 'Display order',
  from_new_to_old: 'From new to old',
  from_old_to_new: 'From old to new',
  making: 'Making',
  authorization_des:
    'To ensure the normal use of all functions, please authorize Lezhi Retail with the default checked permissions during authorization. If you do not already have a mini program, please click on the',
  wechat_public_platform: 'WeChat public platform',
  apply_for_new_widget:
    'Apply for a new mini program, and then rebind it on this page once the application is successful.',
  authorization_notice_des:
    'If you have added applet Subscription Message before authorization, please enter after authorization is complete',
  href_notice: '【Notice】',
  authorization_notice_after_des: 'Page reselect all applets subscription messages.',
  immediately_bind_to_wechat_applet_authorization:
    'Immediately bind to WeChat mini program authorization',
  wechat_applet_authorization_setting: 'Authorization settings for WeChat mini programs',
  please_complete_authorization_new_window:
    'Please complete WeChat mini program authorization in the new window',
  authorization_failed_re_authorize: 'Authorization failed, re authorization',
  edit_wechat_applet_synchronization_update: 'Edit WeChat mini program to synchronize updates',
  setting_update_success: 'Settings updated successfully',
  are_you_sure_you_want_to_unlicense_the_applet:
    'Are you sure you want to unlicense the mini program?',
  operation_failed: 'Operation failure',
  read_wechat_applet_authorization_settings: 'View authorization settings for WeChat mini programs',
  wechat_setting: 'Authorization Settings',
  bind_applet: 'Bind applet',
  deauthorization: 'Revoke Authorization',
  instructions_for_unauthorization_popup:
    'Releasing authorization will only release the authorization relationship between the authorized mini program and the Lezhi retail system, making it easier for other mini programs to authorize the Lezhi retail system. To truly unbind the mini program, you need to go to the mini program backend to unbind it.',
  synchronize_updates: 'Synchronize updates',
  applet_code: 'Mini program code',
  introduce: 'Introduce',
  service_category: 'Service categories',
  notice_attention_title:
    'To actively cooperate with the operation standards of WeChat mini programs, please apply for the required service categories based on your business project, otherwise the mini program review may fail.',
  notice_attention_one:
    'Life Services>Life Services>Department Stores/Supermarkets/Convenience Stores (mandatory)',
  notice_attention_one_secondary: 'Subscription message notification requires',
  notice_attention_two:
    'If your mini program involves online food trading and delivery, please add the following options:',
  notice_attention_two_secondary: 'Merchant self operated>Food category',
  notice_attention_three:
    'If your mini program involves online trading and delivery of primary edible agricultural products, please add the following options:',
  notice_attention_three_secondary:
    'Merchant self operated>Category of primary edible agricultural products',
  notice_attention_four:
    'If your mini program involves online trading and delivery of alcohol, please add the following options:',
  notice_attention_four_secondary: 'Merchant self operated>Liquor/salt category',
  go: 'go',
  application_service_category: '-Settings - Basic Settings, Application Service Category',
  open_service_category_for_small_programs: ' Open Service Categories for Small Programs',
  applet_instruction: 'Instructions for using mini programs',
  applet_authorization: 'Applet authorization',
  waitting_submit: 'To be submitted',
  in_preliminary_review: 'In preliminary review',
  initial_review_failed: 'Initial review failed',
  wechat_is_under_review: 'WeChat review in progress',
  alipay_is_under_review: 'AliPay review in progress',
  wechat_audit_failed: 'WeChat review failed',
  alipay_audit_failed: 'Alipay review failed',
  wechat_audit_success: 'WeChat review successful',
  alipay_audit_success: 'Alipay review successful',
  submit_audit: 'Submit for review',
  resubmit_audit: 'Resubmit for review',
  upgraded: 'Upgraded',
  to_be_applied_for_opening: 'Pending application for activation',
  no_permission: 'No permissions',
  in_application: 'Applying',
  application_fail: 'Application failed',
  permission_opened: 'Opened',
  view_wechat_applet_upgrade_record: 'View WeChat mini program upgrade records',
  successfully: 'success',
  upgrade_succeeded: 'Upgrade successful',
  upgrade_to_latest_version: 'Upgrade to the latest version',
  submitted_version: 'Reviewed version',
  precautions_for_submission_for_review:
    'When submitting for review, store information needs to be set, including creating stores, creating products, adding store products, creating mini program homepage, setting mini program avatars, setting service categories, authorizing development and management permissions, etc',
  view_upgrade_records: 'View upgrade records',
  turn_off_automatic_upgrade: 'Turn off automatic upgrade',
  turn_on_automatic_upgrade: 'Enable automatic upgrade',
  cannot_add_duplicate_wechat_signals: 'Cannot add duplicate WeChat signals',
  automatic_upgrade_is_turned_off: 'Automatic upgrade turned off',
  automatic_upgrade_is_turned_on: 'Automatic upgrade enabled',
  publishing_mode: 'Publishing mode',
  publishing_mode_desc:
    'The switch is turned on, and the mini program will be automatically released after approval; The switch is turned off, and the mini program maintains its current version and will no longer automatically release the latest version',
  automatic_publishing: 'Automatic publishing',
  please_input_wechat: 'Please input WeChat signal',
  please_input_alipay: 'Please input AliPay signal',
  preview_wechat: 'Previewer WeChat',
  preview_alipay: 'Previewer AliPay',
  remaining_number_people_add: 'Remaining number of people to add:',
  be_careful_one:
    'You can only input one WeChat signal at a time. After clicking Enter to confirm, you can input the next WeChat signal again',
  be_careful_two: 'Can delete previewer WeChat account',
  be_careful_three:
    'If the operator is also the administrator of the mini program, there is no need to bind, and the administrator has experience permissions by default.',
  audit_fail_cause: 'Reason for audit failure',
  authorized_service: 'Authorized Services',
  empower: 'authorization',
  reaudit_tips_one:
    'Please ensure that you have modified the relevant configuration based on the reason for the audit failure, otherwise it will result in the audit failure;',
  reaudit_tips_two: 'After submission for review, it cannot be withdrawn;',
  reaudit_tips_three: 'If you have any questions, you can contact the system staff.',
  record_tips:
    'Your applet is not filed to ensure that your applet is used smoothly in the future it is recommended that you confirm the filing status。 View WeChat document',
  applet_version: 'Mini program version',
  current_version: 'current version',
  system_latest_version: 'Latest version of the system',
  preview: 'Preview',
  audit_fail_message: 'Audit failure prompt',
  display_upgrade_records: 'Display nearly 30 upgrade records',
  version_number: 'Version number',
  upgrade_time: 'Upgrade time',
  confirm_start_activity: 'Are you sure you want to start [{{name}}] immediately?',
  confirm_end_activity: 'Are you sure you want to end [{{name}}] immediately?',
  confirm_delete_activity: 'Are you sure you want to delete [{{name}}]?',
  pay_by_meal_people_tip: 'Each customer is charged {{fee}} yuan',
  pay_by_table_tip: 'Each table is charged {{fee}} yuan',
  pay_by_after_discount_tip: 'Charge {{rate}}% according to the discount price',
  pay_by_total_meal_price_tip: 'Charge {{rate}}% according to the total price of the dishes',
  pay_by_open_table_time_tip:
    'Start {{time1}} charge {{fee1}}, and charge {{fee2}} for every {{time2}}',
  pay_by_consume_align_tip: 'The consumption supplement amount {{fee}} yuan',
  start_now: 'Start now',
  end_now: 'End now',
  n_stations: '{{n}} stations',
  station_service_fee_not_found: 'Station service fee not found',
  create_service_fee: 'Creation service fee',
  confirm_service_fee_clash: 'Confirm the conflict station service fee',
  service_fee_clash_tip:
    'Please confirm the service charge per table. There can only be one per-person charge per table at the same time',
  check_stations_tip: 'Select the location where the {{name}} solution is to be applied',
  selected_stations_tip: '({{len1}} selected) There are {{len2}} stations in total',
  pay_by_meal_people: 'Charge according to the number of diners',
  pay_by_table: 'Charge per table',
  pay_by_consume_amount: 'Charge according to the amount spent',
  pay_by_open_table_time: 'Charge according to opening time',
  pay_by_consume_align: 'Charges are made up according to consumption',
  each_yuan_person: 'yuan/person',
  each_yuan_table: 'yuan/table',
  rate_by_after_discount: 'Product price after discount * ratio',
  rate_by_total_meal_price: 'Total menu price * ratio',
  open_table: 'opening table',
  enter_number: 'Please enter the number',
  service_fee_1: 'Service charge',
  over_each: 'More than per',
  extra_pay: 'charge additional',
  consume_align: 'Consumption-replenishment amount',
  service_fee_name: 'Service charge name',
  enter_service_fee_name: 'Please enter the service charge name',
  service_fee_method: 'Service charge plan',
  enter_service_fee_method: 'Please enter service fee plan',
  modify_service_fee: 'Change the amount of service charge',
  not_in_service_products: 'Goods not included in service charge',
  business_refund_money: 'Business refund',
  product_state: 'On/Off Shelf status',
  store_created_successfully: 'Branch created successfully',
  store_created_successfully_will_jump_to_the_payment_page:
    'The branch has been successfully created and will now be redirected to the payment page',
  kit_items: 'Kit items',
  del_request_kit_items_with_no: 'Delete kit items archive [{{id}}]',
  edit_kit_with_name: 'Edit suite project {{name}}',
  create_kit_with_name: 'Create kit item {{name}}',
  business_param: 'Business param',
  complex_mode: 'Complex mode',
  making_meal: 'Making meal',
  making_m: 'Making',
  repayment_receipts: 'Repayment receipts',
  order_del_aduit_confirm_is:
    'Mainly supports deleting documents to be reviewed and confirms that the selected documents need to be deleted.?',
  new_arrival: 'New product launch',
  hot_sale: 'Hot selling item',
  recommended_by_shopkeeper: 'Store recommendation',
  seasonal_selection: 'Seasonal selection',
  recommended_by_store_manager: 'Recommended by store manager',
  recommended_copy: 'Hot selling and sweet arrival',
  cure: 'baking',
  dress: 'clothing',
  kit_sale_count: 'Kit sales statistics',
  kit_inner_product_title: 'Title of product in kit',
  kit_dimension: 'Kit dimension',
  belong_kit: 'Belong kit',
  closed_shop: 'Shop closed',
  open_shop: 'Shop opening',
  one_click_expand: 'Expand link product',
  change_product_sort_type: 'Change product sorting method',
  click_edit_custom_page_odule: 'Click to edit the "Custom Page Module"',
  del_purchase_template_with_no: 'Delete purchase template [{{id}}]',
  oms_jd: 'Jingdong Instant Transmission',
  business_infomation_2: 'Business information',
  wx_pa: 'H5',
  sell_mode_tips: 'If {{name}} is set to Yes, the sales mode cannot be empty',
  template_scope: '模板范围',
  product_export1: 'Export of goods',
  order_archived_successfully1: 'The order was cancelled successfully',
  order_unarchived_successfully1: 'The order was cancelled successfully',
  pos_applet_product_list: 'POS product list',
  abnormal_commodity: 'Abnormal commodity',
  auto_store_receive_by_supplier_in_hours:
    'Supplier assistant order delivery completed, automatic generation of receipt',
  auto_store_receive_by_supplier_in_hours_tip: 'Note: 0 or empty means no automatic audit',
  matching_mode: 'Matching mode',
  summary_by_location_store_type: 'Summary by Store Warehouse Items',
  deduction_type: 'Deduction type',
  customer_consume_pos: 'Customer consumption (POS manual adjustment)',
  coupon_verification_certificate: 'Voucher verification certificate',
  handover_petty_cash: 'Handover petty cash',
  target_device: 'Target device',
  choose_device: 'Choose device',
  business: 'Business',
  mall: 'Mall',
  sales: 'Sales',
  member: 'Member',
  financial: 'Financial',
  operation: 'Operation',
  service_fee_statistics: 'Service fee statistics',
  card_asset: 'Card asset',
  member_operation: 'Member operation',
  financial_audit: 'Financial audit',
  operating_analysis: 'Operating analysis',
  online_store: 'Online store',
  product_kits: 'Product kits',
  other_sales: 'Other sales',
  reconciliation: 'Reconciliation',
  cancel_stock_transfer_with_order_no: 'Void inventory transfer order [{{orderNo}}]',
  product_unit: 'Product unit',
  batch_confirmation_successful: 'Batch confirmation of successful receipt of goods',
  batch_confirmation_fail: 'Batch confirmation of receipt failed',
  batch_confirmation_goods: 'Batch confirmation of receipt of goods',
  submit_qualifications: 'Submit qualifications',
  dine_in_ordering_page: 'Dine-in ordering page',
  failed_result: 'Failed',
  anti_audit_confirm_is_with_order_no:
    'After anti-audit, it cannot be recovered. Confirm the anti-audit order [{{orderNo}}]?',
  anti_audit_transfer_out_order_with_order_no: 'Anti-audit transfer out order [{{orderNo}}]',
  anti_audit_return_order_with_order_no: 'Anti-audit return order [{{orderNo}}]',
  restaurant: 'Restaurant',
  anti_audit_purchase_receive_order_with_order_no:
    'Anti-audit purchase receipt order [{{orderNo}}]',
  batch_delete_location_product: 'Batch delete location product',
  sub_merchant: 'Sub merchant',
  set_sub_merchant: 'Set sub merchant',
  all_sub_merchant_group: 'All sub merchant group',
  select_sub_merchant: 'Select sub merchant',
  anti_audit_produce_material_order_with_order_no:
    'Anti-audit production material order [{{orderNo}}]',
  anti_audit_location_process_order_with_order_no:
    'Anti-audit location process order [{{orderNo}}]',
  anti_audit_produce_storage_order_with_order_no:
    'Anti-audit production storage order [{{orderNo}}]',
  item_corner_label: 'Item corner label',
  search_item_corner_label_name: 'Search item corner label name',
  create_item_corner_label: 'Create item corner label',
  item_corner_label_name: 'Item corner label name',
  item_corner_label_del_tip:
    'Are you sure you want to delete the corner label [{{name}}], it cannot be recovered after deletion',
  del_item_corner_label: 'Delete item corner label [{{name}}]',
  cannot_be_restored_after_deletion: 'Cannot be restored after deletion',
  please_select_item_corner_label: 'Please select item corner label',
  corner_label_name: 'Corner label name',
  please_enter_corner_label_name: 'Please enter corner label name',
  corner_label_type: 'Corner label type',
  please_enter_term_of_validity: 'Please enter term of validity',
  corner_label_setting: 'Corner label setting',
  validity_period_of_corner_marker: 'Validity period of corner marker',
  issued1: 'Issued',
  cancel_distribution: 'Cancel distribution',
  specific_practices: 'Specific practices',
  ic_card_key_configuration: 'IC card key configuration',
  choose_financial_entity: 'Choose financial entity',
  batch_back_success: 'Batch back success',
  batch_back_fail: 'Batch back fail',
};
